import * as React from "react";
const BirthdayWebsiteSVG = (props) => (
  <svg
    className="animated"
    id="freepik_stories-happy-birthday"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    xmlnsXlink="http://www.w3.org/1999/xlink"
 
    {...props}
  >
    <style>
      {
        "svg#freepik_stories-happy-birthday:not(.animated) .animable {opacity: 0;}svg#freepik_stories-happy-birthday.animated #freepik--background-complete--inject-25 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-happy-birthday.animated #freepik--Shadow--inject-25 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-happy-birthday.animated #freepik--Table--inject-25 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-happy-birthday.animated #freepik--Balloons--inject-25 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-happy-birthday.animated #freepik--character-3--inject-25 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-happy-birthday.animated #freepik--character-2--inject-25 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-happy-birthday.animated #freepik--character-1--inject-25 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-happy-birthday.animated #freepik--Cake--inject-25 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut,1.5s Infinite  linear floating;animation-delay: 0s,1s;}            @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        "
      }
    </style>
    <g
      id="freepik--background-complete--inject-25"
      className="animable animator-active"
      style={{
        transformOrigin: "248.178px 202.482px",
      }}
    >
      <path
        d="M57,66.58l13.12-.28,6.66-.11c2.23,0,4.47,0,6.7,0H84v.45L84,77.77v.5h-.5l-13.24-.06c-4.42,0-8.83-.11-13.24-.16h-.28v-.27c0-1.9.09-3.78.13-5.65Zm0,0,.14,5.66c0,1.86.11,3.7.13,5.53L57,77.5c4.41,0,8.82-.16,13.24-.16l13.24-.07-.5.5,0-11.19.45.45C81.34,67,79.16,67,77,67l-6.58-.11Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "70.37px 72.23px",
        }}
        id="ely6px0autg3b"
        className="animable"
      />
      <path
        d="M71.81,52.47l13.12-.28,6.66-.11c2.23,0,4.47,0,6.7,0h.44v.45l.06,11.19v.5h-.5L85.05,64.1c-4.42,0-8.83-.11-13.24-.16h-.28v-.27c0-1.9.08-3.78.13-5.65Zm0,0L72,58.13c0,1.86.11,3.7.13,5.53l-.27-.27c4.41,0,8.82-.16,13.24-.16l13.24-.07-.5.5,0-11.19.45.45c-2.18,0-4.36,0-6.55-.06l-6.58-.11Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "85.16px 58.15px",
        }}
        id="elrde8zi44hx"
        className="animable"
      />
      <path
        d="M140,183.25l13.13-.28,6.66-.11c2.22-.05,4.46,0,6.69-.06h.44v.45l.05,11.19v.5h-.5l-13.24-.07c-4.41,0-8.83-.11-13.24-.16h-.27v-.27c0-1.9.08-3.79.13-5.66Zm0,0,.14,5.65c.05,1.86.11,3.71.13,5.54l-.27-.28c4.41,0,8.83-.16,13.24-.16l13.24-.06-.5.5.06-11.19.44.44c-2.18,0-4.36,0-6.54-.05l-6.58-.11Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "153.345px 188.87px",
        }}
        id="elvexpb3d6m7s"
        className="animable"
      />
      <path
        d="M154.79,169.14l13.13-.28,6.66-.11c2.22-.05,4.46,0,6.69-.06h.45v.45l.05,11.19v.5h-.5L168,180.76c-4.41,0-8.82-.11-13.24-.16h-.27v-.27c0-1.9.09-3.79.13-5.66Zm0,0,.14,5.65c0,1.86.12,3.71.14,5.54l-.28-.28c4.42-.05,8.83-.15,13.24-.16l13.24-.06-.5.5.06-11.19.44.44c-2.18,0-4.36,0-6.54-.05l-6.58-.11Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "168.13px 174.76px",
        }}
        id="eljfoj9gy3zqf"
        className="animable"
      />
      <path
        d="M42.26,52.47l13.13-.28,6.66-.11c2.23,0,4.46,0,6.69,0h.45v.45l0,11.19v.5h-.51L55.5,64.1c-4.41,0-8.82-.11-13.24-.16H42v-.27c0-1.9.09-3.78.13-5.65Zm0,0,.15,5.66c0,1.86.11,3.7.13,5.53l-.28-.27c4.42,0,8.83-.16,13.24-.16l13.24-.07-.49.5,0-11.19.44.45c-2.18,0-4.35,0-6.54-.06l-6.58-.11Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "55.595px 58.15px",
        }}
        id="el1dxq2dxzz9w"
        className="animable"
      />
      <path
        d="M328.06,237.56l-13.12.28-6.67.11c-2.22.05-4.46,0-6.69.05h-.44v-.45l-.05-11.19v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.17l-13.24.06.5-.5L302,237.56l-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "314.72px 231.93px",
        }}
        id="elznssnylmyd8"
        className="animable"
      />
      <path
        d="M443,295.5l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05H416v-.44L416,284.31v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.19,0,4.36,0,6.55.05l6.58.12Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "429.63px 289.87px",
        }}
        id="el25637303rp8"
        className="animable"
      />
      <path
        d="M457.74,309.61l-13.13.27L438,310c-2.23,0-4.46,0-6.7.05h-.44v-.44l-.05-11.19v-.51h.5l13.25.06c4.41,0,8.82.11,13.24.16H458v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.15-5.66c0-1.86-.11-3.7-.13-5.53l.28.27c-4.42.05-8.83.16-13.24.16l-13.25.06.5-.49-.05,11.19-.45-.45c2.19,0,4.36,0,6.55,0l6.58.12Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "444.405px 303.98px",
        }}
        id="elk9ucibwaitf"
        className="animable"
      />
      <path
        d="M83.74,309.61l-13.12.27L64,310c-2.23,0-4.47,0-6.7.05h-.44v-.44l-.06-11.19v-.51h.5L70.5,298c4.42,0,8.83.11,13.24.16H84v.27c0,1.89-.09,3.78-.13,5.65Zm0,0L83.6,304c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.49,0,11.19-.45-.45c2.18,0,4.36,0,6.55,0l6.58.12Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "70.4px 303.98px",
        }}
        id="ely6viouknzf"
        className="animable"
      />
      <path
        d="M416.37,52.47l13.12-.28,6.67-.11c2.22,0,4.46,0,6.69,0h.44v.45l.05,11.19v.5h-.5l-13.24-.06c-4.41,0-8.83-.11-13.24-.16h-.28v-.27c0-1.9.08-3.78.13-5.65Zm0,0,.14,5.66c.05,1.86.11,3.7.13,5.53l-.27-.27c4.41,0,8.83-.16,13.24-.16l13.24-.07-.5.5.06-11.19.44.45c-2.18,0-4.36,0-6.55-.06l-6.57-.11Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "429.71px 58.15px",
        }}
        id="elrguxd9t5mf"
        className="animable"
      />
      <path
        d="M416.16,274.65a83,83,0,0,1-8.89-22.27c-1.88-8.17-2-16.5-1.4-24.83.71-10.55,1.88-21.09,2.8-31.63,0-.17.27-.12.26,0-.71,9.11-1.42,18.21-2,27.32-.58,8.48-.95,17,.54,25.44,2.95,16.66,12,31.54,22.8,44.32,6.69,7.95,14.14,15.26,21.56,22.51.08.08,0,.22-.1.14C438.41,303.43,425.15,290.51,416.16,274.65Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "428.706px 255.742px",
        }}
        id="elpzlgakx05p"
        className="animable"
      />
      <path
        d="M410.78,193.78s3.14,7.74,2.75,8.21-10.6,1.32-10.85.91.91-8.52.91-8.52Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "408.104px 198.394px",
        }}
        id="el59dmw7akvsl"
        className="animable"
      />
      <path
        d="M402.08,130.67c17.3-1.46,32.49,11.22,33.3,32.42s-18.25,31.88-27,32.62c-6.28.53-31.7-2.53-33.94-29.12C372.57,143.86,384.84,132.12,402.08,130.67Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "404.828px 163.159px",
        }}
        id="elvlgpk7ihgpa"
        className="animable"
      />
      <g id="eljug56pr15fd">
        <path
          d="M381.73,163.51a19.22,19.22,0,1,0,5.14-26.7A19.22,19.22,0,0,0,381.73,163.51Z"
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.2,
            transformOrigin: "397.641px 152.728px",
          }}
          className="animable"
          id="ela9qlvmp07tk"
        />
      </g>
      <g id="elian8ciowu8">
        <circle
          cx={394.58}
          cy={148.19}
          r={11.5}
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.4,
            transformOrigin: "394.58px 148.19px",
            transform: "rotate(-67.8deg)",
          }}
          className="animable"
          id="elikdwozyx1e"
        />
      </g>
      <path
        d="M422,316.84c-4.41-13.33-3-26.94-.16-40.44a127.14,127.14,0,0,1,7-23.17c.07-.17.32,0,.25.12a119.1,119.1,0,0,0-6,20.74,138.36,138.36,0,0,0-3.05,20.73c-.73,13.77,3.55,26.66,10.27,38.53,3.79,6.68,8.17,13,12.52,19.29a.15.15,0,0,1-.25.18C434.6,341.65,426.39,330,422,316.84Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "431.02px 303.021px",
        }}
        id="elb8q6923wae"
        className="animable"
      />
      <path
        d="M431.16,255.66s.63,8.33.11,8.65-10.5-2-10.61-2.44,3.46-7.84,3.46-7.84Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "426.067px 259.185px",
        }}
        id="eli6gp3waqju"
        className="animable"
      />
      <path
        d="M442.14,192.9c16.93,3.9,27.52,20.61,21.82,41s-27.12,24.79-35.63,22.83c-6.15-1.41-29.42-12.08-23.43-38.09C410,196.46,425.28,189,442.14,192.9Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "434.719px 224.533px",
        }}
        id="el9kxtpsafwm"
        className="animable"
      />
      <path
        d="M442.14,192.9c16.93,3.9,27.52,20.61,21.82,41s-27.12,24.79-35.63,22.83c-6.15-1.41-29.42-12.08-23.43-38.09C410,196.46,425.28,189,442.14,192.9Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "434.719px 224.533px",
        }}
        id="elvoe7rxhc2nt"
        className="animable"
      />
      <g id="elhfdkmmrvir">
        <path
          d="M413.53,225.66a19.22,19.22,0,1,0,5.14-26.7A19.22,19.22,0,0,0,413.53,225.66Z"
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.2,
            transformOrigin: "429.441px 214.878px",
          }}
          className="animable"
          id="el44jq3kxdqa7"
        />
      </g>
      <g id="elxff0ynbnfnh">
        <path
          d="M416.85,216.79a11.5,11.5,0,1,0,3.08-16A11.5,11.5,0,0,0,416.85,216.79Z"
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.4,
            transformOrigin: "426.36px 210.324px",
          }}
          className="animable"
          id="elpyspuhlfoxr"
        />
      </g>
      <path
        d="M80.7,243.92a83.07,83.07,0,0,0,7.91-22.63c1.51-8.25,1.23-16.58.3-24.87-1.18-10.52-2.8-21-4.19-31.48,0-.17-.27-.11-.25.05,1.1,9.07,2.21,18.13,3.23,27.2,1,8.45,1.7,17,.58,25.44-2.21,16.78-10.64,32-20.83,45.28C61.12,271.15,54,278.78,46.9,286.35c-.07.08,0,.21.12.13C59.74,273.65,72.42,260.16,80.7,243.92Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "68.2736px 225.671px",
        }}
        id="elqopt53466k"
        className="animable"
      />
      <path
        d="M81.21,164.19s-.92,8.3-.42,8.64,10.57-1.59,10.7-2.06-3.18-8-3.18-8Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "86.0674px 167.82px",
        }}
        id="eluz5jrfjxo4r"
        className="animable"
      />
      <path
        d="M72.49,101.08c-17,3.28-28.23,19.61-23.27,40.23S75.43,167.06,84,165.4c6.19-1.19,29.83-11,24.78-37.22C104.47,105.78,89.48,97.8,72.49,101.08Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "78.7609px 133.031px",
        }}
        id="elbmwoyx37wvm"
        className="animable"
      />
      <g id="eli3rrx9o700n">
        <path
          d="M55.84,134.47a19.23,19.23,0,1,0,5.95-26.53A19.23,19.23,0,0,0,55.84,134.47Z"
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.2,
            transformOrigin: "72.0861px 124.181px",
          }}
          className="animable"
          id="elmgcdtp61x"
        />
      </g>
      <g id="elc7148x7qq79">
        <path
          d="M59.44,125.7A11.5,11.5,0,1,0,63,109.84,11.49,11.49,0,0,0,59.44,125.7Z"
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.4,
            transformOrigin: "69.1567px 119.552px",
          }}
          className="animable"
          id="el1lpk6vne9f6"
        />
      </g>
      <path
        d="M70,297.33c5.54-12.91,5.32-26.58,3.61-40.28a126.68,126.68,0,0,0-5-23.68c0-.18-.32-.08-.26.1a119.1,119.1,0,0,1,4.19,21.17,140.76,140.76,0,0,1,1.28,20.92c-.45,13.78-5.82,26.25-13.52,37.51-4.34,6.34-9.24,12.24-14.12,18.16-.13.15.11.35.24.2C55.33,321,64.5,310.1,70,297.33Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "60.4113px 282.379px",
        }}
        id="elicuau4xa3u"
        className="animable"
      />
      <path
        d="M66.07,235.59s-1.33,8.25-.84,8.62,10.62-1.08,10.78-1.53-2.79-8.1-2.79-8.1Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "70.5689px 239.425px",
        }}
        id="eleteunhb2nk"
        className="animable"
      />
      <path
        d="M60.47,172.13c-17.19,2.44-29.17,18.2-25.23,39s24.92,27,33.56,25.78c6.25-.89,30.34-9.54,26.59-36C92.18,178.41,77.6,169.7,60.47,172.13Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "65.1355px 204.396px",
        }}
        id="elg3b1pje77f"
        className="animable"
      />
      <g id="elsss2nqdltw">
        <circle
          cx={57.89}
          cy={195.75}
          r={19.23}
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.2,
            transformOrigin: "57.89px 195.75px",
            transform: "rotate(-39.03deg)",
          }}
          className="animable"
          id="elvn9yekpqh5r"
        />
      </g>
      <g id="el5roraurwrp4">
        <path
          d="M45.15,195.64a11.5,11.5,0,1,0,5.57-15.28A11.5,11.5,0,0,0,45.15,195.64Z"
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.4,
            transformOrigin: "55.5749px 190.785px",
          }}
          className="animable"
          id="el08dktuvm05n4"
        />
      </g>
    </g>
    <g
      id="freepik--Shadow--inject-25"
      className="animable"
      style={{
        transformOrigin: "250px 451.79px",
      }}
    >
      <ellipse
        cx={250}
        cy={451.79}
        rx={160.22}
        ry={17.18}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "250px 451.79px",
        }}
        id="elckt1fefdz2a"
        className="animable"
      />
    </g>
    <g
      id="freepik--Table--inject-25"
      className="animable"
      style={{
        transformOrigin: "250px 426.76px",
      }}
    >
      <polygon
        points="34.06 426.76 88.05 426.51 142.03 426.43 250 426.26 357.97 426.43 411.95 426.51 465.94 426.76 411.95 427 357.97 427.09 250 427.26 142.03 427.09 88.05 427 34.06 426.76"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "250px 426.76px",
        }}
        id="ele50ro0vvt1"
        className="animable"
      />
    </g>
    <g
      id="freepik--Balloons--inject-25"
      className="animable"
      style={{
        transformOrigin: "253.02px 93.0008px",
      }}
    >
      <path
        d="M133.2,33a234.31,234.31,0,0,0,27.88,10.89A291.7,291.7,0,0,0,190,51.71,263.52,263.52,0,0,0,249.31,58a296.78,296.78,0,0,0,59.3-7.1q14.63-3.16,28.93-7.66A292.64,292.64,0,0,0,365.65,33a292.83,292.83,0,0,1-28,10.79q-14.25,4.64-28.9,8T279.25,56.9A260.54,260.54,0,0,1,249.32,59a258.61,258.61,0,0,1-59.53-6.58,288.81,288.81,0,0,1-28.86-8.14A234.34,234.34,0,0,1,133.2,33Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "249.425px 46.0023px",
        }}
        id="elwg91fqgq2gj"
        className="animable"
      />
      <path
        d="M136.84,33a2.33,2.33,0,1,1-2.32-2.33A2.32,2.32,0,0,1,136.84,33Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "134.51px 33px",
        }}
        id="eloy4so05qevs"
        className="animable"
      />
      <path
        d="M367.81,33a2.33,2.33,0,1,1-2.33-2.33A2.32,2.32,0,0,1,367.81,33Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "365.48px 33px",
        }}
        id="el2mdnt76sg8x"
        className="animable"
      />
      <path
        d="M105.74,70.46a158.57,158.57,0,0,0,16.43,10.29q8.49,4.69,17.34,8.67a258.06,258.06,0,0,0,36.38,13.26,255.59,255.59,0,0,0,76.62,9.42,312.89,312.89,0,0,0,76.39-11.86A321.88,321.88,0,0,0,365.49,87.5a300.6,300.6,0,0,0,34.82-17A301.81,301.81,0,0,1,365.69,88a324.51,324.51,0,0,1-36.61,12.93,311.6,311.6,0,0,1-76.55,12.19,256.63,256.63,0,0,1-76.82-9.77,254.64,254.64,0,0,1-36.4-13.46q-8.81-4.08-17.26-8.89A161.09,161.09,0,0,1,105.74,70.46Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "253.025px 91.83px",
        }}
        id="elynqqbso0dw"
        className="animable"
      />
      <path
        d="M402.64,70.46a2.33,2.33,0,1,1-2.33-2.32A2.33,2.33,0,0,1,402.64,70.46Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "400.31px 70.47px",
        }}
        id="elhjmo6u8nxqt"
        className="animable"
      />
      <path
        d="M108.06,70.46a2.33,2.33,0,1,1-2.32-2.32A2.32,2.32,0,0,1,108.06,70.46Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "105.73px 70.47px",
        }}
        id="el7plqq8hnunh"
        className="animable"
      />
      <path
        d="M197.68,50.49a6,6,0,0,0-1-2.33,4.93,4.93,0,0,0-.84-.91,5.5,5.5,0,0,0-1-.68,6.65,6.65,0,0,0-2.67-1,4.66,4.66,0,0,0-2.43.25,6,6,0,0,0-2,1.28A10,10,0,0,0,186.21,49a16.25,16.25,0,0,0-1.13,2.19c-.27.61-.6,1.44-1,2.48S183.36,55.83,183,57s-.69,2.24-1,3.31-.54,1.94-.74,2.61q-1.31-.24-2.28-.33l-1.9-.14c-.61,0-1.24-.12-1.9-.22a15.86,15.86,0,0,1-2.2-.51c.1-.34.26-.87.5-1.58s.48-1.48.75-2.3.51-1.59.75-2.31.42-1.23.56-1.56l.82-2.28c.27-.77.56-1.53.87-2.27.16-.37.3-.74.44-1.11s.25-.76.37-1.14.18-.67.26-1a4.05,4.05,0,0,0,.07-1.06,6.81,6.81,0,0,0-.39-1.63,3.34,3.34,0,0,0-1-1.4,3.6,3.6,0,0,0-1.4-.76A10,10,0,0,0,174,41a5,5,0,0,0-.84,0,.29.29,0,0,0-.21,0,11.25,11.25,0,0,0-3.06.62,11,11,0,0,0-2.73,1.4,6.42,6.42,0,0,0-1.39,1.32c-.41.53-.81,1-1.19,1.59a19.68,19.68,0,0,0-1.19,2.27q-.53,1.15-1,2.4A36.26,36.26,0,0,0,161,55.88q-.51,2.65-.89,5.37c-.24,1.59-.49,3.17-.74,4.73a30.7,30.7,0,0,1-1.13,4.61l-1.13,3.85a19.66,19.66,0,0,0-.76,4,10.11,10.11,0,0,0,.39,3.71,5.93,5.93,0,0,0,2.11,3,5.46,5.46,0,0,0,1.75,1,3.64,3.64,0,0,0,2,.08,4.62,4.62,0,0,0,1.78-1.1,13.73,13.73,0,0,0,1.36-1.57,14.28,14.28,0,0,0,1.41-2.42c.39-.85.76-1.71,1.1-2.58.57-1.44,1.07-2.91,1.51-4.39s.84-3,1.19-4.49a10.7,10.7,0,0,1,1.68.5l2.13.76c.73.27,1.4.52,2,.77a14.36,14.36,0,0,0,1.43.53c-.16,1-.28,2-.37,3s-.18,2-.26,3.07l-.09,2.18c0,.73,0,1.47,0,2.21a18.07,18.07,0,0,0,.55,3.76c.18.65.36,1.27.56,1.85a8.17,8.17,0,0,0,.8,1.73,11.63,11.63,0,0,0,1,1.32,3.74,3.74,0,0,0,1.26,1,2.69,2.69,0,0,0,1.93.26,4.44,4.44,0,0,0,1.79-.89,9.14,9.14,0,0,0,1.48-1.5,12.37,12.37,0,0,0,1.09-1.61,16.06,16.06,0,0,0,1.22-2.71,22.75,22.75,0,0,0,.78-2.85c.19-.82.36-1.63.51-2.44a23.78,23.78,0,0,1,.58-2.43c.25-.84.51-1.66.79-2.46s.57-1.6.86-2.44c.41-1.08.81-2.17,1.18-3.28l1.12-3.3c.44-1.21.83-2.4,1.15-3.57s.62-2.36.89-3.57.51-2.21.69-3.29A21,21,0,0,0,197.9,53,12.76,12.76,0,0,0,197.68,50.49Z"
        style={{
          fill: "#213E60",
          transformOrigin: "177.11px 66.8376px",
        }}
        id="elqnaufithu8"
        className="animable"
      />
      <path
        d="M173.18,55.51c-.63,1.48-1.23,2.94-1.8,4.44-.28.71-.65,1.42-1,2.1s-.52,1.43-1.08,1.77a.48.48,0,0,0,0,.76.86.86,0,0,1,.24.31.11.11,0,0,0,0,0c0,.17,0,.35-.05.52a.38.38,0,0,1-.17.06.6.6,0,0,0-.47.82,4.35,4.35,0,0,1-1.37-.28.15.15,0,0,0-.13.28A2,2,0,0,1,168.48,68l-.24.32a.67.67,0,0,0-.09.53L168,69a5.12,5.12,0,0,1-.56,0,.39.39,0,0,0-.39.31l-.59-.13a5.37,5.37,0,0,0-1.05-.26.13.13,0,0,0-.07.24h0c.49.15,1,.27,1.46.45l.26.11a.41.41,0,0,0,.21.2c1.41.65.51,2.68.47,3.79,0,.09.1.12.15,0,.46-.82,1.23-1.89,1.17-2.89a2.13,2.13,0,0,0-.19-.77l.13,0a.64.64,0,0,0,.73-.69,1.67,1.67,0,0,0-.25-.77c.12-.14.25-.27.36-.41a.69.69,0,0,0,.05-.72,1.11,1.11,0,0,0,.39-.58,1.2,1.2,0,0,0-.07-.77,1.52,1.52,0,0,0,.1-2.08,2.92,2.92,0,0,0,.55-1c.24-.79.41-1.61.61-2.41s.59-1.75.9-2.61.53-1.73.8-2.6C173.25,55.5,173.19,55.47,173.18,55.51Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "169.245px 64.5996px",
        }}
        id="eljy6i6ugih6s"
        className="animable"
      />
      <path
        d="M193.48,67c-.75,1.45-1.43,3-2.23,4.38a8.91,8.91,0,0,0-1.09,2,4.21,4.21,0,0,1-.15.85,1.63,1.63,0,0,1-.68.74.53.53,0,0,0-.22.51l0,.28a1,1,0,0,0-.39.64l-.12,0a.6.6,0,0,0-.41,1,2,2,0,0,1,.16.24l-.58.2a.6.6,0,0,0-.34.37,1.48,1.48,0,0,1-.47.12,3.1,3.1,0,0,1-1.52-.42c-.1-.05-.2.11-.11.17l.87.56.36.22c.11.07.34.15.36.29s-.29.44-.37.63a.5.5,0,0,0,0,.34,4.8,4.8,0,0,1-1.87-.24c-.38-.2-.77-.38-1.16-.56a.07.07,0,0,0-.06.13,20.05,20.05,0,0,1,2,1.35c.17.13.35.25.54.38a.63.63,0,0,0,.11.13l.32.25a.64.64,0,0,0-.16.59.67.67,0,0,0-.19,1.12c.09.1.17.21.25.31-.23.05-.45.12-.69.16a.7.7,0,0,0-.48,1.1,4.7,4.7,0,0,1,.46.7l-.22.08a.81.81,0,0,0-.47.71h-.35c-.81,0-.85,1.17-.23,1.47.35.17-.67,1.37-.79,1.5a2.41,2.41,0,0,1-2.15.76.08.08,0,0,0,0,.15,3.37,3.37,0,0,0,3.46-.39,3.23,3.23,0,0,0,1.06-2c.18,0,.36,0,.55,0a.77.77,0,0,0,.54-1.19.76.76,0,0,0,.39-1,6.9,6.9,0,0,0-.47-.85l.55-.12a.68.68,0,0,0,.55-.92,4.27,4.27,0,0,0-.24-.53.65.65,0,0,0,.36-1,.61.61,0,0,0,.18-.89c.58,0,.6-.9.13-1.13h0l.48-.24a.6.6,0,0,0,.33-.77l-.28-.5c.17-.06.33-.13.5-.18a.62.62,0,0,0,.38-.63,2.94,2.94,0,0,0-.17-.57l.13-.07a.56.56,0,0,0,.21-.63.52.52,0,0,0,.41-.59l-.09-.4a2.33,2.33,0,0,0,.75-1.2c.08-.33,0-.66.07-1s.37-.79.48-1.18c.52-1.79,1.32-3.51,2-5.25A.06.06,0,0,0,193.48,67Zm-6.25,12.52a.28.28,0,0,0,.07-.09.48.48,0,0,0-.05-.62,2.09,2.09,0,0,0-.66-.39l.22,0a1.82,1.82,0,0,0,.57-.07l.06,0a.5.5,0,0,0,0,.27c0,.08.09.15.14.23a.5.5,0,0,0-.1.14c0,.1.11.21.18.11s0,0,0-.06l.1.17C187.63,79.36,187.43,79.47,187.23,79.56Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "187.514px 78.7061px",
        }}
        id="eldz4t3yne6ru"
        className="animable"
      />
      <g id="el4ik0z3368pq">
        <path
          d="M159.26,83a.52.52,0,0,0,0-.56l-.21-.34s0,0,0-.07h0v0a.49.49,0,0,0,0-.24h.06a.59.59,0,0,0,.52-.65,1.6,1.6,0,0,0-.64-1,.93.93,0,0,0-.14-.14h0a1.46,1.46,0,0,0,.17-.51.83.83,0,0,0-.22-.62.79.79,0,0,1-.16-.7c.09-.61.14-1.21.21-1.82a.23.23,0,0,0-.46-.08c-.17.62-.33,1.27-.53,1.88a1.84,1.84,0,0,0-.18.8,1.26,1.26,0,0,0,.13.37l.06.09a3.06,3.06,0,0,0-.21.51,1,1,0,0,0,.11.6,1.59,1.59,0,0,0,.36.45c-.07,0-.15.08-.22.14a.6.6,0,0,0-.19.69,1.11,1.11,0,0,0,.15.31,2.82,2.82,0,0,0,.6,1,.52.52,0,0,0,.47.2h0a6.82,6.82,0,0,0,.84,1c.06,0,.14,0,.12-.09A6.91,6.91,0,0,0,159.26,83Z"
          style={{
            opacity: 0.2,
            transformOrigin: "158.777px 80.1933px",
          }}
          className="animable"
          id="elp0moc8dnl7"
        />
      </g>
      <g id="el08jyyg5vhyd4">
        <path
          d="M177.39,70.76a8,8,0,0,0-1.53-.73c-.23-.09-.37-.3-.6-.36s-.24,0-.35,0a1.12,1.12,0,0,1-.28-.16,1.3,1.3,0,0,0-.54-.23c-.09,0-.27,0-.34,0s-.14-.15-.2-.19a.91.91,0,0,0-.72-.08,1.47,1.47,0,0,0-.3.08c-.13,0-.18.18-.32,0s-.15,0-.11.11a1.25,1.25,0,0,0,.39.37c.21.11.45,0,.67,0,.05,0,0,0,.08,0a1.54,1.54,0,0,1,.12.13.61.61,0,0,0,.37.1,2.06,2.06,0,0,0,.35-.12.32.32,0,0,1,.26.1,1.54,1.54,0,0,0,.57.29.43.43,0,0,1,.32.14.64.64,0,0,0,.28.18,6.12,6.12,0,0,0,.86.1,5.37,5.37,0,0,1,1,.23S177.43,70.78,177.39,70.76Z"
          style={{
            opacity: 0.2,
            transformOrigin: "174.742px 69.8669px",
          }}
          className="animable"
          id="eljofzedin5pe"
        />
      </g>
      <g id="eloiwqvwsrxs">
        <path
          d="M180.36,63.82s0,0,0,0a.61.61,0,0,0,0-.13,1.24,1.24,0,0,0-.1-.2.65.65,0,0,0-.42-.26.55.55,0,0,0-.53.27h-.07l-.23.07a1.27,1.27,0,0,1-.34,0c-.09,0-.12.11,0,.15l.33.14a.66.66,0,0,0,.22.15,1,1,0,0,0,.35.12.36.36,0,0,0,.26-.1l0,0a1.76,1.76,0,0,0,.23.14.27.27,0,0,0,.27-.05.27.27,0,0,0,.05-.27Z"
          style={{
            opacity: 0.2,
            transformOrigin: "179.494px 63.7068px",
          }}
          className="animable"
          id="ela39ohyfcyuh"
        />
      </g>
      <g id="elk552s9b79tk">
        <path
          d="M177.41,63.52c-.28-.18-.61-.07-.89-.2s-.2-.26-.34-.37a.55.55,0,0,0-.38-.06l-.19,0-.08,0,0-.06a.78.78,0,0,0-.12-.22.56.56,0,0,0-.54-.21,1.27,1.27,0,0,0-.18.06,1,1,0,0,0-.16-.14.88.88,0,0,0-.42-.09,1.17,1.17,0,0,0-.45.09l-.06-.06a.24.24,0,0,0-.32,0s0,0,0,0-.17,0-.19,0a.67.67,0,0,0-.07.24.07.07,0,0,0,.13,0l.09.11a2.29,2.29,0,0,1,.09.28.41.41,0,0,0,.32.25.86.86,0,0,0,.42,0h0a.44.44,0,0,0,.14.13.55.55,0,0,0,.48.1.83.83,0,0,0,.27-.17l.07.07a.52.52,0,0,0,.3.13.85.85,0,0,0,.49-.2c.06,0,.14-.11.22-.08s.13.14.19.18c.34.23.81,0,1.18.13C177.41,63.56,177.43,63.53,177.41,63.52Z"
          style={{
            opacity: 0.2,
            transformOrigin: "175.219px 62.8645px",
          }}
          className="animable"
          id="eluc2ij47b1fm"
        />
      </g>
      <g id="elhbl4l2kdp0s">
        <path
          d="M169.3,43.58A9.16,9.16,0,0,0,167.48,46c-.18.37-.22.78-.42,1.16s-.37.6-.55.9l.12.11.18.11h0c.22,0,.52,0,.55.29a.07.07,0,0,1-.1.07,2.28,2.28,0,0,1-.53-.24h-.08a1.06,1.06,0,0,1-.3-.1.26.26,0,0,0-.07.11,2.19,2.19,0,0,0-.29.47,1.27,1.27,0,0,0,.35.38s0,.11,0,.1h0a2.07,2.07,0,0,1,.42.14,3.73,3.73,0,0,1,.79.43c.13.1,0,.34-.14.26l-.73-.26c-.18-.06-.36-.13-.55-.18a1.21,1.21,0,0,1-.3.67c-.17.2-.67.38-.76.6s.14.87.14,1.16a1.9,1.9,0,0,1-.39,1,5.35,5.35,0,0,0-.58.68.57.57,0,0,1,.08.08,1.19,1.19,0,0,1,.29.48,1.09,1.09,0,0,1-.21,1c-.24.3-.65.39-.84.74a11.09,11.09,0,0,0-.4,1c-.42,1-.65,2.08-1,3.13,0,.09-.15,0-.15,0,.06-1.17.18-2.31.18-3.46,0-.64.19-1.78.87-2.08l0-.06a1.13,1.13,0,0,1-.23-.4,1.36,1.36,0,0,1,.06-1,4.48,4.48,0,0,1,.61-.82c.27-.35.21-.56.18-1a1.83,1.83,0,0,1,.27-1.2c.19-.28.56-.42.72-.68s0,0,0-.16a2.13,2.13,0,0,1-.07-.75,3.41,3.41,0,0,1,.54-1.29,6.09,6.09,0,0,1,.81-1.21,12.12,12.12,0,0,1,1.13-.82c.74-.59,1.42-1.31,2.21-1.86C169.27,43.46,169.35,43.53,169.3,43.58Z"
          style={{
            opacity: 0.2,
            transformOrigin: "165.663px 51.9091px",
          }}
          className="animable"
          id="elio89msv6kg"
        />
      </g>
      <g id="ely3y2q9g8hqk">
        <path
          d="M190.66,47.34c-1.08-.17-1.69,1-2.07,1.86s-.82,1.51-1.19,2.27c-.2.44,0,.61,0,1.05a1,1,0,0,1-.26.75,2.57,2.57,0,0,1-.29.28s-.12.12-.16.14a3.75,3.75,0,0,1,.1.39.88.88,0,0,1-.06.36.48.48,0,0,1-.12.22l.13.07a8.59,8.59,0,0,0,.87.4s0,.08,0,.06a3.74,3.74,0,0,1-.8-.35l-.09,0-.12-.07c-.24.31-.63.49-.76.89s-.11,1-.23,1.44a2.63,2.63,0,0,0,.7.28s0,.07,0,.07h-.82a1.64,1.64,0,0,1-.52.59l-.12.11a2.62,2.62,0,0,1,1.25.74h0c.05.06,0,.15-.1.09a3.19,3.19,0,0,0-.92-.51,1.1,1.1,0,0,0-.37-.06c0,.07,0,.17-.06.28-.06.26-.19.32-.37.46a1.79,1.79,0,0,0-.61,1.62c0,.1-.14.11-.16,0a3.2,3.2,0,0,1,.08-1.15,2.21,2.21,0,0,0,.21-1.1,1.11,1.11,0,0,1,.06-.82,6,6,0,0,0,.48-.81,18.06,18.06,0,0,1,.41-1.94,2.15,2.15,0,0,1,.63-.74c.08-.07.15-.16.18-.15a1.74,1.74,0,0,1-.11-.45,1,1,0,0,1,.39-.78c.09-.08.24-.14.31-.23s0-.31,0-.56a1.29,1.29,0,0,1,.29-.87q.45-.69.93-1.35a14.18,14.18,0,0,1,1.68-2,1.75,1.75,0,0,1,1.65-.58A.07.07,0,1,1,190.66,47.34Z"
          style={{
            opacity: 0.2,
            transformOrigin: "187.141px 54.0294px",
          }}
          className="animable"
          id="eldarq8quxipi"
        />
      </g>
      <path
        d="M234,75.17a45.58,45.58,0,0,0-.68-6.48A17.45,17.45,0,0,0,232,64.08c-.54-1-1.09-1.94-1.66-2.9a29.4,29.4,0,0,0-1.86-2.79,20,20,0,0,0-1.84-2.28,13.29,13.29,0,0,0-2.2-1.91,9,9,0,0,0-3.79-1.59,14.3,14.3,0,0,0-3.64-.24,10.36,10.36,0,0,0-3.68,1,37.2,37.2,0,0,0-3.35,1.84,33.53,33.53,0,0,0-2.75,2.2,16.5,16.5,0,0,0-2.38,2.63,17,17,0,0,0-1.36,2.25l-1.16,2.33a20.3,20.3,0,0,0-1.08,2.64L200.3,70a50.2,50.2,0,0,0-1.45,5.77q-.54,2.91-.92,5.87a39.4,39.4,0,0,0-.31,6.1,13,13,0,0,0,.55,3.77A17.37,17.37,0,0,0,199.44,95a11.93,11.93,0,0,0,2.05,3,7,7,0,0,0,2.32,1.7,3.09,3.09,0,0,0,2.73-.07A4.31,4.31,0,0,0,208,98.44,13.3,13.3,0,0,0,209,97a16.35,16.35,0,0,0,1.09-2.27,13.28,13.28,0,0,0,.7-2.44,21.26,21.26,0,0,0,.46-2.65,22.12,22.12,0,0,0,.13-2.69,25.52,25.52,0,0,0,4.16.28c1.38,0,2.76-.07,4.15-.18a4.7,4.7,0,0,0,0,.53,3.11,3.11,0,0,1,0,.53,42.24,42.24,0,0,0,.08,6.26c.1.86.24,1.7.42,2.54a9.19,9.19,0,0,0,.83,2.36,4.61,4.61,0,0,0,1.23,1.54,3.68,3.68,0,0,0,1.84.78,4.82,4.82,0,0,0,2.52-.32,8.33,8.33,0,0,0,2.14-1.28,10.68,10.68,0,0,0,2.6-4.08,33.8,33.8,0,0,0,1.75-6.14,56.68,56.68,0,0,0,.87-7.21C234.11,80,234.13,77.53,234,75.17Zm-13.18-2.64c0,.13,0,.39,0,.76s0,.78-.06,1.2-.07.81-.1,1.19-.06.62-.07.76a1.94,1.94,0,0,1,0,.66c-.48,0-.94,0-1.36,0l-1.36,0q-.93,0-1.89-.06t-1.89-.12c-.39-.08-.8-.14-1.21-.2a7.88,7.88,0,0,1-1.21-.27l0-.26a10.42,10.42,0,0,1,.2-1.22c.11-.5.23-1,.37-1.56s.26-1.07.39-1.57a4.62,4.62,0,0,1,.43-1.13,11.57,11.57,0,0,1,1.67-2.45,5.64,5.64,0,0,1,2.4-1.66,1.66,1.66,0,0,1,1.79.15,2.51,2.51,0,0,1,.88,1,8.31,8.31,0,0,1,.52,1.31,14.44,14.44,0,0,1,.41,2.23l.12,1Z"
        style={{
          fill: "#213E60",
          transformOrigin: "215.846px 76.9899px",
        }}
        id="el2gl67lpsk5"
        className="animable"
      />
      <path
        d="M210.33,82.47a1.16,1.16,0,0,0,.4-1,5.43,5.43,0,0,1-.15-1c0-.38.09-.76.13-1.13.17-1.24,0-2.49.13-3.74,0-.14-.23-.17-.25,0-.19,1-.47,1.93-.59,2.91a9.2,9.2,0,0,0,0,1.39,6.43,6.43,0,0,1-.22,1.54l-.62.55a.61.61,0,0,0-.14.59,5.34,5.34,0,0,0,.28.59l-.25.19a.64.64,0,0,0-.11,1c.16.13.11.09.12.36a3.51,3.51,0,0,1-.07.72c-.09.62-.19,1.26-.25,1.88a7.84,7.84,0,0,1-.2,2.11,7,7,0,0,1-.46.74c-.09.15-.29.37-.12.36a.78.78,0,0,0-.63,1.17l.11.21a4.06,4.06,0,0,1-.51.26.85.85,0,0,0-.47,1.24c.05.07.09.16.13.23-.15.08-.3.16-.46.23a.85.85,0,0,0-.29,1.13l-.11,0a.85.85,0,0,0-.47,1.24l.09.18a1.08,1.08,0,0,1-.2.16.69.69,0,0,0-.22,1c0,.07.06.13.1.19a2.88,2.88,0,0,1-2.26-.14c-.07,0-.16.06-.09.12a4.06,4.06,0,0,0,3.23.79c.3-.05.39-.4.34-.65,0-.08,0-.16,0-.24a2.81,2.81,0,0,0,.66-.46.75.75,0,0,0,.18-.78h0a2.24,2.24,0,0,0,.7-.51.88.88,0,0,0,.15-1l.09,0a.88.88,0,0,0,.49-1.29l-.13-.2a3.66,3.66,0,0,0,.8-.57.86.86,0,0,0,.11-1l-.27-.35a1.49,1.49,0,0,0,.23-.63,9.54,9.54,0,0,0-.11-1.21,4.68,4.68,0,0,1,.45-1.55,15.46,15.46,0,0,0,.8-2.75,2.26,2.26,0,0,0-.11-1.24l.25-.19a.65.65,0,0,0,.11-1A3.47,3.47,0,0,1,210.33,82.47Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "206.747px 87.0453px",
        }}
        id="el8041igxmuc6"
        className="animable"
      />
      <path
        d="M216.71,63.78c-.28,0-.33.27-.3.48a.52.52,0,0,1-.16.55c-.1.08-.27.2-.39.1a.21.21,0,0,0-.33,0,4.41,4.41,0,0,0-.3.74.44.44,0,0,1-.24-.13.39.39,0,0,0-.64.19.23.23,0,0,0,0,.11l-.13,0a.44.44,0,0,0-.29.54c0,.05,0,.07,0,0a.94.94,0,0,1,0,.09l0,.06c0,.06,0,0,0,0a.37.37,0,0,0-.45.35.64.64,0,0,1-.18.49,5.45,5.45,0,0,0-.87-.35.08.08,0,0,0-.05.15,5.28,5.28,0,0,1,.62.33,2,2,0,0,0-.31.12,2,2,0,0,0-.48-.33,1.76,1.76,0,0,1-.49-.49c-.35-.4-.7-.79-1.07-1.17a0,0,0,0,0,0,0,9,9,0,0,1,.68.85,2.89,2.89,0,0,1,.53.91,2.32,2.32,0,0,1,0,.37,2.42,2.42,0,0,0,.13.46,3.3,3.3,0,0,0,.31.69.16.16,0,0,1-.09.09.35.35,0,0,0-.23.43c.21.51-.16,1.22-.42,1.65a3.81,3.81,0,0,0-.62,1.32.08.08,0,1,0,.15,0A3.09,3.09,0,0,1,212,71a1.86,1.86,0,0,0,.54-1.26.85.85,0,0,0,.5-.56,1.14,1.14,0,0,0-.1-1,1.14,1.14,0,0,0,1.11-.85.91.91,0,0,0,.71-.71l0,0a.43.43,0,0,0,.27-.29,2.17,2.17,0,0,0,.36,0,.3.3,0,0,0,.29-.23,7.67,7.67,0,0,0,.15-.81.66.66,0,0,0,.52-.31.75.75,0,0,0,.1-.38c0-.21-.19-.79.19-.76A0,0,0,1,0,216.71,63.78Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "213.68px 68.1339px",
        }}
        id="elwc5quew7bw9"
        className="animable"
      />
      <g id="elanikwwx8pna">
        <path
          d="M219.4,85.39l-.31.24a1.23,1.23,0,0,0-1.08-.47.65.65,0,0,0-.31-.12.63.63,0,0,0-.51.23l0,0s0,0,0-.07a.15.15,0,0,0-.12-.11.65.65,0,0,0-.06-.21.08.08,0,0,0,0,0,2,2,0,0,1,.09-.54c.05-.36.1-.71.18-1.07a.13.13,0,0,0-.23-.09h0c-.14.3-.29.6-.44.9-.06.1-.11.21-.16.31a1.14,1.14,0,0,0-.87,0,1.59,1.59,0,0,0-.75,1,.75.75,0,0,0-.4-.07.87.87,0,0,0-.58.36c-.1-.13-.18-.27-.28-.4s-.17-.22-.32-.21a.37.37,0,0,0-.31.23c-.15.26-.26.57-.39.84,0,.1.09.17.14.08s.44-.85.55-.83.19.44.22.51a4.74,4.74,0,0,1,.15.5.34.34,0,0,0,.56.14l.21-.24s0,0,0,0a1,1,0,0,0,.62.61.57.57,0,0,0,.62-.27c.17-.28.29-.57.44-.86l0,0a.66.66,0,0,0,.37.13c0,.13-.06.26-.08.4a.09.09,0,0,0,.16.06c.12-.19.24-.38.35-.57a1,1,0,0,0,0,.25.33.33,0,0,0,.49.27.74.74,0,0,0,.25-.21l.05-.06a.38.38,0,0,0,.48-.07c.28-.27.59-.36.88,0a.12.12,0,0,0,.2,0c.1-.14.19-.29.29-.44S219.44,85.35,219.4,85.39Z"
          style={{
            opacity: 0.2,
            transformOrigin: "216.041px 85.0286px",
          }}
          className="animable"
          id="elgbgu95vdrti"
        />
      </g>
      <g id="elae6kc10on7">
        <path
          d="M227.84,96.86s0-.07-.05,0a.4.4,0,0,0-.2.36c0,.16.23,1-.09.88a.18.18,0,0,0-.23.18.31.31,0,0,1-.38.33.28.28,0,0,0-.33.35c-.07-.25-.48.17-.55.24a.69.69,0,0,1-.38.21.85.85,0,0,0-.47-.27.8.8,0,0,0-.55.07c-.07,0-.12.08-.18.11a.44.44,0,0,0-.34-.13c.12-.74.22-1.49.28-2.24,0-.11-.15-.11-.19,0a16.85,16.85,0,0,1-.74,2s0,0,0-.07a.6.6,0,0,0-.63-.59,5.15,5.15,0,0,1,0-1.36.57.57,0,0,0-.88-.61,3.4,3.4,0,0,0-.36-1.43,4.14,4.14,0,0,1-.44-2.63c0-.1-.13-.14-.15,0a7.05,7.05,0,0,0-.1,2.38A6.32,6.32,0,0,1,221,97a.51.51,0,0,0,.5.62,4.09,4.09,0,0,0,.2,1.63.66.66,0,0,0,.79.44.29.29,0,0,1,0,.1.4.4,0,0,0,.29.26.87.87,0,0,0,.72-.2c-.05.1-.09.21-.13.31s.07.47.31.39a1.47,1.47,0,0,0,.46-.3.7.7,0,0,0,.38.07,1,1,0,0,0,.33-.09l0,0a.46.46,0,0,0,.26.17,1.16,1.16,0,0,0,1.36-.65.75.75,0,0,1,.18-.3c.09-.07.19-.08.27-.15a.38.38,0,0,0,.11-.18.68.68,0,0,0,.6-.76C228.1,98.05,227.54,97.17,227.84,96.86Z"
          style={{
            opacity: 0.2,
            transformOrigin: "224.331px 96.3653px",
          }}
          className="animable"
          id="el639b3ivq0vt"
        />
      </g>
      <g id="el94ezia0m0pb">
        <path
          d="M200.31,79.48c.7,0,1.41.08,2.12.1.08,0,.11-.08.08-.14-.24-.48-.71-.48-1.18-.61a1.46,1.46,0,0,1-1.11-1.25,2,2,0,0,1,.47-1.41,6.37,6.37,0,0,0,.65-1.24,5.18,5.18,0,0,0,.2-1.3c.05-.43-.08-.86,0-1.28a6.15,6.15,0,0,1,.61-1.61,0,0,0,1,0-.07,0c-.33.49-.55,1-.86,1.52a5.13,5.13,0,0,0-.73,1.21,8.74,8.74,0,0,0-.14.87A2.8,2.8,0,0,1,200,75a2.54,2.54,0,0,0-.33,1.32,3.69,3.69,0,0,0,.65,2.09,1.63,1.63,0,0,0,.65.51c.32.14,1,.11,1.25.45-.73-.25-1.47-.5-2.21-.72a.43.43,0,0,0-.48.21,3.78,3.78,0,0,0-.28,2.18,1.45,1.45,0,0,1,0,.85,3.06,3.06,0,0,0-.35.88c-.27,1.54.32,3.1.26,4.66,0,.1.17.1.16,0a9.11,9.11,0,0,1,.16-2.5c.13-.65.12-1.31.25-2s.54-.85.5-1.44a6,6,0,0,1-.09-1.27A6.5,6.5,0,0,1,200.31,79.48Z"
          style={{
            opacity: 0.2,
            transformOrigin: "200.675px 79.1225px",
          }}
          className="animable"
          id="eluonoewayp8d"
        />
      </g>
      <path
        d="M232.35,72.14c-.15-.34-.72-1-.54-1.4a.6.6,0,0,0-.54-.88h-.06a2.73,2.73,0,0,0,0-2.17,2.7,2.7,0,0,1-.33-1.51c.05-.17.18-.34.17-.52a2.11,2.11,0,0,0-.18-.59,20.59,20.59,0,0,0-1.05-2.63,9.72,9.72,0,0,0-.63-1.14c-.22-.34-.47-.39-.75-.62a8.12,8.12,0,0,1-.69-.84c-.27-.3-.55-.57-.83-.86a7.83,7.83,0,0,1-1.25-2,2.83,2.83,0,0,0-1.12-1.32s-.07,0,0,.07A5.21,5.21,0,0,1,226,58.12a13.37,13.37,0,0,0,1.6,2.23,2.25,2.25,0,0,1,.38.6,4.64,4.64,0,0,1,0,.53,6.1,6.1,0,0,0,.55,1.39c.21.44.42.89.64,1.34a14.87,14.87,0,0,0,.87,1.44.72.72,0,0,0-.49-.1c-.43.07-.87.22-1.3.31a14.11,14.11,0,0,1-1.45.23c-.09,0-.09.15,0,.15a9.27,9.27,0,0,0,2.51-.46.87.87,0,0,1,.69,0,.72.72,0,0,1,.15.11,2.07,2.07,0,0,0,0,.35.77.77,0,0,0-.68-.27s0,0,0,0h-.11a.09.09,0,0,0,0,.16,2.79,2.79,0,0,1,1,1c.06.22.13.44.19.67,0,.06,0,.15,0,.26A2.91,2.91,0,0,1,228,70.29a.06.06,0,1,0,0,.12c.45,0,.89.06,1.34.06h.62a2,2,0,0,0,.68.46,1.94,1.94,0,0,0,.19.79c.27.59.83,1.1.8,1.79,0,.42-.16.84-.21,1.27s0,.73-.05,1.09a8.3,8.3,0,0,0,.28,2.38.08.08,0,0,0,.16,0,8.77,8.77,0,0,1,.07-2.4c.14-.75.51-1.42.7-2.15A2.29,2.29,0,0,0,232.35,72.14Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "228.573px 66.995px",
        }}
        id="eleqlrh587bji"
        className="animable"
      />
      <path
        d="M270.54,72.66a16,16,0,0,1-.27,4.58,8.23,8.23,0,0,1-2,4,10.26,10.26,0,0,1-3.68,2.58,18,18,0,0,1-4.35,1.2,29.89,29.89,0,0,1-7.36.13c-.09,1.77-.18,3.53-.3,5.27a36.32,36.32,0,0,1-.69,5.14,26.39,26.39,0,0,1-1,3.85,5.2,5.2,0,0,1-2.38,3,4.36,4.36,0,0,1-2.76.53,5.68,5.68,0,0,1-2.55-1,8.34,8.34,0,0,1-2.39-2.49,9.3,9.3,0,0,1-1.26-3.15,7.75,7.75,0,0,1-.19-1.09c-.05-.38-.09-.74-.14-1.1,0-.53-.07-1-.1-1.56s0-1,0-1.55c-.09-1.07-.13-2.13-.13-3.19s0-2.12.06-3.18q.14-3.18.37-6.33c.15-2.1.41-4.22.76-6.34.18-1.06.35-2.11.53-3.15s.38-2.06.6-3.08q.26-1.12.6-2.22a13.13,13.13,0,0,1,.86-2.16,8.6,8.6,0,0,1,2.42-2.85,14.65,14.65,0,0,1,3.28-1.86,19.28,19.28,0,0,1,4.08-1c1.39-.18,2.79-.31,4.21-.4a18.13,18.13,0,0,1,4,.33,10,10,0,0,1,3.72,1.59A10.78,10.78,0,0,1,267.06,60a15.28,15.28,0,0,1,1.62,3.55c.09.36.18.72.27,1.1s.17.74.26,1.09.18.72.27,1.09.17.77.26,1.16A26.63,26.63,0,0,1,270.54,72.66ZM255,67.76a5.05,5.05,0,0,0-1.46,1.52,6.61,6.61,0,0,0-.87,2,5.64,5.64,0,0,0-.1,2.16,4.24,4.24,0,0,0,.83,1.92,3.23,3.23,0,0,0,1.26,1.06,6.3,6.3,0,0,0,1.53.47,3.81,3.81,0,0,0,2.25-.27,3.36,3.36,0,0,0,1.4-1.49,5.5,5.5,0,0,0,.53-2,6.39,6.39,0,0,0-.14-2.26,4.61,4.61,0,0,0-1-2,3,3,0,0,0-3.78-.93C255.15,68,255,67.93,255,67.76Z"
        style={{
          fill: "#213E60",
          transformOrigin: "254.794px 79.1071px",
        }}
        id="elc7at1bhn5h"
        className="animable"
      />
      <g id="elbd0l5nvej59">
        <path
          d="M246.68,100.58a1,1,0,0,1-1.37.58,2.68,2.68,0,0,1-.85-.79c-.41-.49-.71-1.05-1.07-1.57l.12-.09a.6.6,0,0,0-.33-1.11H243a.45.45,0,0,0-.16-.28c-.11-.08-.2-.18-.31-.27a.6.6,0,0,0-.3-1l-.07,0a.48.48,0,0,0-.14-.74l0,0a.22.22,0,0,0,0-.16h0a2.09,2.09,0,0,0-.08-.23.08.08,0,0,0,0,0,1.6,1.6,0,0,0-.1-.23.35.35,0,0,0,.05-.08s0,0,0-.07a2.68,2.68,0,0,0,1,.75.1.1,0,0,0,.1-.18,4.45,4.45,0,0,1-1.6-3.1.22.22,0,0,0,0-.28l-.06-.63,0,0a.46.46,0,0,0-.07-.65l0-.55a2,2,0,0,1,.3-.2,4.38,4.38,0,0,0,1.8-.3.12.12,0,0,0,0-.23,5.15,5.15,0,0,0-1.89.29l-.12-.05-.08-.06c0-.09,0-.19,0-.28a1.09,1.09,0,0,1,0-.18c0-.36,0-.72,0-1.08a.39.39,0,0,0-.08-.2c0-.34-.17-.72,0-1s1.16-.49,1.51-.57a.35.35,0,0,0-.11-.68,5.82,5.82,0,0,1-1.18,0c-.84-.16-.26-1.3-.15-1.83a5.47,5.47,0,0,0-.17-3.13c-.24-.64-.67,1.44-.65,1.65,0,.36,0,.74.07,1.11s0,.5.05.76a.16.16,0,0,0-.08.06,5.69,5.69,0,0,0-.38,1.82,6.65,6.65,0,0,0,0,1c0,.14.16.84-.06.9a.23.23,0,0,0-.16.29.52.52,0,0,0,.06.15,1.18,1.18,0,0,0-.22.17.25.25,0,0,0,0,.33l.31.32-.35.33a.24.24,0,0,0,0,.3.48.48,0,0,0,.12.16,1.92,1.92,0,0,0,.14,1,1.84,1.84,0,0,0,.31,1.15.2.2,0,0,0,.16.07c0,.11,0,.22.06.33s0,0,0,0l-.1.08a.24.24,0,0,0,0,.3,1.73,1.73,0,0,1,0,1.39.34.34,0,0,0,.1.33l.4.35-.16.2a.45.45,0,0,0-.06.53,3.45,3.45,0,0,0,.3.34,4,4,0,0,0-.3.28.56.56,0,0,0,.27.92l.13,0a.57.57,0,0,0,.08.45,5.66,5.66,0,0,0,.4.44.6.6,0,0,0,.49,1h.05a.75.75,0,0,0,.17.36c.49.55,1.11,1,1.63,1.51a3.17,3.17,0,0,0,1.31.88,1.24,1.24,0,0,0,1.67-1C246.84,100.51,246.7,100.5,246.68,100.58Z"
          style={{
            opacity: 0.2,
            transformOrigin: "243.239px 91.0095px",
          }}
          className="animable"
          id="el4guvx0n63dp"
        />
      </g>
      <path
        d="M253.22,77l-.19-.13v0a4.92,4.92,0,0,0-.6-.61l.14,0c.09,0,0-.17-.06-.15l-.17.08c-.06-.08-.09-.15-.14-.23a.23.23,0,0,0-.11-.18.4.4,0,0,0-.13-.35.16.16,0,0,0-.09-.08l0-.08a.42.42,0,0,0-.19-.49,6.8,6.8,0,0,1-.19-1s0,0,0,0c0-.21,0-.43-.07-.65a.35.35,0,0,0-.29-.31l-.06,0-.06,0c0-.08.05-.17.08-.25a.26.26,0,0,0,.12-.29.67.67,0,0,0,.2-.71h0c.15-.07.27-.29.13-.43l-.1-.12c.31-.29.54-.64.36-1a1.14,1.14,0,0,0,.31-.41c.16-.35.06-.73.28-1.06a4.12,4.12,0,0,1,1.51-1.13c.1,0,.93-.34,1-.74,0-.22-1.22.11-1.28.13a1.44,1.44,0,0,0-.5.19,2.12,2.12,0,0,0-.51.38.87.87,0,0,0-.47-.26,3,3,0,0,1-.86-.39c-.2-.27-.32-.59-.54-.85a2.68,2.68,0,0,0-.93-.59s-.08,0-.05.06A11.15,11.15,0,0,0,251,66.43l.15.09s0,0,0,.06a7.1,7.1,0,0,0,.71.63.75.75,0,0,1,.23.79l-.06.08a.12.12,0,0,0-.13.13c0,.23.2.46-.2.5a.11.11,0,0,0-.09.06c-.12.32-.12.69-.51.54a6.73,6.73,0,0,1-1-.62.24.24,0,0,0-.31.37c.23.24.48.44.73.66a3.48,3.48,0,0,1,.3.26,2.69,2.69,0,0,1,.18.24l-.25.2a.78.78,0,0,1-.88,0c-.4-.23-.8.41-.43.68,0,0,.06,0,.09,0h0s.1,0,.14.07a3.82,3.82,0,0,0,.65.24l.3.08v.08a.29.29,0,0,0-.26.28.87.87,0,0,0-1,.54c-.12,0-.24,0-.36,0a.23.23,0,0,0-.08.44l.44.17a.86.86,0,0,0,.44.46.94.94,0,0,0,.75,0l.18.1a.4.4,0,0,0-.22.69l.26.2a.38.38,0,0,0,0,.46c-.06,0-.1.12,0,.18a.61.61,0,0,1,.2.77.13.13,0,0,0,.09.18c.39.07,0,.69-.17.86s.09.31.22.18.4-.43.62-.62a.77.77,0,0,1,.17-.13h0a.07.07,0,0,0,.11.08l.14-.12.31.19.08,0a4.35,4.35,0,0,0,.65.44S253.27,77,253.22,77Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "251.841px 71.2105px",
        }}
        id="elwwrv7a7aidk"
        className="animable"
      />
      <path
        d="M269.41,73.73l-.11-.16a.36.36,0,0,0,.11-.51c-.25-.34,0-.83-.05-1.23s-.17-1.09-.23-1.62a19,19,0,0,0-.51-3s-.05,0,0,0a10.69,10.69,0,0,1,.25,3.65c-.09.56-.24,1.1-.32,1.67a1.11,1.11,0,0,0,0,.55.38.38,0,0,0-.11.11s0,0-.09,0a2.66,2.66,0,0,1-.63,0l-.64,0c-.07,0-.09.12,0,.13a4.09,4.09,0,0,1,.69.17,1.72,1.72,0,0,1,.65.32.88.88,0,0,1,.18.21l-.07.08a.36.36,0,0,0,.21.58v.06l0,0a.85.85,0,0,0-.1.19l-.09.2a1.2,1.2,0,0,0-.06.17v0a.08.08,0,0,0,0,0,1.46,1.46,0,0,0-.35.22,1.87,1.87,0,0,1-1-.18.15.15,0,0,0-.2,0,3.12,3.12,0,0,1-.72-.45h0s-.1,0-.06.08a3.48,3.48,0,0,0,.51.34,2.2,2.2,0,0,0,.25.17v0a3.34,3.34,0,0,0,.66,1.17.56.56,0,0,0-.09.87l.12.1a.47.47,0,0,0-.05.59,3.53,3.53,0,0,0-.39.45.42.42,0,0,0,0,.15l-.37.15a.48.48,0,0,0-.31.59h0a.64.64,0,0,0-.33.16l0,0c0-.06-.05-.1-.09-.06a4.39,4.39,0,0,0-.57.57l-.08,0a.47.47,0,0,0-.43.39l-.08,0a2.78,2.78,0,0,1-.42-.22,5.31,5.31,0,0,1-1.19-1,1.13,1.13,0,0,0-.24-.25s0,0-.06-.07h0s-.05,0,0,0l0,0a1.75,1.75,0,0,1,.46.7,2.72,2.72,0,0,0,.5.67,1.36,1.36,0,0,1,.29.66.57.57,0,0,0,0,.13.42.42,0,0,0-.3.11,1,1,0,0,0-.23-.13.8.8,0,0,0-.57,0,.4.4,0,0,0-.19.11,2.67,2.67,0,0,1-.69-.36.06.06,0,0,0-.08.08,1.73,1.73,0,0,1,.55.81v0h-.05a.46.46,0,0,0-.37.7c.15.24-1,.31-1.12.34-.3.05-1.27.75-1.45.49-.06-.08-.19,0-.14.08a.52.52,0,0,0,.56.23,4.78,4.78,0,0,0,.61-.28c.42-.16.73,0,1.14.07A1.18,1.18,0,0,0,263,83h.35a.44.44,0,0,0,.4-.31.38.38,0,0,0,.15,0,.63.63,0,0,0,.59-.22h0a.49.49,0,0,0,.6-.48v0a1,1,0,0,0,.68-.76l.66-.07a.51.51,0,0,0,.48-.51s0-.07,0-.11a1.74,1.74,0,0,0,.27-.14.47.47,0,0,0,.2-.54h0l.21-.09a.47.47,0,0,0,.32-.59c0,.06.45-.6.47-.66s0-.08,0-.12l.13-.08a.56.56,0,0,0,.18-.77c-.05-.08-.12-.16-.18-.24l.09-.14a.36.36,0,0,0,.32-.39.38.38,0,0,0,0-.58.6.6,0,0,0,.08-.08l0,0a0,0,0,0,0,0,0,.46.46,0,0,0,.07-.07.41.41,0,0,0,0-.5c.06-.17.18-.36.22-.51a1.14,1.14,0,0,0,0-.52l-.09-.17.09-.11A.36.36,0,0,0,269.41,73.73Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "264.536px 75.4569px",
        }}
        id="elcr9gezw7tl"
        className="animable"
      />
      <g id="elf23hoejp405">
        <path
          d="M262.08,74.91a2.92,2.92,0,0,1-.31-.14h-.19a1.17,1.17,0,0,1-.2-.42,1.61,1.61,0,0,1,.3-1.24c.07-.07,0-.22-.09-.2a.25.25,0,0,1-.3-.32c.25-.25.48-.52.73-.78,0,0,0-.06,0,0-.32.26-.66.49-1,.77a.11.11,0,0,0,0,.16v.17a.13.13,0,0,0,0,.16.91.91,0,0,1,0,.49c0,.2,0,.39-.06.58s0,.64-.23.79a.21.21,0,0,0,0,.29.52.52,0,0,0-.16.14.21.21,0,0,0,0,.29,1,1,0,0,1,.08.11h0l-.09,0a.21.21,0,0,0-.16.11h-.06a.16.16,0,0,0-.15.2.85.85,0,0,1-.29.94c-.07.07,0,.17.12.11a1.23,1.23,0,0,0,.35-.53s.11,0,.13,0l.12-.26.16.08c.18.06.32-.18.22-.32s.08,0,.12,0a.21.21,0,0,0,.06-.29c0-.08-.11-.14-.17-.22h0l0,0c.07,0,.1-.07.12-.13a.78.78,0,0,1,.39-.18l.25,0a.67.67,0,0,1,.28-.06h0C262.17,75.07,262.16,74.92,262.08,74.91Z"
          style={{
            opacity: 0.2,
            transformOrigin: "261.006px 74.4609px",
          }}
          className="animable"
          id="elu71qs8wsela"
        />
      </g>
      <g id="elfvrhewebx6s">
        <path
          d="M247.47,58.4a10.82,10.82,0,0,1-1.51.88,4.06,4.06,0,0,0-1.2.84,1,1,0,0,0-.27,1s0,0,0,0h-.15a.32.32,0,0,0-.29.23v0a.72.72,0,0,0-.5.13,1.65,1.65,0,0,0-.5,1.22c-.06.56-.2,1.11-.28,1.67a17.1,17.1,0,0,1-.35,1.7c0,.1.13.13.15,0,.08-.26.17-.5.25-.75,0,0,0,0,0,0s0-.2.08-.3c.09-.28.18-.56.28-.84a3.27,3.27,0,0,1,.24-.5A5.41,5.41,0,0,1,244,63c.11-.13.23-.26.34-.4l.41.07.12.07a1.46,1.46,0,0,0,.62.16,0,0,0,0,0,0-.06l-.52-.16-.06,0-.23-.17a.6.6,0,0,1-.13-.28.18.18,0,0,0-.09-.1.28.28,0,0,0,.13-.18c0-.06,0-.12,0-.18a5.06,5.06,0,0,1,.55,0c.37.06.51-.5.14-.56h-.08c-.36,0,0-.55.12-.65s.44-.41.66-.61.46-.53.71-.78a8.88,8.88,0,0,1,.79-.71S247.49,58.39,247.47,58.4Z"
          style={{
            opacity: 0.2,
            transformOrigin: "244.951px 62.2778px",
          }}
          className="animable"
          id="elagapy45pby"
        />
      </g>
      <path
        d="M252.46,83c0-.14,0-.27,0-.41s.06-.51-.08-.65c0-.17,0-.33.06-.5a3.11,3.11,0,0,0,0-.68,4.44,4.44,0,0,0-.16-.6c0-.11-.21-.08-.2,0v.44a.11.11,0,0,0,0,0l-.06.57c0,.11,0,.37-.08.45s-.44,0-.55,0l-.55,0a.22.22,0,0,0,0,.44,2.67,2.67,0,0,1,.4,0s0,0,0,.07a3.39,3.39,0,0,1,.64,1c0,.09,0,.17,0,.25a.53.53,0,0,1-.06.24.26.26,0,0,0,.11.36v0h0a7.38,7.38,0,0,0,0,1,.05.05,0,0,0,.1,0c.08-.39.21-.77.28-1.16l0,0A1.23,1.23,0,0,0,252.46,83Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "251.548px 82.5592px",
        }}
        id="elorcgu9e573"
        className="animable"
      />
      <path
        d="M305.22,67.49a16,16,0,0,1,.54,4.55,8.27,8.27,0,0,1-1.34,4.28,10.27,10.27,0,0,1-3.18,3.18,18.3,18.3,0,0,1-4.07,1.93A29.81,29.81,0,0,1,290,82.84c.22,1.75.42,3.5.62,5.24a36.07,36.07,0,0,1,.2,5.18,27.69,27.69,0,0,1-.31,4,5.28,5.28,0,0,1-1.83,3.36,4.4,4.4,0,0,1-2.62,1,5.82,5.82,0,0,1-2.69-.54,8.25,8.25,0,0,1-2.78-2,9.44,9.44,0,0,1-1.79-2.88,7.15,7.15,0,0,1-.38-1L278.05,94c-.14-.51-.26-1-.37-1.52s-.21-1-.31-1.52c-.27-1-.49-2.07-.68-3.12s-.34-2.09-.49-3.14q-.42-3.16-.73-6.3c-.22-2.1-.33-4.22-.35-6.37,0-1.08,0-2.14,0-3.2s0-2.1,0-3.14c0-.77.11-1.53.2-2.29a13.13,13.13,0,0,1,.48-2.27,8.64,8.64,0,0,1,1.89-3.23,14.77,14.77,0,0,1,2.91-2.4,18.72,18.72,0,0,1,3.84-1.68c1.34-.42,2.7-.79,4.08-1.13a17.78,17.78,0,0,1,4-.37,9.91,9.91,0,0,1,3.93.92,10.44,10.44,0,0,1,3.07,2.33,14.77,14.77,0,0,1,2.22,3.21c.15.33.3.68.45,1s.3.7.45,1,.3.68.45,1,.31.72.46,1.1A26.59,26.59,0,0,1,305.22,67.49ZM289,65.36a5.48,5.48,0,0,0-1.17,1.75,6.82,6.82,0,0,0-.5,2.14,5.63,5.63,0,0,0,.28,2.14,4,4,0,0,0,1.15,1.75,3.15,3.15,0,0,0,1.42.83,6.07,6.07,0,0,0,1.59.19,3.76,3.76,0,0,0,2.17-.65,3.28,3.28,0,0,0,1.11-1.71,5.42,5.42,0,0,0,.18-2.08,6.5,6.5,0,0,0-.53-2.2,4.62,4.62,0,0,0-1.32-1.79,3,3,0,0,0-3.88-.26C289.26,65.56,289.1,65.52,289,65.36Z"
        style={{
          fill: "#213E60",
          transformOrigin: "290.443px 76.9704px",
        }}
        id="elayx2kprrykk"
        className="animable"
      />
      <path
        d="M289.3,89.92c.44-.68.16-1.36,0-2.15A10,10,0,0,1,289,86a11.64,11.64,0,0,1,.13-1.86c0-.06-.08-.08-.09,0a26.42,26.42,0,0,0-.35,3.77c0,.31,0,.62,0,.93a.93.93,0,0,1-.06.57c0,.08-.15.12-.2.21a1.56,1.56,0,0,0,0,.77,1,1,0,0,0-.93-.15s0,0,0,.07c.22.19.51.25.74.42a.68.68,0,0,1,.23.28l0,.06a.43.43,0,0,0-.07.68l0,.08a.87.87,0,0,0-.11.18,2.61,2.61,0,0,1-.28,0H287l-.06,0a0,0,0,0,0,0,0H286a0,0,0,0,0,0,.09,4,4,0,0,0,1,.26l0,0h.14l.42.08a1.49,1.49,0,0,1,1,.7l-.09.39a4.62,4.62,0,0,1-.47,1.8c-.13.18,0,.42.21.48l.08,0-.51.18a.4.4,0,0,0-.08.73l.2.11a2.25,2.25,0,0,1-.52.08.33.33,0,0,0-.33.27l-.27-.35a0,0,0,0,0-.07.05c.11.16.22.31.33.48a.32.32,0,0,0,.13.22l0,.06c.09.18.28.45.2.66a.72.72,0,0,1-.11.19.47.47,0,0,0-.06.09,1.13,1.13,0,0,0-.1.13h0a1.58,1.58,0,0,1-.36-.09,1.4,1.4,0,0,1-.33-.27l-.43-.4a6.87,6.87,0,0,0-.89-.82,0,0,0,0,0-.06.06c.27.27.53.55.81.82l.22.21a7.75,7.75,0,0,1,.86,1.33.05.05,0,0,0,.05,0,2.31,2.31,0,0,1-.95.62c-.1,0-.05.18,0,.15a4.29,4.29,0,0,0,1.41-.64,3.24,3.24,0,0,0,1.06-1.34.36.36,0,0,0-.14-.47l-.07,0,.18-.16a.27.27,0,0,0,.08-.22,2.38,2.38,0,0,0,.55-.28.44.44,0,0,0-.12-.78l-.12,0,.15,0a.39.39,0,0,0,.21-.56,1.21,1.21,0,0,0-.21-.28,3.54,3.54,0,0,0,.11-.44,1.17,1.17,0,0,0-.1-.9.51.51,0,0,1,0-.48,1,1,0,0,0,0-.38s0-.08,0-.13a1.92,1.92,0,0,1,.11-.78,3.43,3.43,0,0,0,.19-.44.87.87,0,0,0,0-.48C289.55,91.06,289.3,90.48,289.3,89.92Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "287.283px 92.2053px",
        }}
        id="el8khh9vni6oa"
        className="animable"
      />
      <path
        d="M300.43,59.57a2.91,2.91,0,0,1-.54-.89c-.1-.31-.09-.66-.22-1a1.06,1.06,0,0,0-.54-.58c0-.4-.55-.69-.85-1a1.35,1.35,0,0,0-.74-.34.41.41,0,0,1,0-.11c0-.28-.19-.58-.5-.47h0s0,0,0-.05a1,1,0,0,0-.18-.18,1.5,1.5,0,0,0-.4-.25,1.7,1.7,0,0,0-.4-.13.91.91,0,0,0-.52-.29.18.18,0,0,0-.2.12,1.78,1.78,0,0,0-.89-.67c-1-.33-1.88.16-2.84.41-.1,0,0,.19.05.15a3.22,3.22,0,0,1,2.28-.18,1.45,1.45,0,0,1,1,1.31.33.33,0,0,0,.23.32,1,1,0,0,1,0,.17c-.11.55-.6.94-.81,1.46,0,0,0,.06.06,0,.22-.28.44-.56.67-.83a3,3,0,0,1,.65-.64,1,1,0,0,1,.91,0l.2.08a2,2,0,0,0,.16.49.4.4,0,0,0,.7,0s0,.12.1.2a.54.54,0,0,1,0,.33,1.94,1.94,0,0,1-.17.42,4.6,4.6,0,0,1-.52.78c0,.05,0,.11.07.07s.26-.3.39-.45l.37-.41a1,1,0,0,1,.34-.28h0a.31.31,0,0,0,.2.09.34.34,0,0,0,.2.31,1.72,1.72,0,0,1,.1.39,1.28,1.28,0,0,1-.25.56,3.36,3.36,0,0,0-.57.62c-.07.09-.11.19-.17.28s-.29.34-.44.5-.35.34-.19.52h0A18.89,18.89,0,0,1,298.26,59a3.28,3.28,0,0,1,.75-.53.46.46,0,0,1,.48,0c.06.15.12.3.18.42a.86.86,0,0,1,.07.1v0a.06.06,0,0,0,.06.06c.24.36.54.68.79,1A8.62,8.62,0,0,1,301.92,63a0,0,0,1,0,.05,0A9.73,9.73,0,0,0,300.43,59.57Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "296.769px 58.3097px",
        }}
        id="elxes52bwflz"
        className="animable"
      />
      <path
        d="M292.28,63.66a11.5,11.5,0,0,0-3.36.23h0a.75.75,0,0,1-.09-.15v0c-.09-.43-.21-.85-.3-1.27h0a0,0,0,0,0-.06,0c0,.41,0,.83,0,1.24a1.07,1.07,0,0,1-.08.38,2,2,0,0,0-1,.88.94.94,0,0,0-.24.44h0s0,0-.05,0a.55.55,0,0,0-.18-.16c-.6-.36-1.25-.65-1.86-1a0,0,0,1,0,0,0c.26.26.51.53.76.8s.59.52.61.86a.12.12,0,0,0,.05.1l-.73-.33c-.25-.12-.56.22-.31.42l.3.26a.3.3,0,0,0-.26.51c.21.22.43.43.65.64a.62.62,0,0,0-.06.26c0,.14.11.33.09.46,0-.11-.12.05-.15.08a.84.84,0,0,0-.13.21,1.2,1.2,0,0,0-.08.53.83.83,0,0,0,.15.45,2.89,2.89,0,0,1,.1.48c0,.24.11.46.15.7s.17,0,.15,0a1.91,1.91,0,0,1,0-1.11c0-.08.11-.11.15-.2s0-.36.1-.48.19-.11.25-.17a.87.87,0,0,0,.14-.27,1,1,0,0,0,0-.41l-.09-.19s0,0,0,0a.33.33,0,0,0,0-.5c.27,0,.49-.38.23-.59a.42.42,0,0,0,.26-.26.54.54,0,0,0,0-.28s-.12-.36,0-.23.41,0,.39-.17c-.06-.93,1.19-1.08,1.82-1.3.42-.15.84-.29,1.25-.47a3.76,3.76,0,0,1,1.51-.36A0,0,0,1,0,292.28,63.66Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "288.71px 66.6283px",
        }}
        id="el11tl1vwd0dv"
        className="animable"
      />
      <path
        d="M304.66,70.08a9.48,9.48,0,0,0-.81-2.11c0-.07-.12,0-.1,0A12.48,12.48,0,0,1,304,71.3a1.26,1.26,0,0,1-.31.25,0,0,0,0,0,0,.08c.27.09-.07,0-.15,0a.73.73,0,0,0-.38.08c-.05,0-.06.06,0,.1a3.47,3.47,0,0,0,.34.32.78.78,0,0,1,.27.57c-.2.47-.41.92-.64,1.37a2.11,2.11,0,0,1-.48-.12,2.64,2.64,0,0,0-.44-.23l-.29-.14a2.17,2.17,0,0,1-.37-.31s-.07,0-.05,0l.15.13c-.14,0,.08.12.21.21a5.62,5.62,0,0,1,.44.41,2,2,0,0,1,.46,1.16,1.94,1.94,0,0,1,0,.34c-.09.14-.17.3-.27.43a.08.08,0,0,0,0,.11,9.91,9.91,0,0,1-1.09,1.44c0,.06,0,.15.1.09a7.18,7.18,0,0,0,1.22-1.3,11,11,0,0,0,1.13-1.42c.08-.11.17-.22.25-.35a5.09,5.09,0,0,0,.62-2.16A8.94,8.94,0,0,0,304.66,70.08Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "303.083px 72.7743px",
        }}
        id="el6a93h3j7jmq"
        className="animable"
      />
      <path
        d="M290,81.23a.59.59,0,0,0-.26-.28c-.08,0-.23-.08-.28-.16s.09-.38.14-.48a.43.43,0,0,0-.27-.62l-.47-.14.18-.31a.47.47,0,0,0-.07-.57l.08-.11A.48.48,0,0,0,289,78a2.42,2.42,0,0,0,0-.38,1,1,0,0,0-.23-.5c-.05,0-.48-.37-.3-.46a.29.29,0,0,0,0-.45,2.45,2.45,0,0,1-.57-.64,9.4,9.4,0,0,0-.9-2.4,0,0,0,0,0-.08,0c.15.71.35,1.41.49,2.13a2,2,0,0,0,.46,1.09,1.24,1.24,0,0,0,.06.9,1.45,1.45,0,0,0,0,.47,1.87,1.87,0,0,1-.14.74.43.43,0,0,0,0,.29,1,1,0,0,0,0,.24.71.71,0,0,0,.11.17.93.93,0,0,0-.06.88,1.1,1.1,0,0,0,.84.38.87.87,0,0,0,.48,1c.07,0,.27,0,.32.07s.08.3.11.38,0,.24.18.32.16-.08.07-.14.12-.4.15-.49A.51.51,0,0,0,290,81.23Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "288.475px 77.711px",
        }}
        id="el4xb0kvstts"
        className="animable"
      />
      <g id="elvmbowpoeu1l">
        <path
          d="M279,58.93c.05,0,.14,0,.11.07a3.19,3.19,0,0,1-.28.59c0,.15.18.23.34.27h0a3.51,3.51,0,0,1,1,.22.08.08,0,0,1,0,.15l-.75-.18a1,1,0,0,0-1.11.47,1.68,1.68,0,0,0-.19.66,1.89,1.89,0,0,0,.65,1l.23.06c.44.11.89.21,1.34.3a.06.06,0,0,1,0,.12,2,2,0,0,1-1.42-.22,1.1,1.1,0,0,0-.53.11,1.35,1.35,0,0,0-.41.38,2,2,0,0,1-.09.91,2.11,2.11,0,0,1-.15,2.71c0,.44,0,.93,0,1.41a.28.28,0,0,0,.35.09c.29-.1.57-.36.89-.22a.08.08,0,0,1,0,.13,3,3,0,0,0-1.2.93,1.51,1.51,0,0,0-.09.18,1.81,1.81,0,0,0,.94.89,1.06,1.06,0,0,0,.23,0,7.82,7.82,0,0,1,1.53,0c.07,0,.08.11,0,.11a7.81,7.81,0,0,1-1.46,0,4,4,0,0,0-.7.16.21.21,0,0,0,0,.06c.07.1-.08.19-.16.13l-.09-.09-.07,0a.73.73,0,0,1-.18.44l-.59.61a55.86,55.86,0,0,0,0,5.93,53.12,53.12,0,0,0,.55,6.42c0,.11-.14.16-.17,0a49.48,49.48,0,0,1-1.44-7.13c-.11-1.19-.19-2.39-.22-3.59a10.48,10.48,0,0,1,0-1.94.84.84,0,0,1,.08-.27,1.72,1.72,0,0,1-.2-1.05.57.57,0,0,1-.18-.37,5.78,5.78,0,0,1,.31-1.53c.07-.28.14-.57.2-.85,0-.07.12-.37.15-.54a.59.59,0,0,1-.43-.79c.09-.35.92-1.26.38-1.52a.45.45,0,0,1-.11-.7c.5-.65.35-1.58.68-2.3s.83-.89,1.21-1.36a1.64,1.64,0,0,0,.26-.42h0c.1-.16.18-.32.29-.47a14.14,14.14,0,0,1,4.11-3.38s.07,0,0,0A15.61,15.61,0,0,0,279,58.93Z"
          style={{
            opacity: 0.2,
            transformOrigin: "279.101px 69.6761px",
          }}
          className="animable"
          id="elwvsdo2hl92k"
        />
      </g>
      <path
        d="M343.13,45.81a11,11,0,0,1,.57,4.49,22.58,22.58,0,0,1-.87,4.9,31.26,31.26,0,0,1-1.8,4.63,14.67,14.67,0,0,1-.77,1.37c-.29.47-.57.94-.83,1.4s-.47.9-.74,1.36-.52.91-.74,1.36-.41.69-.61,1-.38.71-.58,1.1c.49,1.33.92,2.65,1.31,4L339,75a27.49,27.49,0,0,0,1.16,3.53l1.23,2.88a18.28,18.28,0,0,1,1,3,22.69,22.69,0,0,1,.43,2.79,4.23,4.23,0,0,1-.64,2.72,5.08,5.08,0,0,1-2.3,1.73,8.27,8.27,0,0,1-1.69.49,6.88,6.88,0,0,1-1.75.08,6.71,6.71,0,0,1-2.64-.7,11.09,11.09,0,0,1-2.3-1.58,14.11,14.11,0,0,1-2.11-2.52,32.15,32.15,0,0,1-1.66-2.8,45.26,45.26,0,0,1-2.88-6.87c-.4-1.22-.77-2.42-1.11-3.58s-.66-2.36-1-3.56L320.56,69c-.71-.51-1.44-1-2.21-1.51-.31-.22-.62-.43-.94-.63s-.63-.41-.94-.63a8.47,8.47,0,0,1-.82-.57l-.75-.59c-.63-.49-1.21-1-1.74-1.49A21.91,21.91,0,0,1,311.58,62a17.22,17.22,0,0,1-2.5-3.47,5.36,5.36,0,0,1-.55-4.11,9.31,9.31,0,0,1,1.08-2.66,4.47,4.47,0,0,1,2.17-1.9,4.22,4.22,0,0,1,2.41-.2,13,13,0,0,1,2.37.72,20,20,0,0,1,2.79,1.6c.87.6,1.72,1.23,2.54,1.89s1.65,1.41,2.45,2.13,1.57,1.46,2.33,2.23c.21.21.43.43.64.66a6,6,0,0,0,.7.64,13.07,13.07,0,0,1,.05-2.07c.08-.7.18-1.4.33-2.1a33.32,33.32,0,0,1,2-6.09c.43-1,.88-1.92,1.38-2.83a17.44,17.44,0,0,1,1.73-2.59,14.34,14.34,0,0,1,1.64-1.69,4.52,4.52,0,0,1,2.12-1.08,3.29,3.29,0,0,1,2.25.24,6,6,0,0,1,1.8,1.43A12,12,0,0,1,343.13,45.81Z"
        style={{
          fill: "#213E60",
          transformOrigin: "326.04px 66.6125px",
        }}
        id="elwsss1htu16r"
        className="animable"
      />
      <path
        d="M340.94,84.76a27.11,27.11,0,0,0-1.05-2.9c0-.33-.07-.66-.1-1a.44.44,0,0,0-.1-.26,1.41,1.41,0,0,0-.1-.7.86.86,0,0,0-.23-.33c-.11-.11-.27-.18-.33-.32s0-.31-.06-.46a1.67,1.67,0,0,0-.17-.44l-.36-.66h0l-.12-.25a2.43,2.43,0,0,0,.05-.61.15.15,0,0,0-.13-.13.29.29,0,0,0,0-.09.26.26,0,0,0-.13-.16,1.13,1.13,0,0,0,0-.18v0a1.48,1.48,0,0,1,.05-.35c0-.09-.14-.13-.16,0v0h0a4.35,4.35,0,0,0-.21-2.64c-.61-1.61-1.86-2.91-2.12-4.65a.08.08,0,1,0-.15,0c.46,2.58,2.61,5.32,1.15,7.94a.4.4,0,0,0,0,.41,1.94,1.94,0,0,0-.23.26,0,0,0,0,0,0,0c.21.16,0,0,.18.1s.14-.07.52.22l.13.06a.48.48,0,0,1,0,.15.34.34,0,0,0,.2.47,2.87,2.87,0,0,0-.37.58.36.36,0,0,0,.15.49,2.22,2.22,0,0,0,.68.21.25.25,0,0,0,0,.07.4.4,0,0,0,.23.58l-.12.17a.08.08,0,0,0,.07.11h.21a.47.47,0,0,0,0,.16l-1.72,1a.08.08,0,0,0,.07.14,14,14,0,0,1,1.92-.66.85.85,0,0,1,.16,0l.13,0a.78.78,0,0,1,.38.38c.06.33.13.67.17,1a1.36,1.36,0,0,1-.07.74c0,.09-.09.14-.1.25a4.74,4.74,0,0,0,.32,1.14,8,8,0,0,1,.21,1.62.3.3,0,0,0,.14.26,3.4,3.4,0,0,1-.07.46c0,.12.14.23.23.12h0a.09.09,0,0,0,.17,0h0a0,0,0,0,0,0,0s0,0,0,0a.17.17,0,0,0,.1,0v0a.3.3,0,0,0,.17.16v.12a4.09,4.09,0,0,1-2.61-.08c-.1,0-.15.12-.07.16a5.07,5.07,0,0,0,1.3.64c.43.1,1.12-.09,1.45.19.82.72-1.22,2.23-1.74,2.57a0,0,0,1,0,.05.08l.18-.09a.59.59,0,0,0,.14-.07,7,7,0,0,0,1.69-1.11,3.1,3.1,0,0,0,.79-2.19A10,10,0,0,0,340.94,84.76Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "338.614px 79.7111px",
        }}
        id="elx077sxx4yns"
        className="animable"
      />
      <path
        d="M323,57.62a0,0,0,0,0,0,0h0Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "323px 57.62px",
        }}
        id="el2957try48k"
        className="animable"
      />
      <path
        d="M326.42,58.86s.07,0,0,0c-.42-.37-.85-.73-1.28-1.09a.77.77,0,0,0,0-.15,1.47,1.47,0,0,0-.51-.65s0-.08-.08-.1l-.3-.2c-.19-.15-.37-.3-.57-.44l0,0h0l-.05,0a.17.17,0,0,0-.26.08l-.09-.07a.78.78,0,0,0-.18-.3c-.25-.27-.61-.4-.88-.65a2.87,2.87,0,0,0-.84-.58c-.05,0-.12,0-.06.08l.87.68a2.28,2.28,0,0,1,.29.33,5.15,5.15,0,0,0,.42.62.5.5,0,0,1,0,.3A.25.25,0,0,0,323,57a2.18,2.18,0,0,1-.11.27.29.29,0,0,0,.07.36s0,0,0,0,0,0,0,0a.07.07,0,0,1-.05,0v0l0,.11a4,4,0,0,0-.23.46,8.54,8.54,0,0,1-.42,1c-.08.13.12.29.22.16L323.66,58c.09-.12.18-.24.28-.35l.14-.16a3.91,3.91,0,0,1,.85.53.77.77,0,0,1-.49.76h0c-.09,0,0,.2.08.17h0a.19.19,0,0,1,.25,0s0,0,0,0,.11.11.14,0a.08.08,0,0,0,0,0h0c0-.21.16-.33.35-.33a1.14,1.14,0,0,1,.46.18c.07,0,.16,0,.11-.11a2.31,2.31,0,0,0-.14-.19l.16.13c.06,0,.14,0,.08-.08-.23-.23-.49-.43-.73-.65a.52.52,0,0,0,0-.11C325.6,58.16,326,58.49,326.42,58.86Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "323.874px 57.0591px",
        }}
        id="el18zscwko1yd"
        className="animable"
      />
      <path
        d="M327.65,59.77a.08.08,0,0,0-.08,0,.1.1,0,0,0-.09,0,.06.06,0,0,0,0,0h0a.17.17,0,0,0,0,.1h0a1.06,1.06,0,0,0-.42-.22c-.05,0-.07,0-.05.08a1,1,0,0,1,.21.88l-.09.24a4.73,4.73,0,0,1-.61,1c-.08.09,0,.21.12.12a4.47,4.47,0,0,0,.68-1,3.19,3.19,0,0,0,.24-.65v0c0,.1.18,0,.15,0a.92.92,0,0,0-.09-.23.11.11,0,0,0,.08,0A.21.21,0,0,0,327.65,59.77Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "327.12px 60.8259px",
        }}
        id="el5hnck3sskog"
        className="animable"
      />
      <g id="elcj6lstneu7o">
        <path
          d="M331,78.67h0a1.7,1.7,0,0,0-1.07.23l-.18.1-.63.17a1.27,1.27,0,0,1-.84,0c-.17-.08-.31-.35-.41-.5l-.12-.17a3.88,3.88,0,0,0,.67.41c.19.09.34-.19.16-.32-.43-.3-.82-.67-1.23-1-.06-.06-.11-.14-.17-.21a1.17,1.17,0,0,1,.29-1.12A12,12,0,0,1,329,75.1c.06,0,0-.16-.05-.13-.51.21-1,.4-1.54.6a2.45,2.45,0,0,0-.48.26l-.13.06a3.27,3.27,0,0,0-.21-.72h.06a.4.4,0,0,0,.14.19.41.41,0,0,0,.49-.05c.18-.13.34-.29.51-.44l.53-.47c.09-.08,0-.26-.13-.18l-.82.71-.13.12h0s0,0-.06,0a.35.35,0,0,0,0-.38,9.09,9.09,0,0,1-1.52-3.38,13.16,13.16,0,0,0-.35-1.59.45.45,0,0,0,.25-.51c-.11-.39-.22-.78-.34-1.16a.39.39,0,0,0-.48-.28,2.55,2.55,0,0,0-.86.55l-.24-.1a6.43,6.43,0,0,0-.76-1.36c-.81-1-1.92-.35-2.88-.91-1.19-.69-2.31-1.57-3.49-2.3S314.14,62,313,61.09c-.06-.05-.11,0-.14,0a3.47,3.47,0,0,0-.37-.21c-.2-.15-.41-.28-.62-.43s-.16.1-.08.17c2,1.58,4.06,3.2,6.08,4.81a13.65,13.65,0,0,0,1.54,1.21l.49.38a.48.48,0,0,0,.17.27,6.14,6.14,0,0,0,.84.52c.4.3.78.62,1.18.92.23.17.42,0,.47-.25a2.39,2.39,0,0,0,.22.12c.2.23.4.47.59.72a.48.48,0,0,0,0,.12.66.66,0,0,0,.41.52,7.33,7.33,0,0,1,.64,1.32c.79,2.21.68,4.78,1.89,6.82a8.29,8.29,0,0,0,.48.68,2,2,0,0,1,.33,1.18,17.84,17.84,0,0,0,.4,2.32A12.91,12.91,0,0,0,329,85.84l0,.07a9.7,9.7,0,0,1,.72,1.53c.05.18.32,0,.19-.13a3,3,0,0,1-.41-.65l.13.2c.06.08.16,0,.12-.08a23.79,23.79,0,0,1-.91-2.35,16.89,16.89,0,0,1-.25-2c0-.57-.17-1.37.25-1.79s.84-.58.76-1.16c0,0,0-.06-.07-.06l.57-.37.81-.21C331,78.8,331,78.68,331,78.67Z"
          style={{
            opacity: 0.2,
            transformOrigin: "321.36px 73.9594px",
          }}
          className="animable"
          id="ellcjqne4ylma"
        />
      </g>
      <g id="elnbmohdmuo89">
        <path
          d="M331.66,50.66c.18-.38.35-.77.53-1.16a.2.2,0,0,0,0-.17,2.49,2.49,0,0,0,.22-.65,5.07,5.07,0,0,0,1.8,1c.06,0,.1-.08,0-.11-1.72-.91-1.35-3.12-.74-4.6a.12.12,0,0,0-.2-.12,4.47,4.47,0,0,0-.85,1.82v.14c-.29.57-.62,1.13-1,1.67a14.67,14.67,0,0,0-1.34,3.1,29.49,29.49,0,0,0-1.3,6.91c0,.09.14.1.15,0a24.35,24.35,0,0,1,.68-3.16,8,8,0,0,0-.12.92c0,.14.22.17.25,0,.13-.62.29-1.23.45-1.84a2.37,2.37,0,0,1,.61.25,2.33,2.33,0,0,0,.51.42c.09,0,.17-.07.11-.15a3.55,3.55,0,0,0-.47-.4,1.74,1.74,0,0,1-.41-.89,1,1,0,0,1,.34-.23.13.13,0,0,0,.08-.13.3.3,0,0,1,.29,0l.22.06,1,.44c.09,0,.16-.09.07-.13l-1.69-.91s-.05,0-.08,0v0a.94.94,0,0,1,.64-.28A2.43,2.43,0,0,0,332,53s.13,0,.13-.06a.73.73,0,0,0-.47-.63,1.86,1.86,0,0,1,0-1.61S331.66,50.69,331.66,50.66Zm.85-3.35a1.46,1.46,0,0,0,.05.2s-.06,0-.06.05a.55.55,0,0,0,0,.22.65.65,0,0,0,.07.21.79.79,0,0,0,.3.3h0a2.88,2.88,0,0,0,.82,1,1.64,1.64,0,0,1-.29-.16,4.27,4.27,0,0,1-1-1.11.2.2,0,0,0-.13-.09C332.36,47.74,332.43,47.52,332.51,47.31Z"
          style={{
            opacity: 0.2,
            transformOrigin: "331.525px 51.6878px",
          }}
          className="animable"
          id="el04hm9evntg3i"
        />
      </g>
      <path
        d="M135,111a11.66,11.66,0,0,1-2,4.63,9.19,9.19,0,0,1-3.93,3.1c-.42.18-.84.33-1.25.46s-.84.23-1.31.32a22.8,22.8,0,0,1-2.54.44,18.37,18.37,0,0,1-5.12-.16,20.68,20.68,0,0,1-5.05-1.41,23.76,23.76,0,0,1-4.52-2.52,18.81,18.81,0,0,1-3-2.61,9.28,9.28,0,0,1-2-3.44,8.09,8.09,0,0,1-.35-3.36,12.75,12.75,0,0,1,.8-3.26,16.79,16.79,0,0,1,1.57-3.07c.64-1,1.31-1.91,2-2.78.84-1.14,1.73-2.26,2.67-3.38l2.78-3.3q2-2.46,4-5t4.1-4.87c.62-.64,1.25-1.29,1.89-2a18.61,18.61,0,0,1,2-1.84c.63-.52,1.29-1,2-1.49a8.38,8.38,0,0,1,2.25-1.09,7.15,7.15,0,0,1,2.45-.31,5.5,5.5,0,0,1,2.37.74q.09,0,.3.15a24.89,24.89,0,0,1,5.14,3.13,22.85,22.85,0,0,1,4.19,4.32,19.41,19.41,0,0,1,2.25,3.94,16,16,0,0,1,1.19,4.44q.06,1,.06,2a7.28,7.28,0,0,1-.27,1.95A12.41,12.41,0,0,1,146,98a13.19,13.19,0,0,1-2.4,2.5,11.45,11.45,0,0,1-3,1.75,10.21,10.21,0,0,1-3.39.7,7.65,7.65,0,0,1-3.38-.64,42.83,42.83,0,0,0,1,4.27A9.06,9.06,0,0,1,135,111Zm-7.51-16.3a7.31,7.31,0,0,0,3.33,2.44,4.92,4.92,0,0,0,1.89.18,3.51,3.51,0,0,0,1.78-.66A3.06,3.06,0,0,0,136.06,94a5.24,5.24,0,0,0-.45-3.06,5.33,5.33,0,0,0-2.07-2.31q-.21.27-.45.15C132.52,88.53,127.12,93.77,127.52,94.66ZM118.8,104c.19.82,2.44,2.25,3.23,2.68a3.14,3.14,0,0,0,2.38.31,4.64,4.64,0,0,0,2.11-1.29,5.38,5.38,0,0,0,1.3-2.18,5.16,5.16,0,0,0,.23-1.09,2.57,2.57,0,0,0-.16-1.14,3.28,3.28,0,0,0-1.76-1.73c-.1-.08-2-1.64-2.51-1.53S118.6,103,118.8,104Z"
        style={{
          fill: "#213E60",
          transformOrigin: "125.912px 97.0551px",
        }}
        id="el4sqxa8va26q"
        className="animable"
      />
      <path
        d="M124.85,94.8l-.17.21a3.9,3.9,0,0,0-.52.65l-.64.75c-.16.17-.32.33-.47.5a1.2,1.2,0,0,1-.61-.06.46.46,0,0,0-.57.44,3.52,3.52,0,0,1-.31-.35c-.19-.25-.36-.52-.55-.79-.05-.07-.16,0-.12.08a8,8,0,0,1,.59,1.3,2.11,2.11,0,0,0,.16.34c-.12.12-.22.25-.33.38-.36.45-.75.87-1.15,1.29-.13.14-.28.28-.43.43a2.06,2.06,0,0,0-.51-.51,2,2,0,0,0-.74-.51h0l0,0h0a.22.22,0,0,0-.2.39,4.57,4.57,0,0,1,1,1.15.22.22,0,0,0-.16,0,.72.72,0,0,0-.33.34,1.33,1.33,0,0,0-.47-.21,4.14,4.14,0,0,1-.6-.18c-.52-.33-1-.68-1.51-1,0,0,0,0,0,0a7.46,7.46,0,0,0,1,1.19,2.57,2.57,0,0,0,.57.35l.21.1a.36.36,0,0,0-.12.47l.15.3-.08,0a.43.43,0,0,0-.55.53c-.25.49-.39,1-.6,1.52s-.48,1.14-.73,1.71c0,.09.1.14.15.05a14.37,14.37,0,0,1,.76-1.39.07.07,0,0,0,.09,0,.75.75,0,0,0,.34-.41.08.08,0,0,0,.14,0l0-.14c.09-.12.19-.25.27-.38a.27.27,0,0,0,.41.06,5.33,5.33,0,0,0,.46-.49c.27,0,.56-.16.48-.47l0-.11.12-.19a.35.35,0,0,0,.36-.21.49.49,0,0,1,0-.11.35.35,0,0,0,.11-.3l0-.12a.19.19,0,0,0,.19,0A6.73,6.73,0,0,0,121,100l.27-.29.59-.63a3.46,3.46,0,0,0,.49-.53.48.48,0,0,0,0-.35.7.7,0,0,0,.25-.26,1.17,1.17,0,0,0,.09-.24,1.33,1.33,0,0,0,1.32-1.1,7.54,7.54,0,0,1,.29-.88c.08-.18.2-.34.29-.52,0,0,.09-.11.1-.16l.14-.18S124.88,94.76,124.85,94.8Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "120.46px 100.249px",
        }}
        id="elru348aa3uqe"
        className="animable"
      />
      <g id="el5dj5ucm8j3g">
        <path
          d="M117.05,117.13l0,0A.12.12,0,0,0,117,117l-.29-.12a4,4,0,0,0-1.4-.78c-.3-.08-.63-.09-.92-.17l-.36-.16h0c-.3-.22-.47-.58-.76-.81-.53-.43-1.18-.69-1.72-1.11a5.22,5.22,0,0,1-1.46-1.87.54.54,0,0,0-.71-.24l-.19.06a2.36,2.36,0,0,1-.16-1.26l.1,0a5.49,5.49,0,0,0,.63-.34c.42-.25.85-.47,1.26-.72,0,0,0-.07,0,0a8,8,0,0,1-1.33.6l-.58.16c0-.45-.4-.88-.88-.63l-.42.22.14-.53c.11-.4-.3-.86-.67-.71.13-.22.25-.43.39-.64a.45.45,0,0,0,.06-.4l.12,0,.5-.08a2,2,0,0,0,.47-.21,4.51,4.51,0,0,1,1-.25l1-.19s0,0,0,0l-1,.13a3.76,3.76,0,0,1-1.11.09,1.88,1.88,0,0,0-.47,0l-.5.07-.38.06a.25.25,0,0,0-.14-.06.12.12,0,0,0,0-.12s-.06,0-.09,0a.16.16,0,0,1-.09-.07l0,0a.4.4,0,0,0,0-.41,1.45,1.45,0,0,1,.16-.18l.21-.17a1.42,1.42,0,0,0,.24-.25,2.06,2.06,0,0,1,.26-.25,1.38,1.38,0,0,0,.26-.22s0,0,0,0-.27.18-.41.25-.28.12-.42.18a1.36,1.36,0,0,0-.55.49s0,0,0,0a3.35,3.35,0,0,1,.77-1.08.35.35,0,0,0-.07-.55h.08a.39.39,0,0,0,.15-.69l-.29-.2a11.15,11.15,0,0,1,.73-1.19.1.1,0,0,0,0-.09q1.41-2.37,2.74-4.8c0-.05,0-.09-.07-.05-1.3,2.06-2.72,4.07-4.17,6a.34.34,0,0,0,0,.31l-.39,0a.41.41,0,0,0-.23.65l.06,0a.85.85,0,0,0-.2.22.35.35,0,0,0,0,.24,0,0,0,0,0,0,0,3.17,3.17,0,0,0-.46,2.32c0,.17.09.33.14.5a.43.43,0,0,0,.3.46.92.92,0,0,0,.35.38c-.18.35-.35.71-.5,1.07a.51.51,0,0,0,.57.67c.11,0,.21-.08.32-.12l-.18.51a.62.62,0,0,0,.81.77h0a.4.4,0,0,0,.14.22.58.58,0,0,1,0,.14.79.79,0,0,0-.14.37.34.34,0,0,0,.46.33l.43.6a.41.41,0,0,0,.38.13c.36-.06.61.22.87.42s.29.17.42.27.31.23.48.33a4.57,4.57,0,0,0,1.18.48,11.88,11.88,0,0,0,1.23.63c.69.29,1.34.67,2,1l.55.22c.37.16.75.3,1.13.43a7.52,7.52,0,0,1-1.77-.59s-.06,0,0,.06a6.73,6.73,0,0,0,2.58.82C117.08,117.27,117.11,117.18,117.05,117.13Z"
          style={{
            opacity: 0.2,
            transformOrigin: "111.288px 107.622px",
          }}
          className="animable"
          id="elofdcui81rw"
        />
      </g>
      <g id="elp1kqx93553b">
        <path
          d="M129.86,100.7a.07.07,0,1,0-.09-.1l-.61.42,0-.14a.75.75,0,0,0,.13-.69,1,1,0,0,0-.35-.52l0,0a1.18,1.18,0,0,0,.49-.42s0-.1-.07-.06a2,2,0,0,1-.53.38h0a.84.84,0,0,1-.3-.25.38.38,0,0,0-.49-.17l0,0a2,2,0,0,1,.13-.48c0-.07-.08-.13-.12-.06a1.38,1.38,0,0,0-.17.63l-.08.05a.66.66,0,0,0-.48-.17,1.66,1.66,0,0,0-1-1,.07.07,0,0,0,0,.14,1.23,1.23,0,0,1,.65.66,1.64,1.64,0,0,0-.22-.14c-.06,0-.12.08-.06.11s.23.16.35.24a.78.78,0,0,1,0,.21.2.2,0,0,0,.24.16c.1,0,.18,0,.16.12a.31.31,0,0,0,.37.33l.11,0a5.35,5.35,0,0,1,.58.77.17.17,0,0,0,0,.1c.06.29.14.58.21.87s.16.4.22.6a4.85,4.85,0,0,1-.23,1.17v0c-.12.32-.24.63-.37.94,0,.06.08.1.1,0,.14-.33.29-.66.44-1s.36-.63.5-1a2.22,2.22,0,0,0,0-1.35Z"
          style={{
            opacity: 0.2,
            transformOrigin: "128.075px 101.29px",
          }}
          className="animable"
          id="elvnm4gsnyl"
        />
      </g>
      <path
        d="M122.27,107.62a.08.08,0,0,0-.15,0,9.81,9.81,0,0,0-.45,2c0,.17,0,.35-.1.52a4.68,4.68,0,0,1-.18.48,9,9,0,0,1-.48,1,0,0,0,1,0,0,0,8.08,8.08,0,0,0,.52-.9c.1-.19.18-.39.28-.58s.15-.27.22-.42A3.23,3.23,0,0,0,122.27,107.62Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "121.615px 109.594px",
        }}
        id="elz7cqtaivf"
        className="animable"
      />
      <path
        d="M123.22,109c0-.32,0-.64,0-1a.08.08,0,1,0-.16,0q0,.48,0,1c0,.31,0,.62.07.93,0,.06.11.06.11,0C123.23,109.66,123.25,109.35,123.22,109Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "123.15px 108.947px",
        }}
        id="elfu3grqcrit"
        className="animable"
      />
      <path
        d="M133.5,85.53a7,7,0,0,0-.65-2s-.08,0-.07,0a9.2,9.2,0,0,1,.41,2,7.76,7.76,0,0,1,.08,2c0,.1.15.11.16,0A7.86,7.86,0,0,0,133.5,85.53Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "133.156px 85.5694px",
        }}
        id="el85viaxtxx48"
        className="animable"
      />
      <path
        d="M134.82,85.53a1.14,1.14,0,0,0-.24.43c-.06.17-.13.33-.2.49-.13.33-.27.66-.4,1,0,.09.11.14.15,0l.42-1c.07-.15.14-.31.2-.46a1.13,1.13,0,0,0,.16-.5A.05.05,0,0,0,134.82,85.53Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "134.445px 86.5026px",
        }}
        id="elko1ykooe1jd"
        className="animable"
      />
      <path
        d="M132.91,86.67a1.37,1.37,0,0,0-.54.3,3.83,3.83,0,0,0-.28.29,4.78,4.78,0,0,0-1-.73c-.2-.11-.48.07-.36.31a2.44,2.44,0,0,0,.14.28c-.18,0-.34.22-.19.38a.37.37,0,0,1,.07.4c-.09.19-.21.37-.31.56s-.21.41-.32.62-.16.19-.23.29h-.13l-.07,0-.82-.5c-.15-.1-.38.06-.28.24s.34.63.53.93a.25.25,0,0,1-.19,0c-.11-.06-.24.07-.15.17a.72.72,0,0,1,.13.51,1.63,1.63,0,0,0-.09.19.07.07,0,0,0,0,.1.93.93,0,0,1-.39.48c-.09,0,0,.19.06.14a1,1,0,0,0,.52-.74,5.72,5.72,0,0,1,.32-.48,1.11,1.11,0,0,1,.32-.21c.07,0,0-.12,0-.15l.07-.07.08.06,0,0h0s.06,0,.11,0a.24.24,0,0,0,.25-.17h.08a.28.28,0,0,0,.22-.45c.2-.24.4-.47.62-.69a4.94,4.94,0,0,0,.86-.91s0-.06,0-.08a.25.25,0,0,0,.29-.06c.23-.3.52-.54.75-.83C133.14,86.81,133,86.63,132.91,86.67Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "130.722px 89.0677px",
        }}
        id="elzanh7ncamh"
        className="animable"
      />
      <path
        d="M146.85,93.41a16.55,16.55,0,0,0-.56-2.87s0,0,0,0a8.76,8.76,0,0,1,.15,1.77s0,0,0,0,0,.1,0,.15a1.84,1.84,0,0,1-.06.41,6.25,6.25,0,0,1-.8,2,2.39,2.39,0,0,0-.13.21,3.34,3.34,0,0,0-.68-.82q-.49-.45-1-.87s-.08,0-.05.06c.23.27.47.51.69.78a2.28,2.28,0,0,1,.55.76c.17.67-.42,1.2-.83,1.65-.23.25-.47.5-.69.77s-.27.32-.41.47a.56.56,0,0,1-.26.12h-.08a.83.83,0,0,0-.08-.22,2.27,2.27,0,0,0-.84-.66,10.64,10.64,0,0,1-1.21-.75c-.05,0-.1,0-.06.08a8.3,8.3,0,0,1,.88.9c.21.22.49.63.79.71a.24.24,0,0,0-.32.21.45.45,0,0,0-.11.24,2.19,2.19,0,0,1-.55,1.48,5.61,5.61,0,0,1-1.4.86,5.76,5.76,0,0,1-3.29.54c-.1,0-.11.16,0,.15a11.7,11.7,0,0,0,3.72-.47,5.46,5.46,0,0,0,1.7-.82,2,2,0,0,0,.48-.82,1.13,1.13,0,0,0,.1-.13A.46.46,0,0,0,143,99a1.27,1.27,0,0,0,1.21-.81,1,1,0,0,0,.75-.59c.06-.13.08-.31.15-.43s.39-.24.57-.41.24-.53.3-.85a6.63,6.63,0,0,1,.65-1.27A2.72,2.72,0,0,0,146.85,93.41Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "141.638px 96.0436px",
        }}
        id="elakw9e6wswct"
        className="animable"
      />
      <g id="elv7k5f94jfcq">
        <path
          d="M134.37,76.36a5.12,5.12,0,0,0-1.69-1.27l-.06-.28c0-.1-.18-.07-.15,0l0,.17c-.09,0-.17-.09-.26-.12A.21.21,0,0,0,132,75l-.2-.16a.3.3,0,0,0-.42.07.11.11,0,0,1-.16.06.3.3,0,0,0-.27.13l-.24-.1c-.26-.11-.47.19-.38.42,0-.09-.09,0-.16,0a1.86,1.86,0,0,0-.19.11.78.78,0,0,0-.25.32.51.51,0,0,0,0,.2l-.7.43c-.17.1-.32.22-.48.33s-.5.39-.74.6.07.53.29.34a12.09,12.09,0,0,1,1.16-.87,6.89,6.89,0,0,1,.73-.34l.27.05c.1,0,.12-.15,0-.15h-.06a.2.2,0,0,0,.11-.13.14.14,0,0,0,.11,0c.21-.13.42-.27.61-.41a2.64,2.64,0,0,1,.52.92.2.2,0,0,0,.21.13c-.05.2-.1.41-.14.61a1.55,1.55,0,0,0,.07,1.08,2.18,2.18,0,0,1,.14,1.53c0,.05.06.07.07,0a3.08,3.08,0,0,0,.09-.85c0-.3-.12-.58-.17-.88s.15-.61.3-.94a1.74,1.74,0,0,0,.14-.84c0-.22-.05-.44-.09-.65a2.19,2.19,0,0,0,.36,0,.26.26,0,0,0,.21-.19l.12.58a7.09,7.09,0,0,0,.4,1.52,0,0,0,0,0,.06,0A7.34,7.34,0,0,0,133,76.4c-.06-.25-.12-.51-.17-.76.49.26,1,.55,1.44.86C134.33,76.55,134.44,76.44,134.37,76.36Z"
          style={{
            opacity: 0.2,
            transformOrigin: "131.058px 77.4805px",
          }}
          className="animable"
          id="elesyxvyp533g"
        />
      </g>
      <path
        d="M133.83,110c0-.8.27-1.89-.48-2.44h0c-.09-.06-.17.05-.12.13a1.73,1.73,0,0,1,.2.41,2.26,2.26,0,0,1-.17,1,4.74,4.74,0,0,0-.16.65c0,.1,0,.21,0,.31,0,.3-.08.19-.22.34a1.77,1.77,0,0,0-.39.92,2.68,2.68,0,0,1-.07.27l-.21.34c0,.06-.23.45-.3.47s-.19,0-.28-.15a3.3,3.3,0,0,0-1.17-.73.13.13,0,0,0-.16.18,2.24,2.24,0,0,0,.4.53c.15.14.56.3.62.52s-.1.62-.11.86a3.35,3.35,0,0,1-.13.78,8.87,8.87,0,0,1-.55.81,10.21,10.21,0,0,1-.77.69,3.66,3.66,0,0,1-.52.28,6.79,6.79,0,0,0-1.12.54c-.08.06,0,.18.1.12a3.51,3.51,0,0,1,.72-.37l-.25.17.35-.21.08,0-.32.22s-.26.15-.27.17l.06-.07-.18.15s0,.07,0,0a7.2,7.2,0,0,0,1.37-.78,2.91,2.91,0,0,0,1.17-.73,10.06,10.06,0,0,0,1.92-2.7c.22-.5.26-1,.43-1.53.07-.23.31-.34.42-.56A1.2,1.2,0,0,0,133.83,110Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "130.982px 112.232px",
        }}
        id="elptx345e87ko"
        className="animable"
      />
      <path
        d="M128.56,116.77a.39.39,0,0,0,.1-.08Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "128.61px 116.73px",
        }}
        id="el1i1gv9tcl8nh"
        className="animable"
      />
      <path
        d="M156.09,126.67a39.56,39.56,0,0,1-2.12,4.86,12.16,12.16,0,0,1-3.35,4,8.52,8.52,0,0,1-1.58,1,7.85,7.85,0,0,1-1.78.66,4.92,4.92,0,0,1-1.79.11,3.68,3.68,0,0,1-1.72-.69,4.24,4.24,0,0,1-1.36-1.69,8.69,8.69,0,0,1-.59-2.08,13.17,13.17,0,0,1-.18-2.88c0-1,.13-1.91.25-2.83a30.53,30.53,0,0,1,1.11-4.55c.48-1.45.93-2.93,1.36-4.44q1-3.48,1.9-7a59.34,59.34,0,0,1,2.29-6.86,30.19,30.19,0,0,1,1.41-3.33,24,24,0,0,1,1.83-3.14,21.47,21.47,0,0,1,2-2.35,7.6,7.6,0,0,1,2.49-1.68,7.07,7.07,0,0,1,3.39-.6A11.26,11.26,0,0,1,163,94a8.41,8.41,0,0,1,1.3.73,2.93,2.93,0,0,1,1,1.1,4,4,0,0,1,.48,2.68,5.82,5.82,0,0,1-.27,1.66c-.16.53-.34,1.07-.53,1.61a21.32,21.32,0,0,1-.81,2.14c-.32.71-.61,1.44-.9,2.18-.71,1.81-1.39,3.6-2.06,5.36S159.8,115,159,116.77c-.4,1.66-.82,3.33-1.27,5A50.28,50.28,0,0,1,156.09,126.67Z"
        style={{
          fill: "#213E60",
          transformOrigin: "153.721px 115.249px",
        }}
        id="elimyt7skdpee"
        className="animable"
      />
      <path
        d="M157.21,118.31a.31.31,0,0,0-.06-.16,28.45,28.45,0,0,1,1.23-3.5,0,0,0,1,0-.06,0c-.51,1.09-1.06,2.18-1.47,3.32a.28.28,0,0,0-.34.22,57.75,57.75,0,0,1-1.87,5.76c-.06.1-.13.19-.19.28a.41.41,0,0,0-.12.14l0,0s0,0,0,0c-.87-.2-1.74-.4-2.6-.62-.23,0-.36.29-.13.35a2.29,2.29,0,0,1,1.74,1.69,2.05,2.05,0,0,1,0,.7,1,1,0,0,0-.06.19c-.1.35-.19.7-.29,1l-.62.1a.47.47,0,0,0-.51-.12.33.33,0,0,0-.27.39,3.06,3.06,0,0,1,.11.89l-.09.14a1.2,1.2,0,0,0-.27.24.26.26,0,0,0,0,.28,3.73,3.73,0,0,0-.16.35l-.07,0a.48.48,0,0,0-.34.28.65.65,0,0,0-.15-.1,2.43,2.43,0,0,0-.88-.18,3,3,0,0,1-.43-.08s-.55-.25-.41-.31a0,0,0,0,0,0,0c.13,0,0-.22-.11-.16s0,.23,0,.31a1,1,0,0,0,.4.35,9.51,9.51,0,0,0,1.15.46,1.07,1.07,0,0,1,.44.36,3.73,3.73,0,0,1-.34.35,1.6,1.6,0,0,1-.3.23h-.27a.47.47,0,0,0-.21,0,.16.16,0,0,0-.08-.24,2.3,2.3,0,0,0-.81-.14,9.64,9.64,0,0,1-1.49-.4c-.13-.07-.22.16-.08.22a7,7,0,0,0,1,.37h0c-.06.39.54.58.8.75a1,1,0,0,1,.45.53s0,0,0,0c-.5.41-1,.79-1.54,1.16l0,0c-.28.15-.61.24-.88.39s-.25.23-.46.28a2.22,2.22,0,0,1-.77,0c-.09,0-.12.12,0,.15a7.55,7.55,0,0,0,.8.16,4.67,4.67,0,0,1-.93.45.12.12,0,0,0,0,.23,8.22,8.22,0,0,0,1.91-.55.44.44,0,0,0,.19.17c.45.19,1.08-.36,1.42-.58a11,11,0,0,0,2.19-1.91.33.33,0,0,0,.51,0l1.06-2c.69-1,1.29-2.09,1.89-3.19a3.12,3.12,0,0,0,.37-1.8,2.46,2.46,0,0,1,.16-1.23,9.28,9.28,0,0,1,.58-1,5.66,5.66,0,0,0,.73-1.76,5.2,5.2,0,0,0,.09-1A8.3,8.3,0,0,0,157.21,118.31Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "151.982px 125.01px",
        }}
        id="elqw212nqp2ng"
        className="animable"
      />
      <path
        d="M162.46,98.3a5.48,5.48,0,0,0-2.07.43s0,0,0,0a4.84,4.84,0,0,1,2-.32,4.58,4.58,0,0,1,.91.18h.07a1.28,1.28,0,0,1,.07.35,2.33,2.33,0,0,1-.09.58c-.11.4-.24.79-.35,1.19s-.2.82-.31,1.23a.15.15,0,0,0-.18.09c-.14.43-.28.86-.45,1.28-.08.21-.16.42-.25.63a2.74,2.74,0,0,1-.3.7c-.28.33-.74,0-1.1-.17,0-.06-.07-.12-.1-.19s-.32,0-.25.12h0a3.3,3.3,0,0,0-.7,0s0,0,0,.06a3.38,3.38,0,0,0,1,.42,1.56,1.56,0,0,0,.16.2c.12.11.31.18.41.29s.11.49.08.72,0,.18,0,.27-.07.08-.11.11a2.55,2.55,0,0,1-.38.26.92.92,0,0,0-.23-.09l-.77-.24a1.2,1.2,0,0,0-.23-.22A1.82,1.82,0,0,0,158,106s0,0,0,.06c.56.26,1.13.5,1.66.81a.46.46,0,0,0,.3.22h0a1.2,1.2,0,0,1,.42,1.07c-.07.14-.13.3-.21.44a.24.24,0,0,0,0,.29,6.7,6.7,0,0,0-.73,2.08c0,.1.15.11.15,0a4.44,4.44,0,0,1,.78-2,.34.34,0,0,0,.13-.09,3.2,3.2,0,0,0,.38-.67,15.93,15.93,0,0,0,1.16-2.52,12.32,12.32,0,0,0,.47-1.68c.06-.34.1-.67.13-1,.21-.62.43-1.24.63-1.87.13-.39.25-.8.37-1.2.07-.21.13-.43.19-.64a1.43,1.43,0,0,0,.09-.41C164,98.16,162.87,98.3,162.46,98.3Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "160.962px 104.669px",
        }}
        id="elills4pce1nh"
        className="animable"
      />
      <path
        d="M163.3,97.57a1.55,1.55,0,0,0-1.1-.1c-.06,0,0,.13,0,.11a1.32,1.32,0,0,1,1,.13A.08.08,0,1,0,163.3,97.57Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "162.755px 97.5693px",
        }}
        id="els6j7yo076rd"
        className="animable"
      />
      <g id="el6l462qre0s4">
        <path
          d="M151.29,110.29a3,3,0,0,0-.76-.33,7.49,7.49,0,0,0-.81-.23,1.28,1.28,0,0,0-.43-.06.36.36,0,0,0-.15-.41,1.42,1.42,0,0,1-.12-.13,1.44,1.44,0,0,1,.13-.31.71.71,0,0,0,.35-.41v0l0,0,.14-.11a2.06,2.06,0,0,1,.63-.35,2.72,2.72,0,0,1,.75-.11c.06,0,.13-.1.05-.14a1.53,1.53,0,0,0-1.62.33.75.75,0,0,0-.13-.25l.36-.26a.26.26,0,0,0,.09-.27,3.65,3.65,0,0,1,.23-2.06,11.27,11.27,0,0,0,.49-1.72,12.5,12.5,0,0,1,1.49-3.9,0,0,0,1,0,0,0c-.76,1.22-1.46,2.5-2.12,3.77a7,7,0,0,0-.61,2.06,4.55,4.55,0,0,0-.05,1.8l-.46.39a.26.26,0,0,0,.08.44c0,.4-.18.56-.44.47a.28.28,0,0,0-.29.32,2.45,2.45,0,0,0,.11.41l-.18,0a.42.42,0,0,0-.33.37,1.72,1.72,0,0,0,0,.56,8.42,8.42,0,0,0-1,2.76,11.43,11.43,0,0,0-.36,1.74,17.9,17.9,0,0,1-.57,2.18c0,.1.11.15.14.06.19-.54.36-1.08.59-1.6s.58-1.07.82-1.64.37-1.07.56-1.6a7,7,0,0,1,.41-1,2.61,2.61,0,0,1,.24-.23,3.84,3.84,0,0,1,.53-.28l.29-.14a1.69,1.69,0,0,0,.29-.17,1.67,1.67,0,0,1,1.57.2S151.33,110.31,151.29,110.29Z"
          style={{
            opacity: 0.2,
            transformOrigin: "148.87px 108.258px",
          }}
          className="animable"
          id="elh2mhehqxuym"
        />
      </g>
      <path
        d="M239.34,115.42a4.7,4.7,0,0,1-1.42,3.9,6.14,6.14,0,0,1-3.52,1.84c-1.38.21-2.7.4-4,.57-.92.08-1.87.2-2.82.34a9.2,9.2,0,0,1-2.82,0,1.27,1.27,0,0,0-.36-.07,1,1,0,0,1-.36-.07,68.58,68.58,0,0,0,1.14,8.63,47.74,47.74,0,0,1,.87,8.63q.06,1.13.09,2.19c0,.7,0,1.41.08,2.12s.06,1.48.05,2.19a18.54,18.54,0,0,1-.14,2.19c-.1.66-.22,1.32-.38,2a7.49,7.49,0,0,1-.77,1.92,6.82,6.82,0,0,1-3.27,2.83,6.41,6.41,0,0,1-1.86.49,3.8,3.8,0,0,1-3.24-1.35,11.36,11.36,0,0,1-1.05-1.43,12.45,12.45,0,0,1-1.24-3.72,17.67,17.67,0,0,1-.45-2.73c-.08-.92-.16-1.83-.25-2.72s-.14-2-.18-3.11-.07-2.1-.11-3.12,0-2,0-3.05,0-2,0-3c-.08-1.46-.15-2.92-.2-4.38a38.57,38.57,0,0,1,.06-4.31c-.67,0-1.33,0-2-.05s-1.33-.06-2-.11a37.2,37.2,0,0,1-4-.62,15.21,15.21,0,0,1-1.59-.37,8.15,8.15,0,0,1-1.52-.64,7.88,7.88,0,0,1-1.75-1.24,5.94,5.94,0,0,1-1.29-1.7,4.67,4.67,0,0,1,0-3.52,8.14,8.14,0,0,1,2.31-3.2,12.23,12.23,0,0,1,3.29-2.07,9.05,9.05,0,0,1,2.53-.64,21.87,21.87,0,0,1,2.58-.12c1.07,0,2.13,0,3.19.12a30.68,30.68,0,0,0,3.18.05c.53,0,1.06,0,1.59-.05l1.59-.13c.53,0,1.07-.07,1.6-.09l1.59,0q1.59,0,3.21.09c1.09,0,2.16.12,3.22.22a18.06,18.06,0,0,0,2.65.08,9.2,9.2,0,0,1,2.65.28,7.83,7.83,0,0,1,1.16.37,5.09,5.09,0,0,1,1.09.64,13.47,13.47,0,0,1,1.45,1.6,10,10,0,0,1,1,2.06A8.44,8.44,0,0,1,239.34,115.42Z"
        style={{
          fill: "#213E60",
          transformOrigin: "219.032px 131.477px",
        }}
        id="elhy36q4ec6q5"
        className="animable"
      />
      <g id="eli2513a2dakf">
        <path
          d="M219.29,153.19a3.76,3.76,0,0,1-1.28-.78l.07,0a.12.12,0,0,0,0-.2,4.22,4.22,0,0,1-1-1.38.46.46,0,0,1,.14-.05c.21,0,.14-.3,0-.36a2.93,2.93,0,0,1-.42-.24l-.1-.25a.14.14,0,0,1,.07-.06.32.32,0,0,0,.07-.58l-.09-.07.21-.15a.4.4,0,0,0,0-.68l-.27-.17.09-.07c.26-.17.26-.68-.11-.73s-.33-1-.41-1.28a3.16,3.16,0,0,0-.49-1c.32-.26.64-.53,1-.77a3.28,3.28,0,0,0,1.27-.69c.08-.07,0-.21-.08-.18a10.8,10.8,0,0,0-1.74.63.27.27,0,0,1-.11-.05.63.63,0,0,1-.29-.41c0-.28.19-.57.23-.82a2.59,2.59,0,0,0-.37-1.39,1,1,0,0,0,.11-.44c0-.23-.14-.51-.06-.73a2,2,0,0,1,.3-.4.81.81,0,0,0,.19-.46.08.08,0,0,0,0,0l.1-.07c.13-.08.26-.14.37-.22a4,4,0,0,1,.69-.15,11,11,0,0,1,1.62-.05,0,0,0,0,0,0-.06,11.12,11.12,0,0,0-2.08,0l.06-.09a0,0,0,0,0-.07,0,.9.9,0,0,1-.18.16l-.37.07c-.41.1-.83.24-1.11-.17a0,0,0,0,0,0,0,10.87,10.87,0,0,1-.12-1.28s0,0,0-.05a2.44,2.44,0,0,0,0-.47v-.09l.07,0a4,4,0,0,0,.66-.47.4.4,0,0,0,.28-.24c.08-.19-.15-.41-.31-.23s-.58,0-.8.16c-.07-.77-.16-1.54-.22-2.31s-.07-1.49-.09-2.24a0,0,0,1,0-.07,0c0,1,0,2-.08,3.06a10,10,0,0,0,.14,2.31c0,.2,0,.4,0,.61,0-.05,0-.08-.07-.09a45.06,45.06,0,0,1-.1-5.57s0,0,0,0a65.63,65.63,0,0,0,.08,10.95,30,30,0,0,0,.57,3.28,14.21,14.21,0,0,0,.37,2.76,14.62,14.62,0,0,0,1,2.78,1.35,1.35,0,0,0,1.33.87,4.22,4.22,0,0,0,1.43.78S219.32,153.2,219.29,153.19Z"
          style={{
            opacity: 0.2,
            transformOrigin: "216.835px 142.5px",
          }}
          className="animable"
          id="elg8tgx9al92f"
        />
      </g>
      <path
        d="M222.67,151a2.54,2.54,0,0,0-.27-.69c-.13-.23-.24-.46-.35-.7a16.38,16.38,0,0,1-.65-1.69s-.06,0-.05,0a13.21,13.21,0,0,1,.66,2.76,5.18,5.18,0,0,1,.09,1.18c0,.41-.13.87-.6,1-.1,0,0,.19.07.14a2.54,2.54,0,0,0,.88-.68A1.72,1.72,0,0,0,222.67,151Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "222.033px 150.464px",
        }}
        id="elizotnv7bwxj"
        className="animable"
      />
      <path
        d="M223.64,150.33a6.36,6.36,0,0,0-.14-.76,6.24,6.24,0,0,0-.58-1.42c0-.08-.16,0-.12.08a8.41,8.41,0,0,1,.46,1.42,8.88,8.88,0,0,1,.23,1.46.07.07,0,0,0,.15,0A5.08,5.08,0,0,0,223.64,150.33Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "223.224px 149.651px",
        }}
        id="ele3dd471qgm6"
        className="animable"
      />
      <g id="el9otd066a3p">
        <path
          d="M218.77,120.18a6.78,6.78,0,0,0-1.19,0c.34-.08.68-.16,1-.26,0,0,0-.05,0,0a16.61,16.61,0,0,1-2.53.38c-.33,0-.67,0-1,0l-.2,0c-.59-.11-1.22-.46-1.81-.27a1.9,1.9,0,0,1-.38.13.16.16,0,0,1-.1,0l-.2,0a.65.65,0,0,0-.21-.07.4.4,0,0,0-.11,0l-.43-.09-1.2-.24a1.23,1.23,0,0,1-.57-.75.34.34,0,0,0-.11-.17l.08-.12a.68.68,0,0,0,.07-.2c0-.12.1-.25.15-.37s.09-.26.14-.38-.06-.09-.09,0l-.47.55-.12.11a1.13,1.13,0,0,0-.12.18c-.05.09-.09.18-.14.26a.47.47,0,0,0-.16.21L209,119c-.18-.21-.36-.42-.53-.64l-.07-.06a2.57,2.57,0,0,0,.08-.4,2,2,0,0,0-.05-.72,3,3,0,0,1-.08-.79,2,2,0,0,1,.42-1.31s0-.07,0,0a1.54,1.54,0,0,0-.53,1c0,.24-.05.48-.07.71a2.47,2.47,0,0,1-.29.84,3.42,3.42,0,0,0-.29.75,1.5,1.5,0,0,1-.2.56l-.23.35a1.25,1.25,0,0,0-.61,0,1.33,1.33,0,0,0-.9-.49,1.55,1.55,0,0,0-.79.17c-.24.1-.22.11-.48,0l-.67-.27-.35-.14a6.36,6.36,0,0,0-1.19-.8.12.12,0,0,0-.13,0c-.12-.09-.23-.17-.34-.27l.15-.12a2.47,2.47,0,0,0,.36-.49,1,1,0,0,1,.13-.22c.06-.06.12-.13.18-.18a2,2,0,0,1,.46-.32s0-.08,0-.06a1.61,1.61,0,0,0-.38.16l0,0,.68-.75h0l-.7.73,0,0s0-.09-.05-.06a1.57,1.57,0,0,1-.46.2l-.23,0-.29,0-.25,0a.78.78,0,0,1-.22,0l-.11,0a2.38,2.38,0,0,1,0-2.06.08.08,0,1,0-.15-.06,3.51,3.51,0,0,0-.15,1.4l0-.18c-.06-.63-.14-1.26-.22-1.89a0,0,0,0,0-.06,0c0,.29,0,.58,0,.87,0-.06-.09-.08-.11,0a3.62,3.62,0,0,0,.66,3.47,4.09,4.09,0,0,0,1.52,1.21c.15.07.36.12.49.2s.32.31.5.46a2.26,2.26,0,0,0,.87.45,16.2,16.2,0,0,0,2.6.42c1,.11,1.92.19,2.88.23a21.59,21.59,0,0,0,3.41-.18h.09a12.58,12.58,0,0,0,1.84-.16l.83-.12.5,0a4.63,4.63,0,0,1,2.42-.05s0,0,0,0a2.47,2.47,0,0,0-.89-.21,5.65,5.65,0,0,1,.92,0S218.8,120.18,218.77,120.18Z"
          style={{
            opacity: 0.2,
            transformOrigin: "209.507px 117.249px",
          }}
          className="animable"
          id="el8xg7wy606k7"
        />
      </g>
      <g id="elp2okshpzxu9">
        <path
          d="M202.58,114.66l-1.37,1.08a.08.08,0,1,0,.1.12l1.32-1.14S202.62,114.64,202.58,114.66Z"
          style={{
            opacity: 0.2,
            transformOrigin: "201.898px 115.274px",
          }}
          className="animable"
          id="el2mcx00u1i7s"
        />
      </g>
      <path
        d="M237.88,117.07c0-.2,0-.41,0-.61a1.16,1.16,0,0,0,0-.18,2.64,2.64,0,0,0,0-.74c0-.25,0-.5.05-.75a.05.05,0,0,0-.1,0,1.89,1.89,0,0,0-.05.23l-.12-.42a7.29,7.29,0,0,0-.64-1.53c0-.06-.11,0-.08,0,.4.91.85,2.21.32,3.15a5.11,5.11,0,0,1-.88,1h0a2.14,2.14,0,0,1-.85-1.07c0-.05-.1,0-.08,0l.32.84a4.2,4.2,0,0,1,.26.78,1,1,0,0,1-.13.37,2,2,0,0,1-.23.18,4.37,4.37,0,0,0-.44.31,1.32,1.32,0,0,1-.71.15.5.5,0,0,0-.1-.21.8.8,0,0,0-.27-.18c-.09,0-.26-.06-.3-.16a.15.15,0,0,0-.2-.08l-.16-.17a1.71,1.71,0,0,0-.72-.79.06.06,0,0,0-.08.09c.22.48.34,1,.53,1.48a1.15,1.15,0,0,1,.12.37l-.09,0a1.92,1.92,0,0,1-.57.29c-.46.2-.9.42-1.38.58a15.07,15.07,0,0,1-1.5.41.08.08,0,1,0,0,.15,12.2,12.2,0,0,1,2.16-.37,5.3,5.3,0,0,0,1.73-.15.9.9,0,0,0,.36-.31l.46-.09.17,0h.4a3.33,3.33,0,0,0,1.73-.92,6.25,6.25,0,0,0,.85-.69A1.24,1.24,0,0,0,237.88,117.07Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "233.811px 116.804px",
        }}
        id="elhpt47mvgx68"
        className="animable"
      />
      <path
        d="M223.11,111.5c0-.21,0-.41,0-.61s0-.4-.05-.6,0-.39,0-.6a.88.88,0,0,0-.27-.56,1.62,1.62,0,0,0-.89-.4,6.14,6.14,0,0,0-2,.17c-.53.09-1,.16-1.57.21l-.43-.06a5.41,5.41,0,0,0-1.68.3,2.7,2.7,0,0,1-1,0,.74.74,0,0,0-.53.08c-.07,0,0,.16.05.13a1.6,1.6,0,0,1,.89.06,1.73,1.73,0,0,0,.64,0l.53-.1s0,0,0,0a1.93,1.93,0,0,1,1.14,0c.24.07.6.21.64.5a.3.3,0,0,0,.55.14,2,2,0,0,1,1.29-.71,5,5,0,0,1,.86.15,1.88,1.88,0,0,1,.3.12c.13.15.25.31.37.47s.14,0,.1-.06-.08-.13-.11-.2a1.55,1.55,0,0,1,.51.65c.13.35.32.68.43,1a7,7,0,0,1,.15,1.21s0,0,0,0C223.2,112.35,223.11,111.92,223.11,111.5Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "218.897px 110.75px",
        }}
        id="elkicscjpb6wp"
        className="animable"
      />
      <path
        d="M224.24,110.44a2.51,2.51,0,0,0-.15-.67l-.13-.33c-.05-.11-.12-.21-.16-.32a.08.08,0,1,0-.15,0c0,.13,0,.25,0,.37s0,.2,0,.3a4,4,0,0,0,.1.68c.05.21.12.41.17.63a5,5,0,0,0,.16.64,0,0,0,0,0,.08,0,2.94,2.94,0,0,0,.05-.66A5.12,5.12,0,0,0,224.24,110.44Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "223.943px 110.376px",
        }}
        id="el72ozgtkn2yu"
        className="animable"
      />
      <path
        d="M192.23,141.55a16.73,16.73,0,0,1,.13,3,5.75,5.75,0,0,1-.87,2.84,4.3,4.3,0,0,1-2.09,1.72,5.38,5.38,0,0,1-2.76.3,4.2,4.2,0,0,1-2.29-1.09,7.78,7.78,0,0,1-1.61-2.11,14.84,14.84,0,0,1-1.26-3,31.38,31.38,0,0,1-.75-3.23c-.12-.56-.26-1.21-.43-1.94l-.53-2.27c-.19-.78-.36-1.54-.53-2.3a19.3,19.3,0,0,1-.35-2,9.29,9.29,0,0,1-.23-1.53,10.54,10.54,0,0,0-.24-1.53,4.82,4.82,0,0,0-1.41-.08,4.43,4.43,0,0,0-.32.95c-.06.31-.12.63-.19,1a21.25,21.25,0,0,0-.48,2.58,15.54,15.54,0,0,1-.53,2.56c-.24.76-.47,1.54-.67,2.34s-.42,1.57-.66,2.33c-.16.38-.32.76-.46,1.16a9.23,9.23,0,0,1-.53,1.15,7.08,7.08,0,0,1-1.73,1.89,6.46,6.46,0,0,1-1.65,1,3.67,3.67,0,0,1-1.91.27,3.94,3.94,0,0,1-1.59-.69,7,7,0,0,1-1.22-1.15,10.32,10.32,0,0,1-1.81-3.7,12.45,12.45,0,0,1-.45-4c.1-1,.23-1.93.39-2.87s.32-1.88.46-2.85.4-2,.6-3,.42-2,.66-3q1.41-6.15,3.19-12.08c.36-1.37.75-2.76,1.19-4.16a15.42,15.42,0,0,1,1.81-3.9,13.66,13.66,0,0,1,1-1.42,6.21,6.21,0,0,1,1.31-1.17,7,7,0,0,1,3.42-1.22,14,14,0,0,1,2.33,0,18.82,18.82,0,0,1,2.34.33c.86.21,1.73.44,2.6.68a22.84,22.84,0,0,1,2.57.87c.08,0,.14,0,.15.07a.37.37,0,0,0,.16.06,1.39,1.39,0,0,1,.51.17.19.19,0,0,1,.09,0,.13.13,0,0,0,.09.05c.58.25,1.15.52,1.7.81s1.11.6,1.67.94a10.12,10.12,0,0,1,2.3,2.07,10.53,10.53,0,0,1,1.65,2.93,18.38,18.38,0,0,1,.74,10.32,20.76,20.76,0,0,1-1,3.27,12.94,12.94,0,0,1-1.66,3,9.25,9.25,0,0,1-2.4,2.27,8.72,8.72,0,0,1-3.15,1.23l0,.07a17.79,17.79,0,0,1,1.07,1.8c.33.63.63,1.26.91,1.9s.47,1.18.77,1.94.58,1.52.83,2.3.48,1.53.7,2.29S192.12,140.94,192.23,141.55ZM182,121.75a5,5,0,0,0,1.49-.18,2.92,2.92,0,0,0,1.9-1.78,3.68,3.68,0,0,0-.14-2.74,4.24,4.24,0,0,0-1.8-2.17,4.58,4.58,0,0,0-2.82-.43c-.63.65-2.18,6-2,6.31S181.45,121.74,182,121.75Z"
        style={{
          fill: "#213E60",
          transformOrigin: "179.476px 124.887px",
        }}
        id="elzhb9yk1ruha"
        className="animable"
      />
      <path
        d="M174.8,130.16c.06-.29.13-.57.18-.85a0,0,0,0,0-.07,0,1.8,1.8,0,0,0-.08.21.18.18,0,0,0-.35,0c-.07.52-.16,1-.25,1.56l-.59,1.55a1.37,1.37,0,0,1-1.57.52c-.23-.09-.42.25-.2.38.49.31.92.62.95,1.24a2.18,2.18,0,0,0-.16,1s0,.06,0,.09a.75.75,0,0,1,0,.16l0,0-.55.25c-.71-.21-1.5-.28-2.22-.46h0c-.07,0-.1.1,0,.12l1.05.35a3.31,3.31,0,0,1,.33.15,1.83,1.83,0,0,1,.26.16.5.5,0,0,0-.08.7,1.83,1.83,0,0,1,.21,1.61,8,8,0,0,1-.47,1.74,3.47,3.47,0,0,1-2.26,2.23c-.09,0-.06.18,0,.15a5.09,5.09,0,0,0,3.13-2.14,6.54,6.54,0,0,0,.68-2.24c.25-.56.48-1.12.68-1.7a1.35,1.35,0,0,0,.51-.36.84.84,0,0,0,.08-.85,2,2,0,0,1-.11-.31,29.17,29.17,0,0,0,.84-4.24A9.66,9.66,0,0,0,174.8,130.16Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "171.927px 136.167px",
        }}
        id="elq8pn7cc9ww"
        className="animable"
      />
      <path
        d="M182.93,112.81c-.34,0-.68,0-1,0a6.28,6.28,0,0,0-1.06-.14,1.48,1.48,0,0,0-.75.22.17.17,0,0,0-.17,0l-.08.07a.19.19,0,0,0,0-.13.22.22,0,0,0-.07-.06.14.14,0,0,1,0-.07,3.67,3.67,0,0,0,.11-.81,7.71,7.71,0,0,1,0-1,2.84,2.84,0,0,1,.29-1s0,0,0,0a2.78,2.78,0,0,0-.31.83c-.07.33-.16.64-.24,1,0,.1,0,.51-.1.91a1.39,1.39,0,0,0-.4-.06c-.1,0-.19.12-.11.2a.66.66,0,0,1,.17.24.57.57,0,0,0-.26,0,.36.36,0,0,1,0-.09c.08,0,.15-.1.09-.2-.28-.51-.62-1-.94-1.43l-.06,0a12.13,12.13,0,0,0-.75-1c-.06-.08-.19,0-.11.1s.14.17.22.25a5.79,5.79,0,0,0,.34.71.18.18,0,0,0-.07.2,6.94,6.94,0,0,0,.42,1.1l.27.61c0,.11.47,1,0,.9-.15,0-.25.12-.28.24-.07.38-.08,1-.42,1.15a2.11,2.11,0,0,1-1.24-.08.28.28,0,0,0-.26.49,9.76,9.76,0,0,1,1,.76c-.35,0-.86,0-1,0-.41,0-.72.57-.3.82a5.57,5.57,0,0,1,1,.75.93.93,0,0,0-.16.41,1.26,1.26,0,0,0,0,.51c.1.41.11.53-.25.85a.36.36,0,0,0-.08.39c.56,1.11-.74,2.2-.69,3.32a.08.08,0,1,0,.15,0c-.13-1.24,1.32-2,1.22-3.14,0,0,0,0,.06,0l.1-.3a1.13,1.13,0,0,0,.32-.46,2.1,2.1,0,0,0,0-.51c.07-.21.13-.43.21-.63a.46.46,0,0,0,.18-.56c.1-.28.2-.56.29-.85v0s0,0,0-.07a3.74,3.74,0,0,0,.26-1.27.41.41,0,0,0,0-.11l0,0,0-.06a4.66,4.66,0,0,1,.88-1.18c.18-.17.37-.34.56-.49a3,3,0,0,0,.58-.54.14.14,0,0,0,0-.2.54.54,0,0,1,.27-.07c.23,0,.46,0,.7,0s.5-.13.76-.16a8.54,8.54,0,0,1,.86-.07S183,112.81,182.93,112.81Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "179.37px 116.884px",
        }}
        id="el9308ssu3895"
        className="animable"
      />
      <path
        d="M177.3,113c-.39-.41-.73-.87-1.13-1.28a8.42,8.42,0,0,0-1.27-1.11c-.07-.06-.17.05-.1.12l1.22,1.16a9.56,9.56,0,0,1,1.17,1.21C177.24,113.17,177.37,113.06,177.3,113Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "176.048px 111.858px",
        }}
        id="eltnae490bj6"
        className="animable"
      />
      <g id="el702463aafwq">
        <path
          d="M188.79,113.85a4.28,4.28,0,0,1-.85.85,2.25,2.25,0,0,1-.53.28,3.51,3.51,0,0,0-.48.22c-.53.28-1.16.56-1.3,1.2,0,.09.11.15.14,0,.21-.62,1-.66,1.53-.91a2.73,2.73,0,0,0,.82-.73c.25-.3.48-.61.7-.93A0,0,0,0,0,188.79,113.85Z"
          style={{
            opacity: 0.2,
            transformOrigin: "187.225px 115.161px",
          }}
          className="animable"
          id="elttw1bwkh88g"
        />
      </g>
      <g id="elzxxqluqqd6c">
        <path
          d="M186.35,114.06a12.82,12.82,0,0,0-1.11,1.33c-.06.08.07.17.13.09a8.94,8.94,0,0,1,1.11-1.27C186.57,114.12,186.44,114,186.35,114.06Z"
          style={{
            opacity: 0.2,
            transformOrigin: "185.867px 114.778px",
          }}
          className="animable"
          id="elr7se6uw5wy"
        />
      </g>
      <path
        d="M191.71,124.46a2.64,2.64,0,0,1-.51.81,1.83,1.83,0,0,0-.36.38c-.22.38-.76.49-1.1.75a.56.56,0,0,1-.37.13.67.67,0,0,0-.2,0c-.18,0-.32.25-.5.28s-.16,0-.22-.06a.56.56,0,0,0-.36,0,1.11,1.11,0,0,0-.29.28.36.36,0,0,0-.5-.16.71.71,0,0,0-.34.08,1,1,0,0,1-.24.08c-.1,0-.2-.06-.3-.06a.34.34,0,0,0-.2,0l-.07,0a.47.47,0,0,0-.21,0,.78.78,0,0,0-.22,0,1.77,1.77,0,0,1-.69,0,.93.93,0,0,0-.24-.32.12.12,0,0,0-.2.13l.07.11a.15.15,0,0,0-.07.15,1.24,1.24,0,0,1,0,.16s0,0,0,.06h0a.38.38,0,0,0-.14-.14,2.18,2.18,0,0,0,0-.44c0-.47.05-.94.06-1.42a0,0,0,0,0-.07,0,7.68,7.68,0,0,1-.27,1.43.91.91,0,0,1-.1.29s-.08,0-.15.07a.34.34,0,0,0-.18.15l0,0a.26.26,0,0,0-.15,0,.22.22,0,0,1-.28-.05h0a2.05,2.05,0,0,0-.1-.48c0-.18,0-.35,0-.53v0a1.83,1.83,0,0,0,0-.87c0-.42,0-.83-.07-1.24,0,0,0,0,0,0a2.7,2.7,0,0,0-.12.89s0,.07,0,.1a.08.08,0,0,0-.05,0,9.38,9.38,0,0,1-.12,1,3.62,3.62,0,0,0-.17.53,1.61,1.61,0,0,0,0,.48.9.9,0,0,1-.66.75,2.21,2.21,0,0,1-1.22-.11c-.09,0-.15.12,0,.14.67.19,1.45.47,2,0a.36.36,0,0,0,0,.1.34.34,0,0,0,.28.26l.4.05a.35.35,0,0,0,.31-.16.41.41,0,0,0,.53,0,1.17,1.17,0,0,0,.26.17,7.22,7.22,0,0,0,1.08-.35c0,.14,0,.11.18.12a.75.75,0,0,0,.3,0,.64.64,0,0,0,.31-.2,1.14,1.14,0,0,0,1.28-.13h0a.81.81,0,0,0,.41-.06.68.68,0,0,0,.21-.17.73.73,0,0,1,.09-.13c.07,0,.25,0,.35,0a.67.67,0,0,0,.33-.22c.09-.1.13-.22.28-.25s.25,0,.4-.07a2,2,0,0,0,.3-.28,3.85,3.85,0,0,1,.34-.26,1.62,1.62,0,0,0,.49-.52c.06-.12.06-.22.16-.31a2.22,2.22,0,0,0,.31-.3,1.89,1.89,0,0,0,.37-.8C191.82,124.42,191.73,124.4,191.71,124.46Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "186.247px 126.13px",
        }}
        id="elak3gp98djjw"
        className="animable"
      />
      <g id="elar9l2m3mxvo">
        <path
          d="M190.93,146.72a4.63,4.63,0,0,1-1,.76,2.07,2.07,0,0,1-.92.14l.17-.07a.1.1,0,0,0-.09-.18,5,5,0,0,1-.54.21l-.23,0h0l.07-.05a1.37,1.37,0,0,0,.16-1.37s-.06,0-.06,0c.08.45.19,1.32-.44,1.45-.28.06-.44-.15-.68-.24a.78.78,0,0,0-.52,0l-.3,0a1,1,0,0,0-.3-.18h0a6.18,6.18,0,0,0-.26-.76.38.38,0,0,0-.23-.2.83.83,0,0,1,.2-.35,1,1,0,0,0,.23-.19,4.09,4.09,0,0,0,.76-1h0s0-.06-.06,0a4.15,4.15,0,0,1-.24.34,3.38,3.38,0,0,1-.64.55,4.31,4.31,0,0,0-.46.39l-.07.06c0-.08,0-.17,0-.25a.46.46,0,0,0-.17-.35,4.76,4.76,0,0,0,.31-.47c.37-.58.76-1.15,1.18-1.69,0,0,0,0,0,0l-.72.88c-.12.14-.23.28-.35.41s-.2.23-.31.34a.08.08,0,0,0-.09,0,1.06,1.06,0,0,1-.87.38l-.06-.14c-.22-.4-.49-.77-.71-1.17l-.13-.21-.06-.24a1.75,1.75,0,0,0-.39-.64c-.16-.2-.36-.4-.32-.68,0-.08-.12-.09-.14,0v.1c-.11-.2-.22-.41-.31-.62s-.19,0-.14.06a21.22,21.22,0,0,1,.82,2.36c.15.4.28.79.41,1.2s.3.74.41,1.12a.5.5,0,0,0,.64.37s0,0,0,0a.13.13,0,0,0,.12.14l.11,0h0c-.05.27.26.47.5.42a1.73,1.73,0,0,0,.28.19l0,.19c0,.4.56.43.78.17-.44.54,1,.4,1.07.56a.43.43,0,0,0,.73.06c.17-.21.53-.21.77-.27a2.47,2.47,0,0,0,.83-.32,6.3,6.3,0,0,0,1.36-1.27S191,146.7,190.93,146.72Z"
          style={{
            opacity: 0.2,
            transformOrigin: "186.608px 145.142px",
          }}
          className="animable"
          id="eljvlw56wxo2"
        />
      </g>
      <g id="el8azdvn7s5ip">
        <path
          d="M178.68,101.69a1.57,1.57,0,0,0-1.47-.18l-.73.26a2.87,2.87,0,0,1-1.2.07,1.76,1.76,0,0,0-1.45.53c-.35.39-.51,1-1,1.31a.57.57,0,0,0-.25.28c-1.17.43-1.51,2.24-1.76,3.35A27.39,27.39,0,0,1,169,112.5c0,.08.09.15.14.07a31.66,31.66,0,0,1,2.62-4,6.4,6.4,0,0,0,.6-.9h.12c.57.14.71.88,1.23,1.12,0,0,0,0,0,0a2.24,2.24,0,0,1-.51-.63,2.63,2.63,0,0,0-.41-.63,1.11,1.11,0,0,0-.27-.17,6.27,6.27,0,0,0,.35-.74c.21-.49.34-1.16.88-1.39a.71.71,0,0,0,.11-1.2,4.56,4.56,0,0,0,.24-.44,1.33,1.33,0,0,1,1.13-.86c1-.25,2.27-1.55,3.36-.93A.07.07,0,0,0,178.68,101.69Z"
          style={{
            opacity: 0.2,
            transformOrigin: "173.853px 107.005px",
          }}
          className="animable"
          id="eljpjpbdtla4"
        />
      </g>
      <path
        d="M278.14,126.87q-.08,1.73-.15,3.48c-.06,1.17-.13,2.33-.23,3.48-.05.88-.1,1.75-.14,2.58s-.08,1.71-.09,2.59,0,1.67.12,2.49.14,1.65.18,2.49a20.68,20.68,0,0,1,.05,3,16.38,16.38,0,0,1-.42,2.95,12,12,0,0,1-.6,1.85,9.45,9.45,0,0,1-1,1.85,4.5,4.5,0,0,1-1.47,1.35,2.74,2.74,0,0,1-1.92.29,4,4,0,0,1-1.49-.61,13,13,0,0,1-1.29-1,8.84,8.84,0,0,1-1.25-1.44c-.35-.51-.7-1-1.05-1.63a17.05,17.05,0,0,1-1.57-3.46c-.22-.7-.41-1.41-.58-2.12s-.35-1.42-.52-2.13c-.22-1-.42-2-.61-3s-.35-2-.48-3c-.35,0-.86,0-1.52-.11s-1.39-.13-2.16-.18l-2.25-.14a11.74,11.74,0,0,0-1.76,0c.08,1.55.11,3.1.1,4.65s-.08,3.09-.22,4.64c-.1.93-.21,1.85-.35,2.78a15,15,0,0,1-.68,2.72,13.68,13.68,0,0,1-.88,1.88,4.46,4.46,0,0,1-1.4,1.55,3.69,3.69,0,0,1-2,.49,5.4,5.4,0,0,1-1.95-.45,5.84,5.84,0,0,1-2.87-2.34,10.22,10.22,0,0,1-1.41-3.45,20.88,20.88,0,0,1-.37-4c0-1.35,0-2.68,0-4a31.23,31.23,0,0,0-.21-4.74c-.19-1.57-.39-3.16-.6-4.75-.25-1.81-.46-3.62-.63-5.41a38.25,38.25,0,0,1-.09-5.47c.09-.88.19-1.74.31-2.58a22.5,22.5,0,0,1,.51-2.52c.23-.62.46-1.24.71-1.85a6.35,6.35,0,0,1,1-1.66,10.69,10.69,0,0,1,2.24-2.1,10.85,10.85,0,0,1,2.76-1.44.24.24,0,0,1,.2-.07,4.15,4.15,0,0,1,.8-.26,9.66,9.66,0,0,1,1.62-.12,3.62,3.62,0,0,1,1.56.34,3.46,3.46,0,0,1,1.35,1.07,6.7,6.7,0,0,1,.82,1.46,3.7,3.7,0,0,1,.23,1c0,.33,0,.68,0,1s0,.8,0,1.19-.06.8-.1,1.2c-.1.79-.17,1.6-.22,2.42L256,120c0,.35-.08.9-.11,1.65s0,1.56-.08,2.42-.05,1.67-.08,2.42,0,1.31,0,1.66A15.43,15.43,0,0,0,258,128c.67-.08,1.3-.19,1.89-.32s1.22-.26,1.86-.38A21.81,21.81,0,0,1,264,127c0-.71,0-1.62,0-2.72s0-2.26,0-3.45.08-2.34.15-3.45.16-2,.25-2.65a16.31,16.31,0,0,1,.48-2.41,10.3,10.3,0,0,1,.94-2.29,6.29,6.29,0,0,1,1.54-1.78,4.76,4.76,0,0,1,2.26-.91,6.84,6.84,0,0,1,2.85.21,6.16,6.16,0,0,1,1.19.38,5.1,5.1,0,0,1,1.06.63,6,6,0,0,1,1.58,2,12.21,12.21,0,0,1,.91,2.36,20,20,0,0,1,.65,3.22c.12,1.09.2,2.2.24,3.35s.13,2.47.14,3.68S278.24,125.59,278.14,126.87Z"
        style={{
          fill: "#213E60",
          transformOrigin: "260.282px 131.304px",
        }}
        id="elbtqfqhfmefr"
        className="animable"
      />
      <path
        d="M254.76,139.4c-.1-.13-.21-.25-.32-.38a1.82,1.82,0,0,0,.37-.61,5.44,5.44,0,0,0,0-2c0-1.15.52-2.21-.1-3.2a13.21,13.21,0,0,0,.2-2.51c0-.5-.17-1-.23-1.46s-.09-1-.14-1.45a.05.05,0,0,0,0,0c0-.71,0-1.43-.06-2.13,0,0-.07,0-.07,0,0,.71,0,1.43,0,2.15v0a8.6,8.6,0,0,1-.19,1.75c-.13.52-.28,1-.38,1.51s-.16,1-.25,1.44a2,2,0,0,0,0,1.29c.29.71-.17,1.47-.23,2.19a5,5,0,0,0,0,.55,2.56,2.56,0,0,1-.58.46c-.52.1-1,.15-1.56.23-.07,0-.1.11,0,.12h0a2.42,2.42,0,0,0,.76,0,2.93,2.93,0,0,1,.73.11l.68.21-.07,0a.22.22,0,0,0-.21.28,1.51,1.51,0,0,1,0,.3.75.75,0,0,0-.39.7,2.35,2.35,0,0,0-.64,0c-.28,0-.58.06-.86.09a13.27,13.27,0,0,0-1.64.25h0s0,.09,0,.08a4.94,4.94,0,0,1,2.61.29,1.81,1.81,0,0,0,.6.18c.18,0,.36,0,.54,0l0,0-.51.53a.64.64,0,0,0,.3,1.05c.49.15.05.87.07,1.22,0,.52.49.77.61,1.23,0,0,0,.05,0,.07a3.36,3.36,0,0,1-.27.75c-.09.26,0,.58-.15.82a.85.85,0,0,1-.54.36,3.52,3.52,0,0,0-1.13.43s0,.09,0,.07a8.33,8.33,0,0,1,1.31-.42.91.91,0,0,0,.43-.3c.16-.21.13-.46.2-.7a1,1,0,0,1,.14-.29c0,.46-.15.93-.21,1.35a14,14,0,0,1-.47,2,.08.08,0,0,0,.16,0c.28-.88.61-1.74.9-2.61a3.62,3.62,0,0,0,.39-2.13c-.1-.3-.36-.49-.27-.8a2.67,2.67,0,0,0,.25-.93,1.46,1.46,0,0,0-.33-.82l.51-.46A.69.69,0,0,0,254.76,139.4Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "252.297px 136.875px",
        }}
        id="elzn02446upum"
        className="animable"
      />
      <g id="elt9l5cq885zm">
        <path
          d="M269.7,118.2a3.12,3.12,0,0,1-1.74,0,2.15,2.15,0,0,1-1-.68c0-.22-.08-.44-.11-.65l.06-.08a1,1,0,0,0,.24-.4,1.07,1.07,0,0,0-.05-.86l0,0s0,0,0,0v-.08a.08.08,0,0,0,0-.08h0a1,1,0,0,0,.14-.22v0c0,.08.15.06.14,0s0-.16,0-.24a2.83,2.83,0,0,0,.11-.31l.06-.37.18-.06a2.44,2.44,0,0,1,1.07.14.07.07,0,0,0,.08-.11l0,0h0a.84.84,0,0,0-.47-.23c-.21,0-.53,0-.68-.2s-.07-.29-.06-.45a1.55,1.55,0,0,0,0-.48,1.59,1.59,0,0,0-.26-.65,3.48,3.48,0,0,1,1.42-3.26,0,0,0,0,0,0-.05,4.09,4.09,0,0,0-1.78,2.6c-.22.68-.69,1.26-.85,1.94a4.92,4.92,0,0,1-.22,1,3.44,3.44,0,0,0-.44.74,1.15,1.15,0,0,0,.09.81,1.26,1.26,0,0,0-.19.28c-.34.64,0,1.47.08,2.15a26,26,0,0,1,0,2.65,3.21,3.21,0,0,0,.1,1,4.84,4.84,0,0,1,.14,1.7s0,0,0,0c-.06.41-.12.82-.21,1.23a0,0,0,0,0,.05,0c.09-.41.16-.82.23-1.24,0,0,0,0,0,0a5.21,5.21,0,0,1,.32-1.35,4.36,4.36,0,0,0,.42-1,17.22,17.22,0,0,0,.39-2.26,1.28,1.28,0,0,1,.44-.21,1.45,1.45,0,0,1,.29-.11l.31,0,.65-.08a3.1,3.1,0,0,0,1.18-.39A.07.07,0,0,0,269.7,118.2Z"
          style={{
            opacity: 0.2,
            transformOrigin: "267.576px 116.93px",
          }}
          className="animable"
          id="el5ri9ya87tqy"
        />
      </g>
      <g id="elg41qy538km7">
        <path
          d="M270.62,119.14a6.54,6.54,0,0,1-.75.13c-.23,0-.47,0-.7.06s-.46,0-.69.07a3.68,3.68,0,0,1-.74,0,.08.08,0,0,0,0,.16c.26,0,.52,0,.77,0a4.37,4.37,0,0,0,.72-.06,5.43,5.43,0,0,0,.67-.16c.24-.06.49-.14.73-.22A0,0,0,1,0,270.62,119.14Z"
          style={{
            opacity: 0.2,
            transformOrigin: "269.145px 119.34px",
          }}
          className="animable"
          id="elu9r20edipp9"
        />
      </g>
      <g id="elxn10gdkxwq">
        <path
          d="M263.25,128.06l-.33.15a.61.61,0,0,0,0-.11.24.24,0,0,0-.39,0,3,3,0,0,1-.5.36,3.13,3.13,0,0,0-.53,0,3.42,3.42,0,0,0-.57.07l-.18.1a.93.93,0,0,1-.24,0l-1.11.21a.08.08,0,0,0,0,.15,5.56,5.56,0,0,1,.81-.08,2.77,2.77,0,0,1,.41,0c.12,0,.23.09.35.11l.18,0a1.39,1.39,0,0,0,.17,1.05c0,.08.16,0,.12-.08a1.33,1.33,0,0,1-.11-.94l.33.06c.07,0,.19,0,.24.08s0,0,0,0a.39.39,0,0,0,.24.45.48.48,0,0,0,.29,0,2.19,2.19,0,0,0,.1.34c.1.26.19.53.27.8s.28.11.27,0a5.22,5.22,0,0,1,0-1.31,2.58,2.58,0,0,1,.47-1.15C263.72,128.16,263.44,128,263.25,128.06Z"
          style={{
            opacity: 0.2,
            transformOrigin: "261.473px 129.464px",
          }}
          className="animable"
          id="el5l4cr3uo"
        />
      </g>
      <path
        d="M276.53,140.55c-.15-1.11-.16-2.24-.26-3.36s-.16-2.32-.29-3.48c0-.05-.1-.05-.1,0a27.34,27.34,0,0,1,.14,3.84c0,.64,0,1.28-.09,1.92a7,7,0,0,1-.14.9c-.06.24-.11.47-.16.71l-.09.43c0,.18-.09.3-.29.31s-.44,0-.65,0l-.05,0a2,2,0,0,0-1.12,0c-.1,0-.07.18,0,.17a2.9,2.9,0,0,1,.93.07,1.25,1.25,0,0,1,.4.24,1.18,1.18,0,0,0,.4.21l.2.07c-.15.94-.29,1.87-.46,2.81-.06.33-.15.68-.22,1l-.06,0a1.49,1.49,0,0,1-.59.06h-.6c-.42,0-.85,0-1.28,0-.07,0-.08.12,0,.13.67.13,1.37.22,2,.41.11,0,.27.06.31.19a.39.39,0,0,1,0,.28c-.11.25-.44.34-.67.4a.27.27,0,0,0-.19.3l-.24,0c-.27,0-.53,0-.8,0h-.42c-.15,0-.31,0-.46,0s-.13.17,0,.19a6.09,6.09,0,0,1,2.3.94,1.25,1.25,0,0,1,.41.82,7,7,0,0,1-.19,1.2A4.67,4.67,0,0,1,273,153.6c-.09.08,0,.2.12.15a4.87,4.87,0,0,0,2.26-2.11,4.61,4.61,0,0,0,.42-1.49,2.34,2.34,0,0,0,.07-.87,1.22,1.22,0,0,0-.1-.24,1.6,1.6,0,0,0,.49-.6,1.39,1.39,0,0,0-.05-1.34A26.64,26.64,0,0,0,276.53,140.55Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "274.089px 143.717px",
        }}
        id="el0cjinoyo07"
        className="animable"
      />
      <path
        d="M254.92,112.43a.83.83,0,0,0-.62-.77v0a1.91,1.91,0,0,0,0-.89,2,2,0,0,0-.79-1.14,3.49,3.49,0,0,0-1.26-.43,2.69,2.69,0,0,0-1.48-.17c-.1,0-.06.17,0,.15.84-.18,1.31.56,1.73,1.14a1.19,1.19,0,0,1,.31.56,1.85,1.85,0,0,1-.2.67,1.44,1.44,0,0,0,.37,1.57,1.13,1.13,0,0,0,.35.21,6.13,6.13,0,0,0,.24.68,4.64,4.64,0,0,1,.16,1.49c0,.53.17,1.06.2,1.6a11.86,11.86,0,0,1-.06,1.79c0,.06.09.07.09,0a13.9,13.9,0,0,1,.25-1.68c.15-.57.41-1.12.56-1.69A6.65,6.65,0,0,0,255,114,13,13,0,0,0,254.92,112.43Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "252.855px 113.966px",
        }}
        id="elqk8rtyrh3kl"
        className="animable"
      />
      <g id="elspin0ff3xfl">
        <path
          d="M246.83,127.34l-.58,0a2.58,2.58,0,0,1-1.46-1.44v0c-.07-.5-.15-1-.24-1.48a25.45,25.45,0,0,1-.2-3.38c0-.12-.18-.15-.2,0-.19,1-.3,2-.39,3.07,0,.54,0,1.07-.06,1.61a13.35,13.35,0,0,1-.26,1.68c-.33,2.21,1.12,4.17.95,6.39,0,.12.18.13.21,0a6.07,6.07,0,0,0,.33-1.4c0-.45,0-.91,0-1.36a.15.15,0,0,0,.07-.1,17.37,17.37,0,0,0,.1-2.5,3.75,3.75,0,0,1,0-.58c0-.34,0-.34.33-.37a2.35,2.35,0,0,0,1.41.07A.07.07,0,0,0,246.83,127.34Z"
          style={{
            opacity: 0.2,
            transformOrigin: "245.165px 127.411px",
          }}
          className="animable"
          id="elurmmvvgqfw"
        />
      </g>
      <g id="elftr6tsov745">
        <path
          d="M246.37,115l-.28-.24a1.24,1.24,0,0,0-.36-.19,2,2,0,0,0-.86-.16.28.28,0,0,0-.27.28,4,4,0,0,1-.08.59c-.05.19-.1.39-.14.58-.08.4-.17.79-.22,1.19a.11.11,0,0,0,.21.06c.15-.38.25-.77.37-1.15.06-.19.11-.37.16-.55A2.13,2.13,0,0,1,245,115c.15,0,.29.11.45.15s.23.09.36.12a1.77,1.77,0,0,1,.31.08,1,1,0,0,1,.29.14c.11.07.23.13.34.21s.35.31.53.47a0,0,0,0,0,.05,0A4,4,0,0,0,246.37,115Z"
          style={{
            opacity: 0.2,
            transformOrigin: "245.744px 115.793px",
          }}
          className="animable"
          id="elqpvk1zaaep"
        />
      </g>
      <g id="ela4pvplm99j7">
        <path
          d="M247.8,114.42c-.33-.2-.68-.37-1-.54s-.73-.29-1.09-.44a.07.07,0,1,0-.07.13c.35.19.67.41,1,.58s.71.33,1.08.47C247.84,114.67,247.91,114.48,247.8,114.42Z"
          style={{
            opacity: 0.2,
            transformOrigin: "246.728px 114.03px",
          }}
          className="animable"
          id="el5olvjgr8d53"
        />
      </g>
      <path
        d="M314.32,112.62a31.88,31.88,0,0,1,5.71,8.44,31.3,31.3,0,0,1,2.73,9.8,29,29,0,0,1-.3,8.2,18.79,18.79,0,0,1-3.12,7.57,16.78,16.78,0,0,1-2.74,2.85,13.12,13.12,0,0,1-3.36,2,12.69,12.69,0,0,1-2.29.73c-.78.17-1.58.34-2.41.49-1,.23-2,.44-2.92.62s-1.94.33-2.95.43a21.54,21.54,0,0,1-5.67-.35,10.2,10.2,0,0,1-1.87-.59,8.19,8.19,0,0,1-4.07-3.88,20.21,20.21,0,0,1-1.33-3.6q-.6-2.46-1.06-4.93a38.08,38.08,0,0,1-.61-5q0-.6-.24-2.49c-.13-1.26-.26-2.6-.39-4s-.27-2.76-.38-4-.19-2-.2-2.29c-.09-.7-.15-1.4-.19-2.09s-.09-1.39-.13-2.1a26.93,26.93,0,0,1,0-3.24,12.12,12.12,0,0,1,.78-3.22,5.68,5.68,0,0,1,2-2.56,7.36,7.36,0,0,1,1.76-1c.63-.26,1.28-.49,2-.71s1.54-.44,2.31-.61,1.57-.3,2.36-.41a29.65,29.65,0,0,1,4.21-.36,12.73,12.73,0,0,1,4.21.66,16.09,16.09,0,0,1,4.49,2.32A27,27,0,0,1,314.32,112.62Zm-6.42,23.43a2.34,2.34,0,0,0,.78-.49,3.11,3.11,0,0,0,.93-1.52c.81-3.15.49-9.74-3.11-12-1.8-1.15-5.15-.45-6.1-.27.08.93.16,1.86.22,2.79s.16,1.86.29,2.78c.12,1.1,1.16,9.23,1.56,9.47S306.15,136.78,307.9,136.05Z"
        style={{
          fill: "#213E60",
          transformOrigin: "304.701px 130.061px",
        }}
        id="elafug7r82yjt"
        className="animable"
      />
      <path
        d="M300.79,135.32a2.18,2.18,0,0,0-.34-.41.75.75,0,0,0-.34-.81.68.68,0,0,0-.07-1.18l-.23-.12c.1-.08.22-.16.32-.25a.66.66,0,0,0-.11-1.09.13.13,0,0,0,0-.06c0-.11,0-.21,0-.31s0-.41,0-.61c0-.45,0-.9-.07-1.34a13.28,13.28,0,0,0-.33-2.53,17,17,0,0,1-.41-2.44.22.22,0,0,0,0-.08c-.08-.89-.14-1.78-.24-2.67,0-.08-.13-.08-.13,0,0,.83,0,1.67,0,2.51h-.07c-.53.39-.5,1-.54,1.6,0,.33-.06.46-.36.61a2.13,2.13,0,0,0-.87.64.52.52,0,0,0,.28.81c-.17.34,0,.86.41.87a.39.39,0,0,1,.43.3,1.18,1.18,0,0,0,0,.72c.12.36.42.65.52,1a1,1,0,0,1,.05.24v0c0,.44-.18.91-.2,1.37a1.86,1.86,0,0,0-.19.11.62.62,0,0,0-.35.46l-.16.05c-.48-.1-1-.17-1.45-.23a.16.16,0,0,0-.08.31c.61.17,1.23.32,1.85.43l.16.15a.83.83,0,0,1-.07.13l0,0a.61.61,0,0,0-.33.41,3.07,3.07,0,0,1-.42.28,6.9,6.9,0,0,0-2.78.47.07.07,0,0,0,0,.13,13.16,13.16,0,0,0,2-.2l.79,0a4.81,4.81,0,0,1,.85.1l.39.18a.75.75,0,0,0,.28.63l.34.25a2.08,2.08,0,0,0,.09,2,10.36,10.36,0,0,1-.37,1.38c-.14.54-.25,1.08-.37,1.61a.08.08,0,0,0,.15,0,9.62,9.62,0,0,1,.56-1.33,4.65,4.65,0,0,1,.86-1.42.53.53,0,0,0,.16-.6,1,1,0,0,1,.31-1.25A.74.74,0,0,0,300.79,135.32Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "297.752px 131.076px",
        }}
        id="eldi8ojqij8x"
        className="animable"
      />
      <path
        d="M299.82,120a4.74,4.74,0,0,0-.4-.49c-.17-.16-.31-.35-.48-.49a2.64,2.64,0,0,0-.65-.38c-.4-.18-.84-.27-1.24-.45a2.27,2.27,0,0,1-1-.91s-.06,0,0,0a5.46,5.46,0,0,0,.75,1,6,6,0,0,0,1,.93c.18.14.37.25.56.37a1.42,1.42,0,0,0,.35.17,2.64,2.64,0,0,1,.3.1,4.94,4.94,0,0,1,.55.32l.24.2a1.73,1.73,0,0,0,.24.23.08.08,0,0,0,.13-.07A1.45,1.45,0,0,0,299.82,120Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "298.097px 118.949px",
        }}
        id="el2eogjq8se0p"
        className="animable"
      />
      <path
        d="M300.76,119.67l-.9-1.28c-.3-.42-.59-.86-.91-1.27a.08.08,0,0,0-.13.1c.28.44.6.85.91,1.28l.91,1.27C300.7,119.85,300.82,119.75,300.76,119.67Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "299.79px 118.444px",
        }}
        id="el81yyik1fw2c"
        className="animable"
      />
      <g id="elvd4lvdo4g2m">
        <path
          d="M310.73,137.35c-.09-.12-.17-.25-.26-.38a1.87,1.87,0,0,0-.3-.33,4.32,4.32,0,0,0-.78-.54c-.07,0-.15,0-.11.11l.24.39a2.49,2.49,0,0,0,.25.38,5.36,5.36,0,0,0,.73.61,14.28,14.28,0,0,1,1.37,1.21,0,0,0,0,0,0,0A17.61,17.61,0,0,1,310.73,137.35Z"
          style={{
            opacity: 0.2,
            transformOrigin: "310.57px 137.45px",
          }}
          className="animable"
          id="elmws6ndwirm"
        />
      </g>
      <g id="el9bjx7s1vjik">
        <path
          d="M311.07,135.69a1.67,1.67,0,0,0-.38-.25,1.33,1.33,0,0,0-.43-.13,1,1,0,0,0-.24,0l0,0h-.16a.09.09,0,0,0,0,.18l.1,0h0l0,0,.19.07.19.07.19.07a3.84,3.84,0,0,1,.35.18,1.23,1.23,0,0,0,.35.16,0,0,0,0,0,.06-.06A.58.58,0,0,0,311.07,135.69Z"
          style={{
            opacity: 0.2,
            transformOrigin: "310.53px 135.671px",
          }}
          className="animable"
          id="elb3fz8chjpc4"
        />
      </g>
      <g id="elzqs87folk8">
        <path
          d="M311.52,132.9c-.37.14-.72.31-1.08.47a.08.08,0,1,0,.06.14c.36-.14.73-.28,1.09-.45A.09.09,0,0,0,311.52,132.9Z"
          style={{
            opacity: 0.2,
            transformOrigin: "310.996px 133.214px",
          }}
          className="animable"
          id="elmzv76f4czom"
        />
      </g>
      <path
        d="M320.71,126.6c0-.09-.16-.09-.16,0,0,1.26-.05,2.53-.13,3.79a.19.19,0,0,0-.24.16c0,.4-.07.8-.1,1.2a1.64,1.64,0,0,0-.75-1.24c-.06,0-.12.06-.06.1.69.51.56,1.37.47,2.13-.57-.22-1.24-.26-1.66-.75a.07.07,0,0,0-.11.07c.27.72,1.14.83,1.73,1.21a5.48,5.48,0,0,0,0,1,8,8,0,0,1,.15,1.46c0,.07,0,.1.09.11,0,.62-.06,1.4-.51,1.76a.83.83,0,0,0,0,1.31c.16.1-.38.31-.58.39a1.45,1.45,0,0,0-.89-.62c-.26-.07-.35.34-.12.44a1.08,1.08,0,0,1,.55.6.84.84,0,0,0-.05.58l-.07.06-.48.21a.67.67,0,0,0-.37.33,1.06,1.06,0,0,1-.35,0,3.64,3.64,0,0,0-.57-.25,3,3,0,0,0-1.79-.71s0,0,0,.05c.53.32,1.1.6,1.62.94.19.13.53.28.59.52a1.15,1.15,0,0,0,.31.7c.15.12.35.2.42.39a.71.71,0,0,1,0,.45c0,.08,0,.15,0,.22a1.78,1.78,0,0,0-.38.6c-.69.44-.82,1.45-1.12,2.21a5.38,5.38,0,0,1-2.56,3c-.09,0,0,.19.06.15a9.85,9.85,0,0,0,2.56-1.82,5.86,5.86,0,0,0,1-1.25c.21-.37.47-1,1-1a.68.68,0,0,0,.61-.84h0L319,144a1.88,1.88,0,0,0,.45-.44,1.85,1.85,0,0,0,.34-1.23,2.08,2.08,0,0,0-.19-.7l0,0a.81.81,0,0,0,.5-.64c0-.14,0-.26,0-.39a2,2,0,0,0,1-1.22,1.61,1.61,0,0,0-.17-1.17,3.6,3.6,0,0,0,.36-1.54c0-1.07-.07-2.15-.16-3.22s-.29-2.24-.34-3.37S320.76,127.74,320.71,126.6Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "317.421px 137.854px",
        }}
        id="elgyho4iuow0o"
        className="animable"
      />
      <g id="elqrfoxc8gst">
        <path
          d="M300.72,107.63s0-.1,0-.09a6.64,6.64,0,0,1-1.54.21,7.24,7.24,0,0,1-1-.17,7.45,7.45,0,0,0-1.25,0,6.38,6.38,0,0,0-1.23.1,4.28,4.28,0,0,0-1.14.44l-.36.26a2.09,2.09,0,0,1-.59.17c-.69.18-1.29,1-2,.94a.08.08,0,0,0,0,.15c.67.36,1.21-.09,1.88-.16h.18c.29.5.51,1,.77,1.55,0,0,.05,0,.05,0a4,4,0,0,0-.19-.78c-.06-.23-.1-.46-.15-.69a2.33,2.33,0,0,0,.37,0h.08l.17,0a2.36,2.36,0,0,1,.33.72,5.91,5.91,0,0,0,.72,1.87,0,0,0,0,0,.08,0,1,1,0,0,0-.21-.83,4.11,4.11,0,0,1-.21-.42c0-.22-.06-.44-.11-.66a1.63,1.63,0,0,1,.21-.76,2.31,2.31,0,0,1,.24-.29c.66-.08,1.35-.06,2-.19a.06.06,0,0,0,.09,0l.06,0a2.1,2.1,0,0,0,.24-.06,3.75,3.75,0,0,0,.41-.19,1.18,1.18,0,0,1,.26,0,1.89,1.89,0,0,1,.46.2,1.22,1.22,0,0,1,.39.32c.07.08.21,0,.16-.09a1,1,0,0,0-.39-.46,1.26,1.26,0,0,0-.55-.16q.25-.15.51-.27C299.82,107.94,300.28,107.81,300.72,107.63Z"
          style={{
            opacity: 0.2,
            transformOrigin: "296.139px 109.845px",
          }}
          className="animable"
          id="elumu2vxv53ba"
        />
      </g>
      <g id="el6neabd2njdd">
        <path
          d="M299.24,151.07a4.65,4.65,0,0,1-1.84-.48,7.24,7.24,0,0,0-.79-.39l-.43-.13h0a0,0,0,0,1,0,0,1.21,1.21,0,0,0-.41-.51l-.07,0,.06-.12c.07-.09.12-.19.21-.29l0,0,0,0L296,149s0,0,0,0l0,0,.08-.08a1.09,1.09,0,0,1,.27-.19c.06,0,0-.13,0-.12a1.66,1.66,0,0,0-.38.11.82.82,0,0,0-.34.27,1,1,0,0,0-.19.38l0,.12h0s0-.06,0-.08a.88.88,0,0,0-.39-.61c0-.15.06-.3.1-.44a8.25,8.25,0,0,1,.31-1l.27-.4c.31-.46.65-.89.95-1.37a0,0,0,0,0,0,0c-.3.39-.61.78-.94,1.14a.12.12,0,0,0-.22-.05,4,4,0,0,0-.34.6c-.07.06-.12.13-.19.19a3.39,3.39,0,0,1-.9.65.9.9,0,0,1-.16,0,1.11,1.11,0,0,0-.29-.14,3.7,3.7,0,0,0-.65-1.08,3.67,3.67,0,0,1-.89-2.1c0-.1-.16-.08-.16,0a8.65,8.65,0,0,0,.11,2,9.25,9.25,0,0,0,.25.94.91.91,0,0,1,0,.74.78.78,0,0,0,.55,1,2,2,0,0,0,.9.66.08.08,0,0,0,0,0,.91.91,0,0,0,.77.77h.14a1,1,0,0,0,.29.34,2.12,2.12,0,0,0,1.43.17c.43-.07.84-.24,1.26-.33a5.71,5.71,0,0,1,1.6,0A.05.05,0,0,0,299.24,151.07Z"
          style={{
            opacity: 0.2,
            transformOrigin: "295.582px 148.104px",
          }}
          className="animable"
          id="elh8vr5tl6din"
        />
      </g>
      <g id="elecq6b2rwab8">
        <path
          d="M296.63,144.14a11.11,11.11,0,0,0-1.08,1.09c-.36.38-.7.77-1.05,1.15-.07.08.05.17.12.1l1.06-1.12a11.21,11.21,0,0,0,1-1.17A0,0,0,0,0,296.63,144.14Z"
          style={{
            opacity: 0.2,
            transformOrigin: "295.579px 145.323px",
          }}
          className="animable"
          id="el1ceooxw3lzq"
        />
      </g>
      <path
        d="M352.51,103.15a17.08,17.08,0,0,1,3.19,3.61,44,44,0,0,1,3.31,5.61,71.58,71.58,0,0,1,3,6.72,54.48,54.48,0,0,1,2.2,6.92,33,33,0,0,1,1,6.32,10.59,10.59,0,0,1-.68,4.78,8.21,8.21,0,0,1-1.41,2.06,5,5,0,0,1-2.16,1.34,3.78,3.78,0,0,1-2,0,4.78,4.78,0,0,1-1.76-.88,9.29,9.29,0,0,1-1.73-1.81q-.76-1-1.44-2.13a42.33,42.33,0,0,1-2.66-5.67,5.16,5.16,0,0,0-.21-.49,4.1,4.1,0,0,1-.21-.48c-1.22.67-2.45,1.3-3.69,1.88a25.79,25.79,0,0,1-3.91,1.47,23.68,23.68,0,0,1,1,2.5,21.77,21.77,0,0,1,.68,2.61,13.12,13.12,0,0,1,.37,2.5,16.22,16.22,0,0,1-.05,2.52,12.4,12.4,0,0,1-.34,1.78,4.1,4.1,0,0,1-.84,1.6,3,3,0,0,1-2.46,1.2,6.93,6.93,0,0,1-2.81-.58,12,12,0,0,1-3.09-1.85,16.69,16.69,0,0,1-2.59-2.59,13.12,13.12,0,0,1-2.06-3.21,40.32,40.32,0,0,1-2.25-5.67q-.88-2.87-1.59-5.74a47.13,47.13,0,0,1-1.08-5.85c-.1-.94-.21-1.89-.31-2.84a19.41,19.41,0,0,1-.11-2.85c0-.86.06-1.72.09-2.61a18.82,18.82,0,0,1,.3-2.6,16.64,16.64,0,0,1,1.08-3.38,31.82,31.82,0,0,1,1.59-3.14,36.92,36.92,0,0,1,2.28-3.07A10.18,10.18,0,0,1,334,98.71a14.36,14.36,0,0,1,3.41-1.29,8.84,8.84,0,0,1,4.11-.13,13.81,13.81,0,0,1,2.8.82A20.72,20.72,0,0,1,347,99.43a31.55,31.55,0,0,1,2.85,1.76C350.71,101.83,351.61,102.48,352.51,103.15Zm-10.93,19c.58-.21,1.17-.43,1.77-.67s1.18-.47,1.75-.73l1.24-.55c.39-.16.8-.34,1.25-.55a2.38,2.38,0,0,0-.29-.6c0-.13-.13-.37-.25-.72l-.41-1.12c-.14-.4-.28-.77-.43-1.12s-.25-.58-.29-.7l-.09-.25-.52-.87a15,15,0,0,0-1.3-1.86,8.45,8.45,0,0,0-1-1,2.57,2.57,0,0,0-1.22-.56,1.66,1.66,0,0,0-1.68.61,5.65,5.65,0,0,0-1.5,2.51,11.39,11.39,0,0,0-.5,2.92,4.18,4.18,0,0,0,.08,1.21c.09.51.18,1,.28,1.59s.21,1.07.32,1.57a11.11,11.11,0,0,0,.32,1.19l.09.25a6.37,6.37,0,0,0,1.21-.26Z"
        style={{
          fill: "#213E60",
          transformOrigin: "345.53px 122.109px",
        }}
        id="el36bo6osnd7m"
        className="animable"
      />
      <path
        d="M342.47,132.33a.41.41,0,0,0-.22-.44c0-.07,0-.13,0-.2a.65.65,0,0,0-.36-.68.69.69,0,0,0-.33-.84.67.67,0,0,0-.15-.06,1.9,1.9,0,0,0,.23-.39.92.92,0,0,0,0-.59,2.26,2.26,0,0,0-.21-.34.58.58,0,0,0-.29-.62.69.69,0,0,1-.34-.76.57.57,0,0,0-.88-.55c.26-.19.25-.46.23-.79a1.3,1.3,0,0,0-.24-.68,1,1,0,0,0-.58-.4c-.33-.94-.75-1.81-1.12-2.74s-.69-2.13-1-3.18c0-.08-.12,0-.11,0,.27,1.15.6,2.31.79,3.48l.06.43h0c-.09.2,0,.39,0,.6s0,.43,0,.65a2.22,2.22,0,0,1,0,.63.75.75,0,0,1,0,.16.22.22,0,0,0-.08.18v0h0a.33.33,0,0,0-.13.26.21.21,0,0,1,0,.06,3.38,3.38,0,0,1-.82.78l-.23.09a6.57,6.57,0,0,0-1.21.62.09.09,0,0,0,.06.16h0a11.21,11.21,0,0,0,2.05-.6,8.2,8.2,0,0,0,1-.42.74.74,0,0,1,.6,0,1.5,1.5,0,0,0-.1.85,1.18,1.18,0,0,0,.34.64,1,1,0,0,0,.47.25,2,2,0,0,0,.57.94c0,.1.05.2.07.31.08.29.24,0,0,.34l-.2.24c0-.21-.06-.47.13-.6s0-.14-.07-.1a.59.59,0,0,0-.25.54c0,.13,0,.25,0,.38a3.63,3.63,0,0,1-.27.28.64.64,0,0,0-.16.74,5,5,0,0,1-.39.41,3.31,3.31,0,0,0-.7.53,2.43,2.43,0,0,1-.51.4,1.25,1.25,0,0,1-.68.12c-.09,0-.13.1-.05.15a1.14,1.14,0,0,0,1-.15c.35-.2.64-.5,1-.72a1.08,1.08,0,0,1,.24-.12.66.66,0,0,0,1,.77,1.39,1.39,0,0,1,.5-.19s0,.07,0,.1a.55.55,0,0,0,.72.6l.14-.07c.24.47.47.94.73,1.41,0,.08.17,0,.14-.07A3.13,3.13,0,0,1,342.47,132.33Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "339.155px 126.634px",
        }}
        id="elefv1bboy9iw"
        className="animable"
      />
      <path
        d="M337.72,130.4a2.77,2.77,0,0,1-1.49.76,2.33,2.33,0,0,0-1.41.83c-.05.08.08.16.14.07.66-1.05,2.38-.34,3-1.5C338,130.43,337.82,130.27,337.72,130.4Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "336.387px 131.226px",
        }}
        id="els0n9pkae8d"
        className="animable"
      />
      <path
        d="M364.18,131a4.14,4.14,0,0,1-.25-1.2,1.64,1.64,0,0,0-.11-.76c-.33-.77-.72-1.5-1-2.27,0,0-.08,0-.06,0,.18.57.38,1.13.53,1.71a1.72,1.72,0,0,1,0,1.12,3.78,3.78,0,0,0-.17.74,15.32,15.32,0,0,0,0,1.66,1.3,1.3,0,0,1-.36,1.07.67.67,0,0,0-.3.71l-.24-.08a5.51,5.51,0,0,1-.66-.29,0,0,0,0,0,0,.06,2.55,2.55,0,0,0,.66.33l.3.09a.89.89,0,0,0,.29.41c-.25-.19-.06-.14-.22.06a1,1,0,0,0-.13.25l-.09-.08A5.08,5.08,0,0,0,361,134c-.52-.21-1-.48-1.51-.71-.07,0-.13.07-.06.11a23.61,23.61,0,0,1,2.35,1.59,3.89,3.89,0,0,1,.36.34,2,2,0,0,0,0,.35,1.72,1.72,0,0,0,.06.34,2,2,0,0,0-.53,1.17.48.48,0,0,1-.33.21.89.89,0,0,1-.45-.15,3.82,3.82,0,0,1-.47-.31c-.08-.06-.21,0-.15.11a1.38,1.38,0,0,0,1.07.79.73.73,0,0,0,.3-.07.57.57,0,0,1-.3.54,2.23,2.23,0,0,1-.61.27,4.6,4.6,0,0,0-1,.4c-.08.06,0,.19.08.14.64-.4,1.45-.24,2.07-.64a1.22,1.22,0,0,0,.5-.62c.17-.41.19-1,.79-1a.69.69,0,0,0,.4-1.24l0,0c.07-.14.17-.26.24-.4a1.79,1.79,0,0,0,.25-.78,1.36,1.36,0,0,0-.1-.58A3.09,3.09,0,0,0,364.18,131Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "361.915px 132.951px",
        }}
        id="elo2i4eflw6t"
        className="animable"
      />
      <g id="elpzob9p8tpp">
        <path
          d="M344.36,110.76a.31.31,0,0,1-.2-.11s0-.11-.05-.17a1.65,1.65,0,0,0-.15-.25.77.77,0,0,0-.09-.13.94.94,0,0,0-.1-.1l-.08,0a.61.61,0,0,1,0-.14.83.83,0,0,1,0-.15.19.19,0,0,1,0-.08v0a1.27,1.27,0,0,0,.06-.18l0-.08s0,0,0,0l0,0a.43.43,0,0,0,0-.07l0,0s0-.06,0,0,.05-.1.08-.14a.11.11,0,0,0-.11-.15.74.74,0,0,0-.33.22.64.64,0,0,0-.11.16s-.05-.1-.08-.14a5.24,5.24,0,0,1,.16-1.18c.1-.41.17-.83.23-1.25,0-.07-.1-.1-.11,0a13.22,13.22,0,0,1-.29,1.42c-.07.23-.16.45-.25.67s-.08.12-.11.19,0,0,0,0a.91.91,0,0,0-.49,0c-.35.11-.51.45-.76.68a3.65,3.65,0,0,1-.56.41,1,1,0,0,0-.42.43c0,.1.12.13.15,0,.17-.42.67-.24,1-.29a.91.91,0,0,0,.31-.09,1.15,1.15,0,0,0,.25-.12h0l.06,0s0,0,0,0a.56.56,0,0,0,.53.14h0l.23.16.07,0,.12.11,0,0h0l0,0,.09.09a.45.45,0,0,0,.24.14c.14,0,.26.09.39,0A0,0,0,1,0,344.36,110.76Z"
          style={{
            opacity: 0.2,
            transformOrigin: "342.48px 108.778px",
          }}
          className="animable"
          id="elwgap90j5qx"
        />
      </g>
      <g id="elb6ahb98kgmg">
        <path
          d="M346,106.79c-.14.27-.29.52-.41.79s-.26.53-.41.79a2,2,0,0,1-.25.32c-.06.07-.13.1-.18.18a.92.92,0,0,0-.09.25c0,.13,0,.27-.07.4a.65.65,0,0,0,0,.24c0,.07.05.12.06.19a.08.08,0,0,0,.13,0s.09,0,.14-.09a1.15,1.15,0,0,0,.14-.17,2.53,2.53,0,0,0,.2-.36,1.09,1.09,0,0,0,.1-.25.81.81,0,0,0,0-.22,1.42,1.42,0,0,1,0-.41,5.33,5.33,0,0,1,.29-.85c.12-.27.22-.55.35-.82C346,106.79,346,106.78,346,106.79Z"
          style={{
            opacity: 0.2,
            transformOrigin: "345.289px 108.382px",
          }}
          className="animable"
          id="elqb2pfkmkzql"
        />
      </g>
      <path
        d="M347.67,120.7a2.19,2.19,0,0,0-.5.27c-.15.11-.28.24-.43.34s-.3.19-.44.3a2.79,2.79,0,0,0-.28.32c-.29,0-.58,0-.86.08a.33.33,0,0,0-.3.27,1.21,1.21,0,0,0-.88.2,12.93,12.93,0,0,1-1.22.49c-.09,0-.05.18,0,.15a9.21,9.21,0,0,1,1-.31l.47-.1c.14,0,.32-.12.45,0s.16.34.21.49a1.45,1.45,0,0,0,.26.47v0h0s0,0,0,.06h0a2.48,2.48,0,0,0,.18.31,1.54,1.54,0,0,0,.28.34.07.07,0,0,0,.11-.08c-.06-.13-.15-.23-.22-.35l-.1-.16a.29.29,0,0,0,.2-.43,1.57,1.57,0,0,1-.27-.71h.25a1,1,0,0,0-.17.18c-.06.09.08.16.13.08a.89.89,0,0,1,.25-.26h.14a.57.57,0,0,0,.42-.16l0,0a1.21,1.21,0,0,1,.5.07.06.06,0,0,0,.06-.1,1,1,0,0,0-.46-.14l.12-.19a3,3,0,0,1,.4-.7c.2-.21.42-.41.62-.61A.06.06,0,0,0,347.67,120.7Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "345.204px 122.548px",
        }}
        id="elwwyapa2ro3"
        className="animable"
      />
      <path
        d="M347.36,121.67l-.1-.1a.08.08,0,0,0-.11.11l.1.1a.08.08,0,0,0,.11-.11Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "347.255px 121.675px",
        }}
        id="elzy2k925qnkb"
        className="animable"
      />
      <g id="elolisxtn4jv">
        <path
          d="M335.44,108.15c-.68-.26-1.38-.46-2.07-.71l-1-.35-.2-.07-.13,0a3.17,3.17,0,0,0-.49-.17c.09-.26.21-.49.31-.44s.55-.22.31-.41a1.53,1.53,0,0,1-.38-1.55,12.86,12.86,0,0,0,.17-2,5.72,5.72,0,0,1,.28-.55A4.31,4.31,0,0,1,334.4,100a.07.07,0,0,0,0-.14c-1.82.57-3,2.36-3.94,3.89a28.07,28.07,0,0,0-1.31,3,13.89,13.89,0,0,1-.9,1.48,1.36,1.36,0,0,0,0,1.07,1.6,1.6,0,0,0-.69.72,1.35,1.35,0,0,0-.07.89,2,2,0,0,0,.16.44h0a.88.88,0,0,0-.25.57c0,.94,0,1.87,0,2.8v0a18.41,18.41,0,0,0,0,4.45s0,0,0,0h0v0h0a.22.22,0,0,0,.32.13c.1,1,.19,2,.27,3a.08.08,0,0,0,.16,0c-.05-.83,0-1.66,0-2.49l0,0a3.2,3.2,0,0,0,.06-1.07,1.5,1.5,0,0,1,.1-.75.16.16,0,0,0,.31-.07v-.15a5.29,5.29,0,0,1,.79,0c.19,0,.38-.07.56-.1a4.86,4.86,0,0,1,.71-.17.09.09,0,0,0,.08-.13c-.33-.48-.91-.56-1.41-.74a1.38,1.38,0,0,1-.65-.43,5,5,0,0,1,.2-.87,2.46,2.46,0,0,1,.78,0,14.7,14.7,0,0,1,1.85.58c.05,0,.09-.07,0-.1l-1.31-.53-.52-.21-.43-.19-.17-.11a3,3,0,0,1,.25-.37.28.28,0,0,0,0-.4,3.06,3.06,0,0,1-.48-.67c0-.38.1-.76.16-1.13a1.35,1.35,0,0,0,.28-.59,1.42,1.42,0,0,0-.05-.58c.06-.25.13-.49.2-.74a.07.07,0,0,0,0-.07v0a.75.75,0,0,0,.26-.81l0-.07.06-.13a.41.41,0,0,0,.05-.09.93.93,0,0,1,.14-.14c.29-.21.57-.34.73-.68a1.87,1.87,0,0,0,.13-.4,4.42,4.42,0,0,0,.39-.57c.3,0,.59.05.88.06l1.38.33c.08,0,.14-.06.13-.13a14.16,14.16,0,0,1,1.72.5S335.48,108.17,335.44,108.15Z"
          style={{
            opacity: 0.2,
            transformOrigin: "331.356px 111.12px",
          }}
          className="animable"
          id="elxirxpw1lukh"
        />
      </g>
      <g id="elgjlxnbje6nb">
        <path
          d="M337.53,141.68c.15-.18.28-.39.44-.56s-.05-.2-.12-.12a4.17,4.17,0,0,1-1.06.8,5.6,5.6,0,0,1-.71.3L336,142a2.38,2.38,0,0,0-.45-.23c-.15-.05-.36-.07-.45-.1a1.42,1.42,0,0,1-.4-.17c-.3-.19-.57-.45-.86-.65a10.13,10.13,0,0,1-1-.76c-.08-.06-.18.05-.11.11a3.77,3.77,0,0,1,.79.95,9.34,9.34,0,0,0,.53.93,3.07,3.07,0,0,0,.69.66,3.91,3.91,0,0,0,.44.26,1.78,1.78,0,0,1,.32.2.49.49,0,0,0,.44.15.25.25,0,0,0,0,.12.87.87,0,0,0,.3.33l.07.09a.3.3,0,0,0,.3.13l.09.07a1.71,1.71,0,0,0,.65.57.32.32,0,0,0,.38-.51,5.35,5.35,0,0,0-.5-.45.31.31,0,0,0-.32-.39s-.05,0-.08,0c-.05-.36.23-.68.23-1h0l.07-.09C337.26,142,337.39,141.83,337.53,141.68Z"
          style={{
            opacity: 0.2,
            transformOrigin: "335.368px 142.388px",
          }}
          className="animable"
          id="elvqyxnix1hyg"
        />
      </g>
      <g id="elfcc23tkezo">
        <path
          d="M339.32,141.69l-.43.36a2.09,2.09,0,0,0-.4.48,1.77,1.77,0,0,0-.19.56,5,5,0,0,1-.1.56.08.08,0,0,0,.15.06,1.85,1.85,0,0,1,.34-.4,2.27,2.27,0,0,0,.37-.45,5,5,0,0,0,.25-.52c.06-.16.11-.32.18-.48S339.43,141.61,339.32,141.69Z"
          style={{
            opacity: 0.2,
            transformOrigin: "338.852px 142.71px",
          }}
          className="animable"
          id="elqhxhize94j"
        />
      </g>
      <path
        d="M351.33,127.66c-.17-.27-.4-.51-.58-.78l-.26-.38a5.44,5.44,0,0,0-.37-.67.42.42,0,0,0-.16-.14c-.19-.3-.38-.61-.56-.92a2.09,2.09,0,0,0-.25-.44l0,0h0a0,0,0,0,0-.07,0c.14.32.31.62.47.93,0,.14.06.27.1.41a.36.36,0,0,0-.21.45c.08.25.15.52.21.78s0,.26.08.38.11.26.14.4.06.42.12.61.09.12.09.23a.35.35,0,0,1-.21.31c-.08.05,0,.18.08.13s.26-.26.37-.44a1.59,1.59,0,0,0,.13-.22.34.34,0,0,0,.14,0,1,1,0,0,1,.45-.08A.37.37,0,0,0,351.33,127.66Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "350.232px 126.651px",
        }}
        id="eldysbfmt20z"
        className="animable"
      />
      <path
        d="M355.63,130.29A1.81,1.81,0,0,1,355,130a4.78,4.78,0,0,1-.5-.39,2,2,0,0,0-1.13-.47c-.22,0-.42.07-.64,0s-.29-.2-.47-.34a.33.33,0,0,0-.41,0,.2.2,0,0,0-.09.29c.05.09.17,0,.13-.08L352,129l.08.09.06.12a1.37,1.37,0,0,0,.13.2.81.81,0,0,0,.41.21c.35.06.71,0,1.06,0,.67.1,1.22.63,1.9.71A0,0,0,0,0,355.63,130.29Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "353.685px 129.529px",
        }}
        id="elg5zg78kc6q"
        className="animable"
      />
      <path
        d="M352.82,130.79l-.25-.13-.22-.16a1.36,1.36,0,0,1-.35-.44s-.07,0-.1,0a.07.07,0,0,0,0,.1,1.47,1.47,0,0,0,.38.48,2.07,2.07,0,0,0,.24.17,1.11,1.11,0,0,0,.29.1C352.84,130.9,352.88,130.81,352.82,130.79Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "352.365px 130.485px",
        }}
        id="elfoyzc0m6srj"
        className="animable"
      />
      <path
        d="M387.32,79.37a10.84,10.84,0,0,1,1.53,4.26,22.25,22.25,0,0,1,.22,5,32.26,32.26,0,0,1-.74,4.92c-.13.48-.28,1-.46,1.5s-.35,1-.51,1.54-.26,1-.42,1.49-.31,1-.43,1.49-.25.77-.36,1.14-.22.78-.33,1.2c.76,1.2,1.48,2.39,2.14,3.59s1.11,2.22,1.67,3.33a26.3,26.3,0,0,0,1.9,3.19l1.82,2.54a19,19,0,0,1,1.6,2.68,22.2,22.2,0,0,1,1,2.63,4.2,4.2,0,0,1,0,2.8,5.2,5.2,0,0,1-1.86,2.19,8.16,8.16,0,0,1-1.54.84,7,7,0,0,1-1.69.46,6.58,6.58,0,0,1-2.73-.11,10.72,10.72,0,0,1-2.59-1,14.25,14.25,0,0,1-2.62-2c-.79-.77-1.53-1.56-2.22-2.38a45.66,45.66,0,0,1-4.32-6.08c-.65-1.1-1.27-2.18-1.86-3.25s-1.15-2.16-1.71-3.27l-2.46-1.08c-.8-.35-1.62-.68-2.48-1-.35-.15-.7-.29-1.06-.41s-.7-.26-1.05-.42a7.06,7.06,0,0,1-.92-.38l-.87-.41c-.71-.34-1.39-.7-2-1.07s-1.26-.78-1.89-1.23a17.54,17.54,0,0,1-3.2-2.84,5.38,5.38,0,0,1-1.43-3.89,9.39,9.39,0,0,1,.48-2.83,4.45,4.45,0,0,1,1.7-2.33,4.15,4.15,0,0,1,2.31-.72,13.5,13.5,0,0,1,2.47.19,20.65,20.65,0,0,1,3.07,1c1,.39,1.94.82,2.89,1.29s1.92,1,2.85,1.54S373,94.46,374,95l.76.51a6.87,6.87,0,0,0,.83.48,12.48,12.48,0,0,1-.4-2,21.15,21.15,0,0,1-.15-2.12,33.16,33.16,0,0,1,.61-6.38c.2-1,.44-2.06.72-3a17.85,17.85,0,0,1,1.13-2.91,13.77,13.77,0,0,1,1.23-2A4.57,4.57,0,0,1,380.53,76a3.27,3.27,0,0,1,2.24-.25,5.65,5.65,0,0,1,2.06,1A11.46,11.46,0,0,1,387.32,79.37Z"
        style={{
          fill: "#213E60",
          transformOrigin: "375.818px 100.955px",
        }}
        id="elixnqblq5xe"
        className="animable"
      />
      <path
        d="M388.5,110.44l.1-.25a.58.58,0,0,0-.47-.73.6.6,0,0,0-.51-.75l.12-.43a.62.62,0,0,0-.43-.74l-.15,0a2.32,2.32,0,0,0-.44-1c-.25-.33-.9-.85-.8-1.31a.6.6,0,0,0-.29-.67l-.75-.39,0-.08a.36.36,0,0,0-.22-.52.61.61,0,0,1-.2-.09.55.55,0,0,0-.06-.18.65.65,0,0,0-.15-.18,3.93,3.93,0,0,1,.14-.89,2.21,2.21,0,0,1,.08-.35,3.44,3.44,0,0,0,.3-.53,4.35,4.35,0,0,0,.25-.63l.06-.1a11.26,11.26,0,0,0,1-2.75.17.17,0,0,0-.27-.16c.09-.29.16-.57.23-.86a19,19,0,0,1,.7-2.77s0,0,0,0a22.41,22.41,0,0,0-.91,2.53c-.14.43-.32.83-.47,1.25s-.23.73-.36,1.09a.41.41,0,0,1,0-.09s0,0,0,0,0,0,0,0v0c0,.06,0,0,0,0h0l.06,0a.24.24,0,0,0-.17-.4h-.34a1,1,0,0,1-.3,0,1.11,1.11,0,0,1-.3-.12,1.13,1.13,0,0,1-.24-.25.07.07,0,0,0-.12.07,1.63,1.63,0,0,0,.23.29,2.52,2.52,0,0,0,.3.27,1.14,1.14,0,0,0,.29.15,4.74,4.74,0,0,0-.91-.26A15,15,0,0,1,382,97.8s0,0,0,0a11.63,11.63,0,0,1,2.15,1.28,1.07,1.07,0,0,1,.3.5l-.25.13-.12,0-.22.08-.35.13c-.11,0-.22.08-.33.1s0,0,0,0h-.1a.1.1,0,0,1-.07,0s0-.06-.06-.07a.08.08,0,0,0-.09,0,.27.27,0,0,0,.06.26.69.69,0,0,0,.68.13,1.49,1.49,0,0,0,.4-.15.9.9,0,0,0-.22.64.18.18,0,0,0,.07.11.08.08,0,0,1,0,0c-.07.06,0,.19.09.13l.07-.06c-.12.19-.24.38-.37.57l-.12,0a.34.34,0,0,0-.4.24c-.26.66-1.1.38-1.61.24a6.12,6.12,0,0,0-1.9-.24,0,0,0,0,0,0,.06,1.84,1.84,0,0,0,1.08.43,8.79,8.79,0,0,1,1.52.43,2.83,2.83,0,0,1,.71.31,1.48,1.48,0,0,0,.35.25l.32.17c.11.06.21.15.32.22l.17.07h.05s0,0,0,0L384,104a.44.44,0,0,0,0,.62c.22.22.47.42.7.62a2,2,0,0,0,.47,1.27c.25.33.91.85.77,1.3a.61.61,0,0,0,.44.75l.05,0-.12.52a.58.58,0,0,0,.32.67l-.3.62c-.2.47.31,1.2.83.8l.27-.18a.87.87,0,0,0,.11.09,6.78,6.78,0,0,1,2.89,3.17.08.08,0,0,0,.15-.05A7.18,7.18,0,0,0,388.5,110.44Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "385.096px 104.187px",
        }}
        id="el1b9duvh8b7g"
        className="animable"
      />
      <path
        d="M384.4,96.73l-.23-.14c-.07,0-.12-.12-.19-.17a1.64,1.64,0,0,0-.22-.14l-.25-.12a6.93,6.93,0,0,0-1-.37s-.1.07,0,.1a5.4,5.4,0,0,0,.86.58,3,3,0,0,0,.48.23,2.1,2.1,0,0,0,.24.06l.28.11A.08.08,0,0,0,384.4,96.73Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "383.448px 96.33px",
        }}
        id="elz8ci2k0z6kn"
        className="animable"
      />
      <g id="elz1n06k12l2q">
        <path
          d="M393.83,122.05c-.69.36-1.34.74-2,1.16-.1.06-.23.19-.35.2s-.3-.15-.41-.18H391a4.77,4.77,0,0,0-.17-.93c-.16-.48-.35-1-.55-1.41,0,0-.05,0-.05,0a12.11,12.11,0,0,1,.32,1.45c0,.24.09.48.14.71l.05.17c-.15,0-.29.06-.43.09l-.37.1-.4-.27c-.3-.19-.67-.31-.84-.64a2.43,2.43,0,0,1-.21-.68c-.07-.26-.14-.51-.22-.77a10.92,10.92,0,0,1-.37-1.6s-.05,0-.05,0c0,.45.05.91,0,1.36s0,.9,0,1.35c0,.21,0,.42,0,.62s0,.18,0,.27a.8.8,0,0,0-.48-.17,1,1,0,0,0-.32.09,1.84,1.84,0,0,1-.19-.25,2.28,2.28,0,0,0-.58-.44,7.69,7.69,0,0,0-1.52-.48,5.19,5.19,0,0,1-2-1,.08.08,0,0,0-.11.11,6.75,6.75,0,0,0,1.73,1.37c.63.35,1.42.54,1.77,1.22a1.12,1.12,0,0,0,.62.66,1.3,1.3,0,0,0,.3,0,1.17,1.17,0,0,0,.05.11.89.89,0,0,0,.79.44.65.65,0,0,0,.33-.12,1.48,1.48,0,0,0,.26.24,1.51,1.51,0,0,0,.86.18,4.32,4.32,0,0,0,.87-.17,2,2,0,0,0,.52-.19l.13,0a1.3,1.3,0,0,0,1.68-.48,17.13,17.13,0,0,0,1.45-2C394,122.08,393.89,122,393.83,122.05Z"
          style={{
            opacity: 0.2,
            transformOrigin: "388.324px 122.233px",
          }}
          className="animable"
          id="el0z6hp1agiv7"
        />
      </g>
      <g id="elujgbo8bo4fb">
        <path
          d="M387.26,119.56c0-.06-.09-.09-.1,0a7.4,7.4,0,0,0-.09,1.76c0,.1.16.1.15,0A6.76,6.76,0,0,1,387.26,119.56Z"
          style={{
            opacity: 0.2,
            transformOrigin: "387.156px 120.449px",
          }}
          className="animable"
          id="eln5n56la31so"
        />
      </g>
      <g id="elgh7zzv8v3qu">
        <path
          d="M380.49,116.48a.89.89,0,0,0-.73-.19,1.51,1.51,0,0,1-.09-.18.12.12,0,0,0,0-.21.53.53,0,0,1-.31-.37,1.28,1.28,0,0,1,.1-.47c.1-.39-.68-.87-.46-1.2s1.45-.56,1.68-.87c.07,0,.13-.11.2-.15a.13.13,0,0,0,0-.19c.26-.34.51-.68.74-1,0,0,0-.06-.05,0-.31.32-.59.66-.88,1a10.1,10.1,0,0,1-2.12.21,2,2,0,0,1-.35-.09.37.37,0,0,1-.16-.1,1.11,1.11,0,0,1,0-.26c0-.16,0-.32,0-.48a1.44,1.44,0,0,0-.54-1.08,1.26,1.26,0,0,0-.56-.23l-.27,0a.07.07,0,0,1,0,0,2.12,2.12,0,0,0-1.61-1.22c-.12,0-.21.16-.08.21,1,.41.34,1.59,1,2.23a2.38,2.38,0,0,0,.37.24.27.27,0,0,1,0,.09,3.4,3.4,0,0,0,.07,1.19,1.77,1.77,0,0,0,1.31,1.13c.09.32.24.64.34.93a7.24,7.24,0,0,0,1,1.93.48.48,0,0,0,.86-.13c0-.1.32.15.36.22a2.57,2.57,0,0,1,.27.52,1.36,1.36,0,0,0,.6.63c.11.06.24-.09.14-.18C380.85,117.8,381.06,116.93,380.49,116.48Z"
          style={{
            opacity: 0.2,
            transformOrigin: "378.278px 114.002px",
          }}
          className="animable"
          id="elutg1038jp5"
        />
      </g>
      <g id="elme5zfp6tuuc">
        <path
          d="M379.21,109.91a2.52,2.52,0,0,0-.78.45,3.88,3.88,0,0,0-.64.64c-.06.08,0,.19.11.11a3.59,3.59,0,0,1,.64-.59c.23-.17.49-.31.74-.46C379.36,110,379.3,109.89,379.21,109.91Z"
          style={{
            opacity: 0.2,
            transformOrigin: "378.542px 110.523px",
          }}
          className="animable"
          id="elj9gvqp2bpnl"
        />
      </g>
      <g id="eletemsq6g9vb">
        <g
          style={{
            opacity: 0.2,
            transformOrigin: "367.801px 103.818px",
          }}
          className="animable"
          id="el0c3gcpiwxqd"
        >
          <path
            d="M369.76,103.72Z"
            id="elih2kg11353k"
            className="animable"
            style={{
              transformOrigin: "369.76px 103.72px",
            }}
          />
          <path
            d="M373.74,106.18c-.14-.09-.29-.16-.42-.26s-.21-.22-.34-.31l-.77-.54a2.5,2.5,0,0,0-1-.5.87.87,0,0,0-.65-.25,1.85,1.85,0,0,1-.47,0c-.15,0-.32-.21-.16-.34s0-.16-.1-.12a.34.34,0,0,0-.05-.14l0,0a.25.25,0,0,1,0-.07s0,0,0,0a.37.37,0,0,1,0-.21c0-.1-.09-.17-.17-.13a.49.49,0,0,0-.24.31.76.76,0,0,0,0,.15.12.12,0,0,0-.07,0,.13.13,0,0,1,0,.06l-.07,0a.31.31,0,0,0-.12.19l-.15-.12a1.21,1.21,0,0,0,.43-.88,1.64,1.64,0,0,0,.33-.66.43.43,0,0,0-.38-.53.85.85,0,0,1,.3-.58s0,0,0,0a1.37,1.37,0,0,0-.49.64.38.38,0,0,0-.13.09c-.18.19-.35.38-.51.58a1.08,1.08,0,0,0-1.1,0c-.27.15-.41.36-.74.4a2.74,2.74,0,0,1-.94-.13c-.65-.18-1.29-.47-1.92-.7s-1.38-.46-2.07-.71c-.09,0-.13.11,0,.15a11.12,11.12,0,0,1,2,1.08c.57.37,1.06.85,1.63,1.22a2.24,2.24,0,0,0,1.61.36,1.6,1.6,0,0,0,.31-.1.36.36,0,0,0,.17.21c.86.34,1.7.71,2.57,1,.4.14.83.21,1.23.35a5.36,5.36,0,0,0,1.23.34.13.13,0,0,0,.14-.1,2,2,0,0,0,.38.15,2.48,2.48,0,0,1,.39.1l.34.17A.12.12,0,1,0,373.74,106.18Z"
            id="el5cq1o2ueplg"
            className="animable"
            style={{
              transformOrigin: "367.801px 103.818px",
            }}
          />
        </g>
      </g>
      <path
        d="M382.53,76.69c-1.09-.22-2,.62-2.73,1.37a5.12,5.12,0,0,0-1.4,2.66,1.27,1.27,0,0,0-.72.89,1.6,1.6,0,0,0,.06.54,1.56,1.56,0,0,0-.2.16,1.44,1.44,0,0,0-.44,1c-.09,1-.28,1.87-.45,2.83-.07.4-.12.81-.16,1.22a4,4,0,0,0-.12.83v.25c0,.28-.06.57-.11.85,0,0,.05.1.09.1,0,.19,0,.38,0,.57a8.46,8.46,0,0,0,.06,1.67s.07,0,.06,0a8.41,8.41,0,0,1,.58-3.24,5.55,5.55,0,0,0,.17-.73,12.91,12.91,0,0,0,1.05-2.84c0-.23.09-.46.13-.69l0,0h0l.05,0,.05-.07a1,1,0,0,1,.22-.2,1.56,1.56,0,0,1,.28-.16s0-.05,0,0a1.27,1.27,0,0,0-.38.07.89.89,0,0,1,.39-.3,1.41,1.41,0,0,1,1.05.06c.14.08.28.16.43.23a.05.05,0,1,0,0-.09,6.12,6.12,0,0,0-1-.65,1.75,1.75,0,0,1-.32-.41,1.16,1.16,0,0,0,0-.18,1.21,1.21,0,0,0-.12-.44.63.63,0,0,0,.53-1,.5.5,0,0,1,0-.13c.32-.42.73-.74,1.13-.37l0,0a.15.15,0,0,0,.21-.17.66.66,0,0,0-.63-.52c-.32-.6.3-1.57.62-2.09,0-.07,0-.12-.1-.09a1.73,1.73,0,0,1,1.65-.81A0,0,0,0,0,382.53,76.69Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "379.395px 84.1422px",
        }}
        id="elutiziyaygx"
        className="animable"
      />
      <path
        d="M380.57,84.8c-.42-.19-.84-.35-1.27-.52-.08,0-.14.11-.06.15.42.18.84.36,1.27.51l1.32.47s0,0,0,0Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "380.516px 84.845px",
        }}
        id="elbmpwlajnlgt"
        className="animable"
      />
      <path
        d="M369.77,93.8a6,6,0,0,0-2.12-1,9.62,9.62,0,0,1-1.81-.76l-.41-.23c-.4-.22-.57-.7-1.06-.75a1.32,1.32,0,0,0-.78.21,1.18,1.18,0,0,0-.41-.39,1.11,1.11,0,0,0-.82-.09,1.16,1.16,0,0,0-.38.2l-.08.07a2,2,0,0,0-1.47,0,7.85,7.85,0,0,0-1.55.66.08.08,0,0,0,.07.14c.69-.21,1.58-.51,2.22,0,.26.2.42.46.77.5a.76.76,0,0,0,.47-.07h0a.74.74,0,0,0,1.24.69c.15-.12.35-.34.55-.48l.11.06a1.66,1.66,0,0,0,.53.18c.34.06.66,0,1,0H366l0,0a5.26,5.26,0,0,0,.88.17,12.53,12.53,0,0,1,1.23.57s.07,0,0-.06l-.57-.37a15.79,15.79,0,0,1,2.07.8C369.76,93.92,369.83,93.85,369.77,93.8Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "364.321px 92.3144px",
        }}
        id="elnr8ncs68hcl"
        className="animable"
      />
      <g id="el8rv69hjiob4">
        <path
          d="M377,103.08a21.82,21.82,0,0,0-1.92,2.26,4.38,4.38,0,0,0-.8,1.28,3.52,3.52,0,0,1-.3.69,3.45,3.45,0,0,1-.2.32,1.71,1.71,0,0,0-.22.25.08.08,0,0,0,.09.12,1.65,1.65,0,0,0,.57-.3,2.1,2.1,0,0,0,.51-.52,4.76,4.76,0,0,0,.61-1.45,6.56,6.56,0,0,1,1.71-2.6S377.06,103.05,377,103.08Z"
          style={{
            opacity: 0.2,
            transformOrigin: "375.299px 105.538px",
          }}
          className="animable"
          id="elne28wgf5eue"
        />
      </g>
      <g id="elb6h32t8enwc">
        <path
          d="M377.69,103.5c-.68,1-1.36,1.94-2,2.92-.06.08.08.16.14.08.65-1,1.29-2,1.92-3C377.74,103.5,377.71,103.48,377.69,103.5Z"
          style={{
            opacity: 0.2,
            transformOrigin: "376.713px 105.012px",
          }}
          className="animable"
          id="el4jx43y4y8aq"
        />
      </g>
    </g>
    <g
      id="freepik--character-3--inject-25"
      className="animable"
      style={{
        transformOrigin: "382.314px 283.15px",
      }}
    >
      <path
        d="M433.07,342.38l0,.14c-.31,1.23-2.63,10.32-5.68,22.33-.22.87-.45,1.76-.69,2.66-5.08,20-11.85,46.55-15.05,59.15h-6.9c0,.14,0,.3,0,.45,0-.16,0-.31,0-.45H354.08c5.21-20.3,18.43-73.45,20.77-82.84,0-.19.09-.36.13-.51l.23-.93Z"
        style={{
          fill: "rgb(173, 99, 89)",
          transformOrigin: "393.575px 384.745px",
        }}
        id="eljna7nh9428d"
        className="animable"
      />
      <path
        d="M433.07,342.38l0,.14-5.28,23.11-.62,2.74L413.8,426.66h-9.09c0,.14,0,.3,0,.45,0-.16,0-.31,0-.45H353.76l21.09-82.84.13-.51.23-.93Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "393.415px 384.745px",
        }}
        id="elqux2guvaav"
        className="animable"
      />
      <path
        d="M462.48,426.66H404.71c0,.14,0,.3,0,.45,0-.16,0-.31,0-.45,0-.9-.07-1.78-.1-2.63,0-1.12-.08-2.27-.13-3.4,0-.42,0-.84-.05-1.25s0-.54,0-.81,0-.71-.05-1.07,0-.85,0-1.26,0-.85,0-1.26c0-.18,0-.35,0-.53,0-.74-.06-1.43-.09-2.09,0-.32,0-.62,0-.92,0-.13,0-.26,0-.39v-.11c0-.14,0-.28,0-.4a1.93,1.93,0,0,0,0-.24c0-.34,0-.66,0-1a1.77,1.77,0,0,0,0-.23c0-.12,0-.24,0-.36,0-.39,0-.75,0-1.09s0-.4,0-.59,0-.54,0-.76a1.85,1.85,0,0,0,0-.24,1.55,1.55,0,0,0,0-.22c0-.22,0-.33,0-.33l-.49-.29h0l-.65-.38h-.05l-.05,0-.6-.37c-.92-.53-1.8-1-2.64-1.48l-.83-.45c-.54-.3-1.07-.57-1.58-.83-1-.54-2-1-2.87-1.45l-1.28-.61-.59-.28-.13-.07-.62-.28h0c-.47-.22-.91-.41-1.31-.58l-.72-.31c-.72-.3-1.28-.52-1.67-.67l-.21-.09-.21-.07a.42.42,0,0,0-.18-.06l-.08,0c-.08-.2-.14-.39-.21-.58s-.15-.4-.21-.6c-.21-.61-.42-1.23-.62-1.86s-.46-1.49-.68-2.25c-.16-.5-.31-1-.46-1.54s-.27-1-.4-1.44c-.62-2.21-1.18-4.46-1.7-6.73-.11-.45-.21-.9-.31-1.35s-.24-1.07-.35-1.61c-.22-1-.43-2.08-.63-3.11-.09-.39-.17-.77-.25-1.16-.48-2.59-.93-5.14-1.33-7.59,0-.24-.07-.49-.11-.73l-.3-2c-.08-.58-.18-1.16-.26-1.74-.18-1.35-.37-2.66-.54-3.94,0-.3-.07-.6-.11-.9-.11-.91-.22-1.81-.32-2.68-.06-.43-.1-.86-.15-1.28l-.12-1c0-.26-.05-.51-.08-.76a1.11,1.11,0,0,0,0-.19c-.05-.42-.09-.84-.13-1.23-.12-1.2-.22-2.29-.31-3.26-.06-.58-.1-1.11-.14-1.6a.15.15,0,0,0,0-.07c-.08-.94-.14-1.73-.19-2.31v0c0-.39-.05-.7-.06-.91s0-.26,0-.3v0h78.83s.22,2.78.61,7.64c0,.49.08,1,.11,1.55.23,2.86.5,6.31.81,10.23,0,.54.09,1.09.14,1.65.14,2,.31,4.09.49,6.3.1,1.3.21,2.63.31,4,.05.51.08,1,.12,1.51q.36,4.49.73,9.35c.66,8.53,1.39,17.84,2.13,27.47,0,.15,0,.3,0,.44q.27,3.71.56,7.45Q462.23,423.3,462.48,426.66Z"
        style={{
          fill: "rgb(173, 99, 89)",
          transformOrigin: "420.018px 384.8px",
        }}
        id="elxsbup37t9xe"
        className="animable"
      />
      <path
        d="M465.15,426.66H404.71c0-.86-.07-1.74-.11-2.63,0-1.12-.08-2.27-.13-3.4-.07-1.95-.14-3.87-.22-5.65,0-.18,0-.35,0-.53,0-1.22-.09-2.36-.14-3.4v-.11c0-.57,0-1.11-.06-1.61a1.77,1.77,0,0,0,0-.23c0-.79,0-1.48-.08-2,0-.28,0-.54,0-.76a1.85,1.85,0,0,0,0-.24,1.55,1.55,0,0,0,0-.22c0-.22,0-.33,0-.33h0l-.49-.29h0l-.65-.38h0l-.7-.41c-.92-.53-1.8-1-2.64-1.48s-1.64-.89-2.41-1.28c-1-.54-2-1-2.87-1.45l-1.28-.61-.59-.28-.13-.06h0l-.62-.27h0l-1.31-.58-.72-.31c-.72-.3-1.28-.52-1.67-.67l-.21-.09-.21-.07a.42.42,0,0,0-.18-.06l-.08,0c-.08-.2-.14-.39-.21-.58s-.15-.41-.22-.61c-.21-.61-.41-1.23-.61-1.85s-.46-1.49-.68-2.25c-.16-.5-.31-1-.46-1.54s-.27-1-.4-1.44c-.62-2.21-1.18-4.46-1.7-6.73-.11-.45-.21-.9-.31-1.35s-.24-1.07-.35-1.61v0c-.22-1-.44-2.07-.63-3.09-.65-3.24-1.21-6.42-1.69-9.48l-.3-2c-.08-.58-.18-1.16-.26-1.74-.18-1.35-.37-2.66-.54-3.94,0-.3-.07-.6-.11-.9-.11-.91-.22-1.81-.32-2.68-.06-.43-.1-.86-.15-1.28l-.12-1c0-.26-.05-.51-.08-.76a1.11,1.11,0,0,0,0-.19c-.05-.42-.08-.84-.13-1.23-.12-1.2-.22-2.29-.31-3.26-.05-.58-.1-1.11-.14-1.6a.15.15,0,0,0,0-.07c-.07-.95-.14-1.73-.19-2.31v0c0-.39,0-.7-.06-.91s0-.26,0-.3v0h78.83a66.15,66.15,0,0,1,7,49S464.26,413.45,465.15,426.66Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "421.182px 384.61px",
        }}
        id="elt2x30eza0b"
        className="animable"
      />
      <path
        d="M411.18,408.54c-2.65-1.84-5.52-3.39-8.33-5s-5.8-3.18-8.79-4.58a144.47,144.47,0,0,0-18.18-6.59c-.16-.05-.26.2-.11.27,5.93,2.54,11.67,5.46,17.57,8.08,3,1.31,6,2.57,8.92,3.88s5.87,2.79,8.86,4A.07.07,0,0,0,411.18,408.54Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "393.438px 400.482px",
        }}
        id="eldw62s6tevor"
        className="animable"
      />
      <path
        d="M395,379.53c-.08-2.9-.28-5.81-.42-8.71-.34-6.85-.61-13.75-1.25-20.58a.21.21,0,0,0-.42,0c-.09,5.3.12,10.62.22,15.92.06,2.65.14,5.31.21,8a74.1,74.1,0,0,1,.05,7.6c-.14,1.91-.56,5.63-3.06,5.86s-3.63-2.32-4.22-4.18a72.61,72.61,0,0,1-2.5-14.73c-.29-2.9-.58-5.8-.75-8.72a78.89,78.89,0,0,1-.29-9c0-.19-.28-.18-.29,0-.17,3-.58,6-.68,9a89.44,89.44,0,0,0,.09,9c.18,2.86.42,5.74.85,8.58a30.78,30.78,0,0,0,1.85,7.58c.86,2,2.35,3.86,4.6,4.3a5,5,0,0,0,.84.09c0,.61.11,1.23.15,1.84.07,1,.19,1.92.32,2.87a22.17,22.17,0,0,0,.59,2.78,10.27,10.27,0,0,0,1,2.65c.08.14.26.06.28-.08a13.29,13.29,0,0,0-.23-2.74c-.13-.93-.26-1.87-.45-2.8s-.36-1.81-.55-2.72c-.12-.61-.21-1.24-.32-1.86a4.44,4.44,0,0,0,3.33-2.61A16.38,16.38,0,0,0,395,379.53Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "388.294px 374.892px",
        }}
        id="elisak6tud3vl"
        className="animable"
      />
      <path
        d="M457.88,377.86c-4.16.28-8.26.82-12.43.33a21.66,21.66,0,0,1-10.83-4.25c-6.86-5.32-9.87-14-11.72-22.19a.15.15,0,0,0-.3,0c.78,7.09,2.31,14.41,6.88,20.11a22.08,22.08,0,0,0,7.29,6,21.47,21.47,0,0,0,9.64,2A45.91,45.91,0,0,0,458,378.33.24.24,0,0,0,457.88,377.86Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "440.391px 365.734px",
        }}
        id="el83e8bc31x58"
        className="animable"
      />
      <path
        d="M404.71,426.66c0,.14,0,.3,0,.45,0-.16,0-.31,0-.45h-.29c-.3-4.56-1-18.32-1-21.44v-.47c0-.12.49.06.51.18s0,.27.05.45c.31,3,1.08,13.63,1.26,17.18.07,1.36.13,2.73.17,4.1Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "404.415px 415.91px",
        }}
        id="eln3tvj0rrq4"
        className="animable"
      />
      <path
        d="M442.63,305.37c-8.8,12.18-25,17.53-39.26,19.2-14.58,1.71-31.1,1.18-44.69-4.93a35.71,35.71,0,0,1-15.17-12.18c-3.95-5.86-4.7-12.2-1.09-18.07,2.91-4.73,9.62-8.35,9.42-12.54s-3.77-7.32-4.92-11.3c-1.95-6.79,1.48-12.13,6-16.84,10.75-11.18,7-25,13.24-38.52,3.57-7.7,14-22.09,34.32-16.81,7.72,2,13.27,8.71,16.74,15.77,4.07,8.31,2,19.6,6.91,27.54,4.16,6.76,9.79,7.59,13.79,14.7,1.73,3.09,2.68,6.74-.28,14.39-1.08,2.76-2.16,7-.88,10.11,1.77,4.37,7.11,6.15,9.07,10.71C448.55,292.87,446.51,300,442.63,305.37Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "393.581px 258.829px",
        }}
        id="elgdfvs9zwali"
        className="animable"
      />
      <path
        d="M348.05,309c-6.91-.78-10.33-10.18-6.23-15.27,2.59-3.23,6.66-4.87,9.26-8.08,4.28-5.29,0-9.66-2.69-14.51-5.86-10.51,1-18.14,8.37-25.19,5.57-5.34,6.46-11.2,6.47-18.66,0-.11-.19-.12-.2,0-.27,5.51-.75,10.94-4.33,15.41-2.91,3.64-6.9,6.23-9.71,10-4.71,6.31-5,12.92-1.12,19.68,1.11,1.94,3.15,4.1,3.67,6.25,1.21,5.08-2.47,7.91-6,10.61-2.69,2.08-5.67,4.38-6.55,7.85-1.33,5.25,3.62,12.05,9,12.34C348.25,309.43,348.33,309,348.05,309Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "351.001px 268.317px",
        }}
        id="ell6a5pdc9zt"
        className="animable"
      />
      <path
        d="M352,314c-4.33-2.36-9-4.47-11.7-8.84-4-6.47.34-11.71,4.39-16.62,1.74-2.12,3.17-4.21,2.93-7.05-.34-4.27-3.6-7.7-4.31-11.91-1.7-10.05,7.89-16.63,12.51-24.28,4.73-7.8,6-16.74,7.39-25.58a.15.15,0,0,0-.29-.05c-1.9,11.3-4.68,22-12.1,30.94-5.18,6.27-10.69,13.05-7.74,21.63.72,2.11,2.07,4,2.74,6.1,1.35,4.19.34,7-2.29,10.15s-5.48,6.17-5.79,10.34c-.6,8.08,7.59,13,14,15.82A.36.36,0,0,0,352,314Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "350.459px 267.114px",
        }}
        id="ells3l18n16b"
        className="animable"
      />
      <path
        d="M447.57,284c-3.6-4.74-9.11-6.95-8-14,.79-4.84,3.23-8.78,2.08-13.84-1-4.18-3.76-7.33-7-10-4.15-3.36-8.69-6-11.78-10.51-3.38-4.89-5-10.71-6.73-16.31,0-.11-.22-.06-.2,0,1.85,7.65,4,15.48,10,21,3.13,2.89,6.88,5,10,7.95,5.58,5.27,5.74,11.26,3.67,18.18-.95,3.17-1.78,6.35-.24,9.5s4.61,5,6.82,7.6c9.35,11-3.88,25.92-15.17,28.4-.5.11-.41.9.11.8,8.45-1.6,17.16-9.69,18.75-18.19A13.47,13.47,0,0,0,447.57,284Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "433.042px 266.027px",
        }}
        id="eltgluhqcvp8s"
        className="animable"
      />
      <path
        d="M447.4,290.08c-.26-5.08-3.5-7.79-6.06-11.69-4-6.14-.28-12.46,0-19.1.17-4.62-1.81-8.47-4.75-11.74-4-4.4-8.93-7.47-12.22-12.57a33.06,33.06,0,0,1-5.15-18.29c0-.12-.17-.09-.17,0a31.38,31.38,0,0,0,8.91,23.8c3.95,4,9.21,7.16,11.52,12.62,2.45,5.79-.31,11.23-.91,17.09a13,13,0,0,0,2.77,9.74c1.61,2.13,3.55,4.05,4.5,6.65,1.27,3.52.63,7.51-.7,10.94-4.22,10.83-15.17,17.91-25.74,20-.37.08-.32.69.06.62a37,37,0,0,0,23.86-15.48C445.75,299,447.63,294.58,447.4,290.08Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "433.208px 267.383px",
        }}
        id="elz7a45q3y71n"
        className="animable"
      />
      <path
        d="M406,267.71c-3.68,26.41-24.84,78.27-34.89,83.34-2.7,1.37-13.36,3.74-18.83,1.84-11.1-3.87-29-28.45-41.13-50.82-3.93-7.25,27.43-19.74,35.94-17.82,3.29.74,11.76,19.95,12.88,18.93,5.71-5.26,26.59-33.72,31.11-39.6C400.81,250.87,407.3,258.15,406,267.71Z"
        style={{
          fill: "rgb(235, 148, 129)",
          transformOrigin: "358.488px 305.189px",
        }}
        id="elkjm8gqzcdti"
        className="animable"
      />
      <path
        d="M314.38,307.42c-6.19-7.4-11.81-26.7-14-39.15-1.15-6.6-1.77-25.28,1.77-26.35,3.22-1,5.19,4.43,5.19,4.43s.93-9.16,4.07-9.76c4.61-.89,5.41,7.39,5.41,7.39s.08-8.44,4.67-9.38,5.42,8,5.42,8-.26-7.74,3.9-6.75c5,1.19,4,15.45,6.42,22.45.55,1.59,7.31,31.62,7.31,31.62Z"
        style={{
          fill: "rgb(235, 148, 129)",
          transformOrigin: "322.009px 270.975px",
        }}
        id="el12w2xop5dof"
        className="animable"
      />
      <path
        d="M307.25,246.41a79.09,79.09,0,0,0,4.49,22.27c.7,2,1.52,4.05,2.25,6.08,0,.08.15,0,.12-.05a107.86,107.86,0,0,1-2.92-11c-.85-3.66-1.56-7.34-2.35-11-.45-2.09-.83-4.19-1.26-6.27C307.54,246.22,307.25,246.22,307.25,246.41Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "310.682px 260.532px",
        }}
        id="elx9uotv8qzoq"
        className="animable"
      />
      <path
        d="M316.69,243.76c.06,1.77.16,3.51.39,5.27s.57,3.64.95,5.44a93.63,93.63,0,0,0,2.89,10.36c.66,1.95,1.48,3.84,2.26,5.75.05.13.24,0,.2-.1-1.15-3.39-2-6.89-2.92-10.36s-1.58-6.92-2.27-10.4c-.4-2-.82-4-1.22-6C316.94,243.59,316.68,243.59,316.69,243.76Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "320.038px 257.131px",
        }}
        id="elbju96up7so5"
        className="animable"
      />
      <path
        d="M326.91,242.27a78.74,78.74,0,0,0,1.33,12.42,107.78,107.78,0,0,0,3,12.35.07.07,0,0,0,.14,0c-.68-4.13-1.43-8.26-2.1-12.4s-1.38-8.25-2.22-12.35C327,242.19,326.91,242.19,326.91,242.27Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "329.145px 254.661px",
        }}
        id="elnecewct71k"
        className="animable"
      />
      <path
        d="M351.45,289.76s3-12,1.87-17.59-11.93-23.81-15.63-20.83c-4.79,3.85-.43,16,2.4,21.61,0,0-11.08,8.89-9.62,18.66S351.45,289.76,351.45,289.76Z"
        style={{
          fill: "rgb(235, 148, 129)",
          transformOrigin: "341.956px 273.266px",
        }}
        id="elobvd5lpdr9s"
        className="animable"
      />
      <path
        d="M336.62,252.88c-2.55,7,1.58,14,4,19.65a.7.7,0,0,1-.39.93c-4.46,4.07-9.89,11.24-10,18,0,.19-.24.24-.26,0-.7-7.11,4.2-14.62,9.3-18.73-2.52-5.77-6.39-13-2.65-19.88A0,0,0,1,1,336.62,252.88Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "335.29px 272.236px",
        }}
        id="elkw8vi6lddz"
        className="animable"
      />
      <path
        d="M396.54,320l-28-31.66a271.68,271.68,0,0,1,20.16-25.48c12.22-13.73,21-10.74,18.53,13.91A157.13,157.13,0,0,1,396.54,320Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "388.094px 287.359px",
        }}
        id="elal6eo2a10od"
        className="animable"
      />
      <path
        d="M373.18,284.19c2.34,2.11,4.38,4.59,6.54,6.88s4.11,4.39,6.1,6.65q6.17,7,12,14.3c.07.09-.06.22-.14.14q-6.35-6.74-12.52-13.63c-2.05-2.28-4-4.62-6-7s-4.28-4.69-6.14-7.25C373,284.24,373.1,284.12,373.18,284.19Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "385.429px 298.177px",
        }}
        id="el5vpsnwzkt82"
        className="animable"
      />
      <g id="elfz4e34qdus9">
        <path
          d="M407.25,276.72A157.35,157.35,0,0,1,396.55,320l-25.7-29.07,31.2-36.09C406.46,255.75,408.67,262.76,407.25,276.72Z"
          style={{
            opacity: 0.1,
            transformOrigin: "389.264px 287.42px",
          }}
          className="animable"
          id="elswhv6k07ies"
        />
      </g>
      <path
        d="M459.27,343.1l-85.67.23,4.6-28.78s-6.49-9.7-5.41-20,23.74-38.76,25.52-40.28c7.16-6.13,14.86-5.24,19.65-2.64C446.26,267,459.27,343.1,459.27,343.1Z"
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "415.969px 296.486px",
        }}
        id="elbu83u2eydnq"
        className="animable"
      />
      <path
        d="M419.56,271.87a1.88,1.88,0,1,1-1.88,1.88A1.88,1.88,0,0,1,419.56,271.87Zm-23.43,1.88a1.88,1.88,0,1,0,1.87-1.88A1.88,1.88,0,0,0,396.13,273.75Zm10.77-15.19a1.88,1.88,0,1,0,1.88-1.87A1.88,1.88,0,0,0,406.9,258.56Zm32.33,46a1.88,1.88,0,1,0,1.88-1.87A1.88,1.88,0,0,0,439.23,304.6Zm-21.55,0a1.88,1.88,0,1,0,1.88-1.87A1.88,1.88,0,0,0,417.68,304.6Zm-21.55,0a1.88,1.88,0,1,0,1.87-1.87A1.88,1.88,0,0,0,396.13,304.6Zm-21.56,0a1.88,1.88,0,1,0,1.88-1.87A1.88,1.88,0,0,0,374.57,304.6Zm53.89-15.19a1.88,1.88,0,1,0,1.87-1.87A1.88,1.88,0,0,0,428.46,289.41Zm-21.56,0a1.88,1.88,0,1,0,1.88-1.87A1.88,1.88,0,0,0,406.9,289.41Zm-21.55,0a1.88,1.88,0,1,0,1.87-1.87A1.88,1.88,0,0,0,385.35,289.41Zm53.88,46a1.88,1.88,0,1,0,1.88-1.87A1.88,1.88,0,0,0,439.23,335.45Zm-21.55,0a1.88,1.88,0,1,0,1.88-1.87A1.88,1.88,0,0,0,417.68,335.45Zm-21.55,0a1.88,1.88,0,1,0,1.87-1.87A1.88,1.88,0,0,0,396.13,335.45Zm-21.39.77a1.85,1.85,0,0,0,1.71,1.11,1.88,1.88,0,1,0-1.39-3.15Zm75.27-16a1.88,1.88,0,1,0,1.88-1.87A1.88,1.88,0,0,0,450,320.26Zm-21.55,0a1.88,1.88,0,1,0,1.87-1.87A1.88,1.88,0,0,0,428.46,320.26Zm-21.56,0a1.88,1.88,0,1,0,1.88-1.87A1.88,1.88,0,0,0,406.9,320.26Zm-21.55,0a1.88,1.88,0,1,0,1.87-1.87A1.88,1.88,0,0,0,385.35,320.26Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "414.17px 296.975px",
        }}
        id="eldqwcag7bvlb"
        className="animable"
      />
      <path
        d="M396.64,311.09a91.57,91.57,0,0,1,13.25,2.3c2.15.57,4.27,1.24,6.38,2,1.05.35,2.11.67,3.17,1a14.29,14.29,0,0,0,3.42.67.08.08,0,0,1,0,.16,22.61,22.61,0,0,1-3.29-.09,24,24,0,0,1-3.13-.61c-2.19-.56-4.36-1.23-6.54-1.81-4.41-1.17-8.82-2.35-13.31-3.2C396.38,311.42,396.43,311.07,396.64,311.09Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "409.698px 314.166px",
        }}
        id="elr2aysyihjbp"
        className="animable"
      />
      <path
        d="M385.56,315a97.82,97.82,0,0,1,11.09-.43c1.85,0,3.69.18,5.53.38.88.09,1.76.2,2.63.32s1.91.39,2.88.51c.1,0,.1.17,0,.16-.92-.09-1.85,0-2.77-.05l-2.76-.1c-1.85-.06-3.69-.1-5.54-.18-3.69-.15-7.37-.27-11.06-.3C385.35,315.26,385.37,315,385.56,315Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "396.587px 315.247px",
        }}
        id="el6od095uv6wy"
        className="animable"
      />
      <path
        d="M412.64,254.2c0,1.74-5.22,14.35-12.83,15.85-2.48.48-5.72-12.94-5.72-12.94l-.46-.94-6.5-13.1,13.72-14.45,2-2s1.54,3.71,3.41,8.34c.09.21.18.42.27.65s.23.51.32.75c.29.69.58,1.4.86,2.1.21.54.42,1.06.62,1.63s.42,1.13.64,1.7A95.13,95.13,0,0,1,412.64,254.2Z"
        style={{
          fill: "rgb(235, 148, 129)",
          transformOrigin: "399.885px 248.341px",
        }}
        id="eluxgk7tyu0ah"
        className="animable"
      />
      <path
        d="M406.28,235a29.27,29.27,0,0,1-12.65,21.17l-6.5-13.1,13.72-14.45,2-2S404.41,230.37,406.28,235Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "396.705px 241.395px",
        }}
        id="el2w9art0v2ni"
        className="animable"
      />
      <path
        d="M361.49,224.5c1.93,25.61,17.48,27.34,23,26.92,5-.38,22-2.32,22.76-28s-11.79-32.86-23.3-32.59S359.56,198.9,361.49,224.5Z"
        style={{
          fill: "rgb(235, 148, 129)",
          transformOrigin: "384.29px 221.146px",
        }}
        id="el008ib2ilvuz74"
        className="animable"
      />
      <path
        d="M365.53,221.1c.59-.16,1.1-.4,1.67-.61a2.85,2.85,0,0,0,1.57-1,.91.91,0,0,0-.16-1.1,2.24,2.24,0,0,0-2.28-.21,3.34,3.34,0,0,0-1.9,1.47A1,1,0,0,0,365.53,221.1Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "366.599px 219.543px",
        }}
        id="ele4jbmpidc"
        className="animable"
      />
      <path
        d="M382.19,218.88a17.34,17.34,0,0,1-1.77-.11,2.84,2.84,0,0,1-1.78-.46.91.91,0,0,1-.16-1.1,2.25,2.25,0,0,1,2.13-.85,3.35,3.35,0,0,1,2.24.86A1,1,0,0,1,382.19,218.88Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "380.733px 217.606px",
        }}
        id="el3ox770gd0zt"
        className="animable"
      />
      <path
        d="M379.16,224.31c0-.06.15.07.15.14.16,1.74.63,3.71,2.27,4.1.05,0,.06.1,0,.09C379.63,228.61,379,226,379.16,224.31Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "380.379px 226.468px",
        }}
        id="elm0ni0q41zsj"
        className="animable"
      />
      <path
        d="M380.49,222.31c2.76-.55,3.67,5,1.1,5.53S378.17,222.78,380.49,222.31Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "381.122px 225.074px",
        }}
        id="eldsybe0uh2nk"
        className="animable"
      />
      <path
        d="M381.63,222.43c.54.24,1.1.72,1.7.68s1.11-.71,1.46-1.34c0-.07.09,0,.11,0,.18,1.07,0,2.23-1.17,2.58s-1.92-.51-2.36-1.54C381.29,222.66,381.41,222.33,381.63,222.43Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "383.153px 223.084px",
        }}
        id="els8x4pc2z6kk"
        className="animable"
      />
      <path
        d="M369.44,225.05c0-.06-.12.1-.11.17.35,1.72.46,3.74-1,4.58-.05,0,0,.11,0,.09C370.22,229.3,370,226.62,369.44,225.05Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "369.072px 227.465px",
        }}
        id="elgl3ysc4e18f"
        className="animable"
      />
      <path
        d="M367.59,223.51c-2.8.26-2.08,5.86.53,5.62S370,223.29,367.59,223.51Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "367.783px 226.321px",
        }}
        id="elp30ns2egjj"
        className="animable"
      />
      <path
        d="M366.48,224c-.41.35-.78.95-1.3,1.05s-1.14-.42-1.61-1c0-.06-.08,0-.07.07.11,1.07.6,2.14,1.66,2.21s1.53-.94,1.65-2C366.83,224.17,366.64,223.89,366.48,224Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "365.155px 225.154px",
        }}
        id="elcrt7n4ohppb"
        className="animable"
      />
      <path
        d="M381.58,238.88c-.33.49-.62,1.13-1.23,1.31a4.66,4.66,0,0,1-1.93-.05.06.06,0,0,0-.05.11,2.36,2.36,0,0,0,2.36.47,1.86,1.86,0,0,0,1-1.79C381.77,238.82,381.63,238.81,381.58,238.88Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "380.036px 239.845px",
        }}
        id="elvkst3kv58sl"
        className="animable"
      />
      <path
        d="M373.41,233.72s0,2.63.22,3.85c0,.12.32.13.73.09,0,0,0,0,.05,0a5.86,5.86,0,0,0,5.3-3c.07-.14-.11-.24-.21-.15a8.79,8.79,0,0,1-5.06,2.31c-.13-.32.1-4.51-.09-4.5a10.42,10.42,0,0,0-2.67,1c-.23-5.49.43-11,.13-16.43a.17.17,0,0,0-.33,0c-1.1,5.7-1,12-.9,17.69C370.59,235.29,373,234,373.41,233.72Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "375.124px 227.221px",
        }}
        id="elqb8y0r6j2u"
        className="animable"
      />
      <path
        d="M374.42,237.19a7.16,7.16,0,0,0,3,1.94,3.15,3.15,0,0,0,1.94-.06c1.37-.49,1.29-1.77.93-2.84a7.84,7.84,0,0,0-.77-1.63A9.22,9.22,0,0,1,374.42,237.19Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "377.468px 236.927px",
        }}
        id="elh8jxb155v48"
        className="animable"
      />
      <path
        d="M377.44,239.13a3.15,3.15,0,0,0,1.94-.06c1.37-.49,1.29-1.77.93-2.84A3.29,3.29,0,0,0,377.44,239.13Z"
        style={{
          fill: "rgb(255, 154, 187)",
          transformOrigin: "378.988px 237.742px",
        }}
        id="elf4c1egw9a9"
        className="animable"
      />
      <path
        d="M407.15,221.68c-4,1.42-7.3-7-7.3-7s-8.38,2.27-14.37-9a19.28,19.28,0,0,0,6.38,9s-15.2,2.39-24.74-8.32c0,0,4.17,5.64,7.1,7.26,0,0-6.66-.07-11-4.3,0,0-.68,7.83-2.15,10.34,0,0-6.31-26,18.39-29.69,0,0,15.28-3,23.84,7.42S407.15,221.68,407.15,221.68Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "384.396px 205.705px",
        }}
        id="elywsi9qrd5c"
        className="animable"
      />
      <path
        d="M403.09,224.44s4.24-8.81,8.15-7.43,1.62,13.54-2.34,15.79a4.33,4.33,0,0,1-6.11-1.36Z"
        style={{
          fill: "rgb(235, 148, 129)",
          transformOrigin: "408.027px 225.196px",
        }}
        id="ell6nxev0586"
        className="animable"
      />
      <path
        d="M410.5,220.48c.06,0,.09.08,0,.11-2.76,1.68-3.87,4.67-4.5,7.69.7-1.24,1.8-2,3.44-1.23a.1.1,0,0,1-.06.18,2.66,2.66,0,0,0-2.75,1.39,12.92,12.92,0,0,0-1,2.57c-.1.29-.6.23-.55-.1a.15.15,0,0,0,0-.07C404.45,227.27,406.51,221.52,410.5,220.48Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "407.762px 225.928px",
        }}
        id="elr20c2n5151c"
        className="animable"
      />
      <path
        d="M407.68,231.31a1.42,1.42,0,0,0-1,.63,4.35,4.35,0,0,0-.59,1.08,12.41,12.41,0,0,0-.6,2.42,29.58,29.58,0,0,0-.36,5,35.66,35.66,0,0,0,.38,5,17.28,17.28,0,0,0,.55,2.39,4.34,4.34,0,0,0,1.08,1.95c.48.41,1.09.24,1.51-.37a6.72,6.72,0,0,0,.92-2.15,27.56,27.56,0,0,0,.73-4.91,41.85,41.85,0,0,0,.06-5c0-.84-.08-1.67-.18-2.5a10.38,10.38,0,0,0-.22-1.24,2.09,2.09,0,0,0-.5-1.12,2.17,2.17,0,0,1,.64,1.08c.13.41.23.82.32,1.23.18.83.3,1.67.4,2.51a45.4,45.4,0,0,1,.19,5.08,25.07,25.07,0,0,1-.59,5.09,7.3,7.3,0,0,1-1,2.48,2.29,2.29,0,0,1-1.24.92,1.78,1.78,0,0,1-1.58-.37,5.17,5.17,0,0,1-1.36-2.4,15.87,15.87,0,0,1-.55-2.53,29.15,29.15,0,0,1-.22-5.11,28.68,28.68,0,0,1,.62-5.05,12.77,12.77,0,0,1,.82-2.42,4.09,4.09,0,0,1,.7-1.08A1.49,1.49,0,0,1,407.68,231.31Z"
        style={{
          fill: "#213E60",
          transformOrigin: "407.729px 241.121px",
        }}
        id="ele33ja2e7x1m"
        className="animable"
      />
      <polygon
        points="374.41 188.36 408.29 194.63 399.98 144.86 374.41 188.36"
        style={{
          fill: "#213E60",
          transformOrigin: "391.35px 169.745px",
        }}
        id="elfraksmqad17"
        className="animable"
      />
      <g id="el92oqzsw1cbg">
        <polygon
          points="374.41 188.36 408.29 194.63 399.98 144.86 374.41 188.36"
          style={{
            fill: "rgb(3, 4, 2)",
            opacity: 0.1,
            transformOrigin: "391.35px 169.745px",
          }}
          className="animable"
          id="elby56hxlb9k"
        />
      </g>
      <g id="elqgi60gtxuzq">
        <path
          d="M378.76,181l28.75,9,.5,3-30.77-9.41Zm1.33-2.28,26.35,4.88-.48-2.88L381.66,176Zm4.15-7.05,21.3,6.51-.5-3-19.3-6Zm3.31-5.63,16.47,3-.48-2.89-14.45-2.77Zm3.7-6.3,11.82,3.63-.51-3-9.84-3.09Zm3.76-6.39,6.59,1.22-.49-2.9-4.59-.89Z"
          style={{
            fill: "rgb(3, 4, 2)",
            opacity: 0.1,
            transformOrigin: "392.625px 171.89px",
          }}
          className="animable"
          id="eltgynhuw7pzq"
        />
      </g>
      <polygon
        points="373.01 189.57 409.34 196.29 410.16 193.75 373.22 186.57 373.01 189.57"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "391.585px 191.43px",
        }}
        id="elvmaqaz3mwp"
        className="animable"
      />
      <polygon
        points="372.82 192.57 408.3 199.13 409.18 196.74 373 190.05 372.82 192.57"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "391px 194.59px",
        }}
        id="elgr76jqbqpgj"
        className="animable"
      />
      <polygon
        points="394.32 144.47 398.58 144.99 394.46 146.18 394.88 147.35 398.84 145.67 395.86 148.76 396.81 149.57 399.4 146.14 398.36 150.3 399.59 150.53 400.11 146.26 401.3 150.38 402.48 149.96 400.8 146 403.88 148.98 404.69 148.03 401.25 145.44 405.42 146.48 405.65 145.25 401.37 144.73 405.5 143.54 405.08 142.37 401.12 144.05 404.1 140.96 403.15 140.15 400.57 143.58 401.6 139.42 400.37 139.19 399.85 143.47 398.67 139.34 397.49 139.76 399.17 143.72 396.08 140.74 395.27 141.69 398.71 144.28 394.54 143.24 394.32 144.47"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "399.985px 144.86px",
        }}
        id="el4gmri9gynn8"
        className="animable"
      />
      <path
        d="M428.67,272.66c-.16,25.7-15.42,77.13-25.47,82.2-2.71,1.37-11.56,5.27-17.2,3.93-16.91-4-38.57-29.43-52.37-48.4-4.86-6.67,25.67-28.91,32.23-23.15,3.93,3.45,20.81,25.12,21.85,24.08,0,0,21.29-41.73,24.14-46.32C421.29,249.79,428.74,263,428.67,272.66Z"
        style={{
          fill: "rgb(235, 148, 129)",
          transformOrigin: "380.889px 308.572px",
        }}
        id="elkvthjvrn4lh"
        className="animable"
      />
      <path
        d="M367.22,290.74s-4-14.71-7.08-24.2c-1.71-5.3-5.46-14.12-8.5-17.44-4.55-5-26.73-22.8-31.18-17.51-4,4.78,17,17.69,17,17.69s-20.05-14.9-23.83-8.25,21.89,18.08,21.89,18.08-20.93-14.84-23.75-7.37c-2.13,5.65,20.54,17.31,20.54,17.31s-18.08-12.64-20.52-6.92c-2.7,6.32,17.55,18.39,17.55,18.39-3.75,15.57.51,24.22,4.53,30.2C334.83,312.17,367.22,290.74,367.22,290.74Z"
        style={{
          fill: "rgb(235, 148, 129)",
          transformOrigin: "339.381px 270.704px",
        }}
        id="eljs6rtxp5pyc"
        className="animable"
      />
      <path
        d="M344.71,254c-2.29-1.84-4.6-3.71-7-5.34s-4.95-3.16-7.54-4.55a49.55,49.55,0,0,0-10.58-4.45c6.4,2.38,15.25,8.06,17.7,9.69s5,3.12,7.4,4.74A.05.05,0,0,0,344.71,254Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "332.161px 246.875px",
        }}
        id="elns2gvm527r"
        className="animable"
      />
      <path
        d="M339,262.93c-3-2.22-5.95-4.53-9.07-6.61s-6.25-3.77-9.49-5.63c-.25-.14-.25,0,0,.2,3.17,2,5.94,4.05,9.09,6.07s6.37,3.92,9.43,6C339,263,339.05,263,339,262.93Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "329.637px 256.81px",
        }}
        id="els0idy1q2zu"
        className="animable"
      />
      <path
        d="M335.48,271.48a84.08,84.08,0,0,0-14.65-9.05c-.25-.13-.22.11,0,.25,4.93,2.92,8.82,5.17,14.5,9C335.45,271.7,335.58,271.56,335.48,271.48Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "328.085px 267.037px",
        }}
        id="eln6on8nuo1n"
        className="animable"
      />
      <path
        d="M371.73,351.59c-1.93-1.86-8.21-7.06-10.15-8.93s-3.86-3.73-5.76-5.63a155.37,155.37,0,0,1-10.77-12,151.87,151.87,0,0,1-9.45-13.12,43.89,43.89,0,0,1-6.38-14.7,35.31,35.31,0,0,1-.71-8.52,85,85,0,0,1,.91-8.57c.06-.43-2.57-1.68-3.09-2-1-.64-2-1.27-3-1.95a57.17,57.17,0,0,1-5.68-4.46,22.45,22.45,0,0,1-4.83-5.55c-.87-1.55-1.4-4.23.94-4.75a8.74,8.74,0,0,1,3.92.46,34.45,34.45,0,0,1,4.23,1.3.06.06,0,0,0,.05,0l0,0a.09.09,0,0,0,.09-.15c-1.79-1.31-3.51-2.71-5.2-4.15-.84-.72-1.67-1.46-2.47-2.23a8.11,8.11,0,0,1-2.05-2.64,3.15,3.15,0,0,1,0-2.57,3.06,3.06,0,0,1,2.5-1.47,11.11,11.11,0,0,1,6,1.14s.09-.05.05-.08l-.43-.25a.08.08,0,0,0,0-.07,23.25,23.25,0,0,1-4-3.33c-1.21-1.19-2.68-2.67-2.74-4.48a3.06,3.06,0,0,1,2.92-3.18,9.16,9.16,0,0,1,2.66.19,26.85,26.85,0,0,1,2.93.77s0,0,0,0c-1-.48-2.07-.86-3.12-1.26a6.92,6.92,0,0,0-2.88-.49,3.54,3.54,0,0,0-3.52,3.27A6.55,6.55,0,0,0,315,247,24.12,24.12,0,0,0,319,250a9.41,9.41,0,0,0-4.51-.85,3.42,3.42,0,0,0-3.36,3.84c.28,2.4,2.5,4.14,4.22,5.6a36.13,36.13,0,0,0,5.08,3.63,15.45,15.45,0,0,0-6.12-1.88,3.22,3.22,0,0,0-3.4,3.91c.33,2.39,2,4.52,3.66,6.2a46.6,46.6,0,0,0,6.31,5.43q1.89,1.36,3.87,2.56a38.21,38.21,0,0,0,3.66,1.89c-1.76,4.75-1.64,9.88-.94,14.84a40.76,40.76,0,0,0,5.25,15,121.07,121.07,0,0,0,9.52,13.75,146,146,0,0,0,10.92,12.4c2.17,2.2,4.4,4.37,6.78,6.35s9,7.41,11.62,9.1A.11.11,0,0,0,371.73,351.59Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "341.301px 295.359px",
        }}
        id="el59nka127fvw"
        className="animable"
      />
      <path
        d="M329.91,244a22.28,22.28,0,0,1-4-3.23,36.25,36.25,0,0,1-3.48-3.64c-.88-1.09-2.13-2.43-2.14-3.92,0-2.45,2.79-2.67,4.55-2.11,0,0,0,0,0,0-1.5-.54-3.22-.64-4.44.57s-.66,3.08.19,4.41a24.23,24.23,0,0,0,3.93,4.53,20.69,20.69,0,0,0,2.44,1.93c.9.61,1.9,1.05,2.81,1.64A.09.09,0,1,0,329.91,244Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "324.825px 237.461px",
        }}
        id="elbd5x1tpends"
        className="animable"
      />
      <path
        d="M386.77,310.21c-1.64-2-3.34-3.95-5-5.89s-3.45-3.86-5.21-5.75-3.8-3.8-5.63-5.77c-.07-.08-.21,0-.13.11,1.75,2,3.36,4.15,5.08,6.19s3.4,4,5.14,6,3.49,3.94,5.27,5.88,3.49,3.87,5.35,5.68c.08.07.18-.05.13-.13C390.2,314.33,388.46,312.27,386.77,310.21Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "381.28px 304.724px",
        }}
        id="elcsqdi35c8l6"
        className="animable"
      />
      <path
        d="M424.4,322.12l-31.9-27.71a268.92,268.92,0,0,1,16.64-27.91c10.31-15.22,19.44-13.41,20.2,11.36A157.52,157.52,0,0,1,424.4,322.12Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "410.957px 289.447px",
        }}
        id="el9ta2gk37b9"
        className="animable"
      />
      <path
        d="M396.54,289.74c2.6,1.78,4.95,4,7.38,6s4.66,3.81,6.92,5.79q7.05,6.17,13.82,12.6c.08.07,0,.22-.12.15q-7.19-5.85-14.2-11.86c-2.33-2-4.61-4.06-6.88-6.11s-4.86-4.1-7-6.38C396.35,289.81,396.45,289.68,396.54,289.74Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "410.552px 302.012px",
        }}
        id="el7h9j85fm8yk"
        className="animable"
      />
      <path
        d="M394,290.32c.71-1.37,1.45-2.71,2.22-4.05l.48-.82a55.16,55.16,0,0,1,2-5.43.05.05,0,0,1,.1,0c-.39,1.42-.89,2.82-1.41,4.2a69.91,69.91,0,0,1,3.82-5.95.05.05,0,1,1,.09.06c-1.35,2.77-2.91,5.45-4.37,8.17-.7,1.31-4.33,7.71-4.27,7.78a8.32,8.32,0,0,1,.92.94c.13.23,0,.15-.09.09s-1.58-1-1.58-1S393.43,291.49,394,290.32Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "396.61px 286.81px",
        }}
        id="elb3bdc8ewk5u"
        className="animable"
      />
      <path
        d="M420.53,318.76c.68.51,1.36,1,2,1.57l2,1.59-.43.14c.57-2.62,1-5.27,1.53-7.9s.94-5.28,1.38-7.92.83-5.3,1.21-7.95.66-5.33.95-8a74.94,74.94,0,0,1-.26,8.07q-.31,4-.93,8t-1.45,7.95c-.55,2.63-1.22,5.24-1.92,7.84l-.12.43-.3-.29-1.86-1.77C421.75,320,421.13,319.37,420.53,318.76Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "424.859px 306.435px",
        }}
        id="el09dhecac9wl"
        className="animable"
      />
      <path
        d="M428.56,298.77a12.36,12.36,0,0,1,1.6-5,6.76,6.76,0,0,1-.36,2.65A7,7,0,0,1,428.56,298.77Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "429.367px 296.27px",
        }}
        id="elcp8zsi66kn"
        className="animable"
      />
    </g>
    <g
      id="freepik--character-2--inject-25"
      className="animable"
      style={{
        transformOrigin: "309.875px 319.974px",
      }}
    >
      <path
        d="M349.47,367.21a0,0,0,0,1,0,0s0,0,0,0a2.2,2.2,0,0,1-.07.28.06.06,0,0,0,0,0c0,.16-.08.35-.15.58l-.06.26,0,.1c0,.13-.07.27-.1.42s-.15.62-.25,1c0,.18-.09.37-.14.57-.1.39-.2.82-.32,1.28l-.12.47,0,.14c-.13.52-.27,1.07-.41,1.66s-.3,1.21-.46,1.87h0c-.21.85-.43,1.75-.67,2.71-.11.47-.23,1-.36,1.46s-.24,1-.37,1.54c0,.06,0,.11,0,.17-.13.54-.27,1.09-.4,1.66q-.3,1.27-.63,2.61c-.13.55-.27,1.1-.4,1.67h0c-.06.23-.11.46-.17.69-.11.45-.21.89-.32,1.34h0c-1.55,6.5-3.31,14-5.09,21.85-.14.6-.27,1.19-.41,1.79-.09.39-.17.78-.26,1.17-.17.73-.33,1.47-.5,2.21-.72,3.22-1.44,6.49-2.15,9.76H286.92c5.11-29.84,10.65-59.38,10.65-59.38Z"
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "318.195px 396.78px",
        }}
        id="elyx4sijo7jmo"
        className="animable"
      />
      <path
        d="M339.81,374.09c-.25,1.73-.52,3.44-.81,5.16h0c-.15.9-.3,1.79-.46,2.68-.63,3.64-1.3,7.28-1.92,10.92-.95,5.51-1.86,11-2.84,16.51h0c0,.1,0,.2,0,.3-.09.56-.19,1.11-.29,1.67q-1.37,7.62-2.74,15.24h-1.16q1.56-8.52,3.19-17a4,4,0,0,1,.09-.48h0l.33-1.73c1.69-8.77,3.23-17.6,5-26.37h0c.17-.84.35-1.69.53-2.52h0c.29-1.46.6-2.91.92-4.36A.11.11,0,0,1,339.81,374.09Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "334.7px 400.317px",
        }}
        id="el0pqnyfkf7rh"
        className="animable"
      />
      <path
        d="M349.46,367.21v0s0,0,0,0,0,.15-.07.28a.06.06,0,0,0,0,0,5.25,5.25,0,0,0-.15.58l-.06.26,0,.1c0,.13-.07.27-.1.42s-.16.62-.25,1c0,.18-.09.37-.14.57-.1.4-.21.82-.32,1.28l-.12.47,0,.14c-.13.52-.27,1.07-.41,1.66s-.3,1.21-.46,1.87h0c-.21.85-.43,1.75-.67,2.71-.11.47-.23,1-.36,1.46s-.24,1-.37,1.54c0,.06,0,.11,0,.17-.13.54-.27,1.09-.4,1.66q-.31,1.26-.63,2.61c-.13.55-.27,1.1-.4,1.67h0c-.06.23-.11.46-.17.69-.11.45-.21.89-.32,1.34h0c-1.55,6.5-3.31,14-5.09,21.85-.14.6-.27,1.19-.41,1.79-.09.39-.17.78-.26,1.17-.17.73-.33,1.47-.5,2.21-.72,3.22-1.44,6.49-2.15,9.76H319.89l-5.37-20.26-.22-.85-.05-.2-10.1-38.07Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "326.805px 396.78px",
        }}
        id="el3i8canh7nr5"
        className="animable"
      />
      <path
        d="M371.8,426.59H323.54c-2-9.29-3.43-16.53-4-19.25l-.23-1.17-5-.69-3.38-.47c-3-2.74-8.35-37.8-8.35-37.8h59.86s9.42,21.05,5.67,43.79Z"
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "337.19px 396.9px",
        }}
        id="elivibz9meu9"
        className="animable"
      />
      <path
        d="M334,409.43A75.19,75.19,0,0,0,321,406.1c-4.56-.74-9.16-1-13.76-1.39-.22,0-.29.31-.06.34,4.47.61,8.88,1.62,13.31,2.47s8.88,1.57,13.36,2.18C334,409.72,334.11,409.49,334,409.43Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "320.541px 407.206px",
        }}
        id="el68s33uw04y"
        className="animable"
      />
      <path
        d="M318.18,386.14c-.52-4.61-1.17-9.24-1.93-13.81a.17.17,0,1,0-.33,0c.13,4.15.4,8.32.69,12.47.14,2.07.34,4.13.53,6.19.13,1.38.87,5.49-1.35,5.53s-2.64-2.61-3-4.16c-.53-2.11-1-4.25-1.35-6.4-.74-4.19-1.16-8.43-1.66-12.65,0-.18-.33-.22-.34,0a59.28,59.28,0,0,0,.53,11.83c.27,2,.61,4,1,5.92a16.16,16.16,0,0,0,1.37,4.79,4.56,4.56,0,0,0,3.34,2.2,1,1,0,0,0,0,.17c0,.33.06.66.08,1,.06.74.11,1.48.19,2.21s.2,1.42.29,2.12a10.3,10.3,0,0,0,.44,2.07.18.18,0,0,0,.34,0,9.25,9.25,0,0,0,.11-2c0-.74,0-1.48-.05-2.22s-.1-1.42-.15-2.13c0-.35,0-.72-.08-1.07a.94.94,0,0,0-.06-.15,2.58,2.58,0,0,0,1.63-1.38c.7-1.36.55-3.13.45-4.6C318.66,390,318.4,388.09,318.18,386.14Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "314.153px 388.93px",
        }}
        id="elk8bvulrx12m"
        className="animable"
      />
      <path
        d="M360.25,391.23a35.22,35.22,0,0,1-3.68.89,14,14,0,0,1-4-.16,15.59,15.59,0,0,1-7.5-3.63,22,22,0,0,1-5.19-7.18,39.39,39.39,0,0,1-1.66-4c-.55-1.56-1.18-3.12-1.64-4.71-.06-.19-.38-.12-.34.08.16,1,.16,1.95.34,2.91.15.78.35,1.56.56,2.32a30.46,30.46,0,0,0,1.68,4.81,22.4,22.4,0,0,0,5.61,7.7,14.76,14.76,0,0,0,8.16,3.51c2.53.24,6-.23,7.79-2.3C360.42,391.36,360.36,391.2,360.25,391.23Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "348.314px 383.078px",
        }}
        id="el13edipd98scr"
        className="animable"
      />
      <path
        d="M368.19,426.59h-1.11q-1.59-7.95-3.12-15.91l0-.12,0-.11a34.48,34.48,0,0,0,1.25-10.25,79.12,79.12,0,0,0-.76-10.41q-.65-5.19-1.7-10.34c-.71-3.42-1.48-6.83-2.38-10.21a146.94,146.94,0,0,1,4.67,20.47A78,78,0,0,1,366,400.2a35.29,35.29,0,0,1-1.09,10.41Q366.56,418.61,368.19,426.59Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "364.28px 397.915px",
        }}
        id="el1ks1p4o7c4a"
        className="animable"
      />
      <path
        d="M291.61,304.34c-24,28.62-54.21,93.86-58,103.75-2.58,6.71,32.57,21.15,33.64,16.33,1.37-6.17,29.22-74.21,33.87-110.72C303.13,297.71,296.46,298.57,291.61,304.34Z"
        style={{
          fill: "rgb(211, 118, 106)",
          transformOrigin: "267.481px 362.961px",
        }}
        id="ell1k0v06dte"
        className="animable"
      />
      <path
        d="M268.48,419.85c-.93,3.31-3.89,17.31-6.57,19.24s-17.44,2.7-24.88,3.27S228,441,227.9,438.41s15.48-4.26,15.48-4.26-20.36,7.58-25.52,9-17,5.36-19.08,1.15c-.94-1.89,2.21-4.13,2.21-4.13s-5,1.87-6-.58c-1.14-2.8,2.77-4.69,2.77-4.69s-3.12.88-3.37-1.44c-.57-5.21,19-9.31,19-9.31s-14.6,8.56-15.41,4.34c-1.13-5.85,29.45-14.72,32.48-17.54a22,22,0,0,0,4.69-6.8Z"
        style={{
          fill: "rgb(211, 118, 106)",
          transformOrigin: "231.429px 425.169px",
        }}
        id="elrdpqip824sk"
        className="animable"
      />
      <path
        d="M228.12,439.7a2.25,2.25,0,0,1,.55-2,6.26,6.26,0,0,1,1.72-1.32,24.94,24.94,0,0,1,4.15-1.71c2.87-1,5.83-1.73,8.76-2.73a36.34,36.34,0,0,0-9.1,1.74,17.19,17.19,0,0,0-4.25,2,6.19,6.19,0,0,0-1.7,1.72A2.35,2.35,0,0,0,228.12,439.7Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "235.59px 435.82px",
        }}
        id="elwbql0bxfw9n"
        className="animable"
      />
      <path
        d="M201,440.13c2.1-.69,4.17-1.46,6.23-2.23s4.11-1.58,6.16-2.38l6.12-2.45c2-.82,4.08-1.63,6.14-2.42a49.19,49.19,0,0,0-6.42,1.66c-2.11.66-4.17,1.44-6.23,2.24s-4.08,1.67-6.08,2.61S202.92,439.05,201,440.13Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "213.325px 435.39px",
        }}
        id="elksccey6zdu"
        className="animable"
      />
      <path
        d="M220.21,425.84a41.35,41.35,0,0,0-5.94,1.29,55,55,0,0,0-5.76,2,51.34,51.34,0,0,0-5.53,2.57,42.73,42.73,0,0,0-5.17,3.19c1.86-.81,3.67-1.69,5.52-2.47s3.69-1.59,5.56-2.32,3.74-1.46,5.63-2.18S218.3,426.52,220.21,425.84Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "209.01px 430.365px",
        }}
        id="el49kk5sd1lim"
        className="animable"
      />
      <path
        d="M216.76,421.1a37.8,37.8,0,0,0-9.41,2.76,37,37,0,0,0-8.46,4.95c3-1.34,5.9-2.73,8.88-4S213.73,422.34,216.76,421.1Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "207.825px 424.955px",
        }}
        id="eloeoqts8jzv"
        className="animable"
      />
      <path
        d="M294.94,348.4,269.1,334.33s-1.79,3.37.45,5,4.84-.61,4.84-.61-.92,2.81,1.41,4.32,4.52-1.24,4.52-1.24-.8,3.56,1.71,4.94,4.87-1.34,4.87-1.34a3.77,3.77,0,0,0,1.72,4.8C292.25,352.17,294.94,348.4,294.94,348.4Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "281.681px 342.55px",
        }}
        id="elaf58yflgnim"
        className="animable"
      />
      <path
        d="M294.88,350l-26.57-15.11s10.51-18.37,21.24-32.2,14.94-5.81,13.31,9.26S294.88,350,294.88,350Z"
        style={{
          fill: "#213E60",
          transformOrigin: "285.755px 322.779px",
        }}
        id="elub8u542aouf"
        className="animable"
      />
      <path
        d="M273,330.19A248.79,248.79,0,0,1,295.63,342c.11.07,0,.25-.11.2a248.89,248.89,0,0,1-22.69-11.8C272.71,330.34,272.83,330.13,273,330.19Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "284.229px 336.194px",
        }}
        id="el6i232i1si5t"
        className="animable"
      />
      <g id="elzmlwffur8d">
        <path
          d="M285.7,344.73l9.18,5.23s6.35-23,8-38c1.17-10.75-.63-17.91-5.65-16.11Z"
          style={{
            opacity: 0.1,
            transformOrigin: "294.462px 322.767px",
          }}
          className="animable"
          id="el1w18cqmar23"
        />
      </g>
      <path
        d="M362.43,367.2c0,.09-64.54.87-64.54.87-.32-.16-7.85-47.56-3.51-65.64,1.11-4.6,9.73-13.55,19.56-8.51C334.67,304.55,362.43,367.2,362.43,367.2Z"
        style={{
          fill: "#213E60",
          transformOrigin: "327.733px 330.248px",
        }}
        id="ele8x339imbtf"
        className="animable"
      />
      <path
        d="M362.43,367.2s-9.66-26.28-16.73-35.8c0,0-14.76,3.28-21,.12s-11.07-16.87-11.07-16.87l-21.16,2.06s1.56,39.14,5.41,51.36C297.89,368.07,350.46,369.59,362.43,367.2Z"
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "327.45px 341.598px",
        }}
        id="elzhwgmg9p9g"
        className="animable"
      />
      <path
        d="M304.79,346.24s-6.37-6.66-8.19-14.36c-1.1-4.67.13-9.5,2-9.12,3.81.79,4.88,10.34,4.88,10.34s-.32-10.85,4.08-11.42,5.39,7.52,4.22,11.79A29.56,29.56,0,0,1,304.79,346.24Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "304.209px 333.946px",
        }}
        id="el9kz8u6k5rys"
        className="animable"
      />
      <path
        d="M295.15,316.45l-2.67.26s.42-9.53.83-12.2,3.25-8.76,3.25-8.76l2.6-.7s-3.09,6.83-3.65,9.58S295.15,316.45,295.15,316.45Z"
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "295.82px 305.88px",
        }}
        id="elqkxjktq24ph"
        className="animable"
      />
      <path
        d="M328.18,304.34c24,28.62,54.22,93.86,58,103.75,2.59,6.71-32.56,21.15-33.64,16.33-1.37-6.17-29.21-74.21-33.86-110.72C316.66,297.71,323.33,298.57,328.18,304.34Z"
        style={{
          fill: "rgb(211, 118, 106)",
          transformOrigin: "352.313px 362.961px",
        }}
        id="eltck6mxurlcm"
        className="animable"
      />
      <path
        d="M351.32,419.85c.92,3.31,3.88,17.31,6.56,19.24s17.45,2.7,24.88,3.27,9.05-1.38,9.13-3.95-15.48-4.26-15.48-4.26,20.36,7.58,25.53,9,17,5.36,19.07,1.15c.94-1.89-2.21-4.13-2.21-4.13s4.95,1.87,5.95-.58c1.14-2.8-2.76-4.69-2.76-4.69s3.11.88,3.37-1.44c.56-5.21-19-9.31-19-9.31s14.59,8.56,15.41,4.34c1.13-5.85-29.45-14.72-32.49-17.54a22,22,0,0,1-4.69-6.8Z"
        style={{
          fill: "rgb(211, 118, 106)",
          transformOrigin: "388.346px 425.169px",
        }}
        id="el6ar9s0l1g8m"
        className="animable"
      />
      <path
        d="M391.68,439.7a2.31,2.31,0,0,0-.55-2,6.57,6.57,0,0,0-1.72-1.32,25.4,25.4,0,0,0-4.16-1.71c-2.87-1-5.83-1.73-8.76-2.73a36.34,36.34,0,0,1,9.1,1.74,16.86,16.86,0,0,1,4.25,2,6.09,6.09,0,0,1,1.71,1.72A2.4,2.4,0,0,1,391.68,439.7Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "384.201px 435.82px",
        }}
        id="elgi5itcmsvir"
        className="animable"
      />
      <path
        d="M418.8,440.13c-2.1-.69-4.16-1.46-6.23-2.23s-4.1-1.58-6.15-2.38l-6.12-2.45c-2-.82-4.08-1.63-6.15-2.42a48.79,48.79,0,0,1,6.42,1.66c2.11.66,4.18,1.44,6.23,2.24s4.09,1.67,6.08,2.61S416.87,439.05,418.8,440.13Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "406.475px 435.39px",
        }}
        id="el3htyzfaoo0d"
        className="animable"
      />
      <path
        d="M399.58,425.84a41.48,41.48,0,0,1,5.95,1.29,55.85,55.85,0,0,1,5.76,2,51.19,51.19,0,0,1,5.52,2.57,43.64,43.64,0,0,1,5.18,3.19c-1.87-.81-3.67-1.69-5.53-2.47s-3.69-1.59-5.56-2.32-3.74-1.46-5.62-2.18S401.49,426.52,399.58,425.84Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "410.785px 430.365px",
        }}
        id="el1aqpehpj60f"
        className="animable"
      />
      <path
        d="M403,421.1a37.56,37.56,0,0,1,9.41,2.76,37.06,37.06,0,0,1,8.47,4.95c-3-1.34-5.9-2.73-8.88-4S406.06,422.34,403,421.1Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "411.94px 424.955px",
        }}
        id="elo39ono9e6l"
        className="animable"
      />
      <path
        d="M352.61,335.08l-27.66,10s1.33,3.57,4.05,3,2.76-4,2.76-4,1.49,2.55,4.16,1.81,2.07-4.22,2.07-4.22,2.13,3,4.83,2,2.23-4.54,2.23-4.54a3.78,3.78,0,0,0,4.73,1.91C353.65,339.6,352.61,335.08,352.61,335.08Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "338.844px 341.611px",
        }}
        id="elrg6kbvxvia"
        className="animable"
      />
      <path
        d="M353.74,336.17l-28.92,9.88s-6.81-20-10.05-37.24,5.55-15,15.75-3.84S353.74,336.17,353.74,336.17Z"
        style={{
          fill: "#213E60",
          transformOrigin: "333.913px 321.141px",
        }}
        id="elp2a92da3ck"
        className="animable"
      />
      <path
        d="M324.4,339.49a245.29,245.29,0,0,1,23.88-9.16c.12,0,.19.16.08.21a246.42,246.42,0,0,1-23.88,9.18C324.35,339.77,324.27,339.55,324.4,339.49Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "336.374px 335.029px",
        }}
        id="el5mxjatdetz8"
        className="animable"
      />
      <path
        d="M316.88,318.22c.69,3.61,1.51,7.2,2.42,10.76-.5-1.14-1-2.27-1.51-3.41-.07-.14-.28,0-.22.12l1.4,3.2c.22.51.44,1,.67,1.53l.12.28.39,1.44s0,0,0,0l0,0c0,.13.07.26.1.38,1.27,4.61,2.39,9.39,4.32,13.78.06.14.28,0,.25-.1-.8-4.76-2.42-9.42-3.71-14.07s-2.65-9.35-4.14-14C317,318.13,316.86,318.15,316.88,318.22Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "320.85px 332.245px",
        }}
        id="elevw94huofnb"
        className="animable"
      />
      <path
        d="M313.64,314.65s-1.33-10.85-1.23-12.55,1.85-8.59,1.85-8.59l-2.91-1s-1.1,5.84-1.62,8.55.83,13.89.83,13.89Z"
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "311.935px 303.73px",
        }}
        id="eluq47yq61lm"
        className="animable"
      />
      <path
        d="M310.29,294.19c-.24,2.36-3.56,14.81-10.22,16.14C297.9,310.76,295,299,295,299l-.41-.81-5.74-11.46,13.73-14.42S310.55,291.6,310.29,294.19Z"
        style={{
          fill: "rgb(211, 118, 106)",
          transformOrigin: "299.573px 291.326px",
        }}
        id="elhpxzgm6r4ca"
        className="animable"
      />
      <path
        d="M305.09,278.21a43.49,43.49,0,0,1-.27,4.62c-1.16,10.39-6.25,14.39-9.94,15.93l-.27-.56-5.75-11.45,13.74-14.42S303.69,274.81,305.09,278.21Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "296.975px 285.545px",
        }}
        id="elilz95i4h3r8"
        className="animable"
      />
      <path
        d="M307.71,273.43c2.73,1.32,5.39,2.46,6.44,6.47.73,2.82-.59,7.13-.59,7.13l-4.31,1.79a14.08,14.08,0,0,1-5.53-5.07c-1.94-3.48-.44-8.24-.44-8.24Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "308.548px 281.125px",
        }}
        id="eli7wjneua8kd"
        className="animable"
      />
      <path
        d="M313.14,286.57c2.51,1.7,5,3.21,5.45,7.32.33,2.9-1.59,7-1.59,7L312.48,302a14.11,14.11,0,0,1-4.76-5.81c-1.42-3.72.74-8.22.74-8.22Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "312.932px 294.285px",
        }}
        id="el8r01ajbal9"
        className="animable"
      />
      <path
        d="M316.89,300.43c1.73,2.48,3.5,4.78,2.45,8.78-.73,2.83-4,5.94-4,5.94l-4.63-.54a14.06,14.06,0,0,1-2.36-7.12c0-4,3.64-7.41,3.64-7.41Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "314.002px 307.615px",
        }}
        id="eljeb1dkoms6"
        className="animable"
      />
      <path
        d="M315.35,315.15a10.11,10.11,0,0,1,2.24,9c-1.38,5.18-11.1,9.89-11.1,9.89s2.1-3.19,1.44-6.42-2.46-9.2,2.79-13Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "312.176px 324.33px",
        }}
        id="elytsmrb6tld"
        className="animable"
      />
      <g id="el6qa4m2svbma">
        <rect
          x={308.86}
          y={314.31}
          width={8.53}
          height={2.73}
          style={{
            fill: "#213E60",
            transformOrigin: "313.125px 315.675px",
            transform: "rotate(-172.55deg)",
          }}
          className="animable"
          id="el43v6hp1kx6l"
        />
      </g>
      <path
        d="M277.29,275.71c1.88,2.38,3.79,4.56,3,8.62-.56,2.86-3.62,6.17-3.62,6.17l-4.66-.25a14.08,14.08,0,0,1-2.79-7c-.24-4,3.17-7.62,3.17-7.62Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "274.84px 283.065px",
        }}
        id="elho7jam2zwov"
        className="animable"
      />
      <path
        d="M276.49,289.91c1.53,2.62,3.11,5,1.74,9-1,2.75-4.46,5.59-4.46,5.59l-4.57-.91a14.08,14.08,0,0,1-1.78-7.29c.33-4,4.23-7.09,4.23-7.09Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "273.084px 296.855px",
        }}
        id="elm16ozfb0s3r"
        className="animable"
      />
      <path
        d="M273.86,304c.49,3,1.09,5.83-1.59,9-1.88,2.23-6.17,3.63-6.17,3.63l-3.94-2.5a14.12,14.12,0,0,1,1-7.44c1.74-3.59,6.49-5.1,6.49-5.1Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "268.158px 309.11px",
        }}
        id="eldpfdygl1d2h"
        className="animable"
      />
      <path
        d="M266.1,316.63a10,10,0,0,1-1.87,9.06c-3.49,4.08-14.29,4.11-14.29,4.11s3.28-2,4.08-5.16,1.76-9.36,8.14-10.51Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "258.211px 321.965px",
        }}
        id="elo8n20z0kgap"
        className="animable"
      />
      <g id="eljtl3pxzoy8e">
        <rect
          x={259.61}
          y={314.78}
          width={8.53}
          height={2.73}
          style={{
            fill: "#213E60",
            transformOrigin: "263.875px 316.145px",
            transform: "rotate(-146.89deg)",
          }}
          className="animable"
          id="elz34sxv3bhao"
        />
      </g>
      <path
        d="M263.09,275.73c4.86,23.33,19.38,23.06,24.42,22,4.56-1,20-4.79,17.57-28.5s-14.8-28.83-25.36-27.2S258.24,252.39,263.09,275.73Z"
        style={{
          fill: "rgb(211, 118, 106)",
          transformOrigin: "283.621px 269.923px",
        }}
        id="elj5kkapmvqr"
        className="animable"
      />
      <path
        d="M266.27,272.58a15.61,15.61,0,0,0,1.46-.77,2.67,2.67,0,0,0,1.34-1.06.87.87,0,0,0-.28-1,2.11,2.11,0,0,0-2.13.09,3.1,3.1,0,0,0-1.57,1.58A.9.9,0,0,0,266.27,272.58Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "267.078px 271.076px",
        }}
        id="el226f8ixkl8e"
        className="animable"
      />
      <path
        d="M281.77,269.34a14.91,14.91,0,0,1-1.64.14,2.61,2.61,0,0,1-1.7-.18.85.85,0,0,1-.29-1,2.12,2.12,0,0,1,1.84-1.07,3.13,3.13,0,0,1,2.17.49A.9.9,0,0,1,281.77,269.34Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "280.303px 268.373px",
        }}
        id="elv27pso174z"
        className="animable"
      />
      <path
        d="M280.75,272.45c2.48-.84,4,4.17,1.68,5S278.67,273.15,280.75,272.45Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "281.662px 274.948px",
        }}
        id="el2wr09s8vmy8"
        className="animable"
      />
      <path
        d="M281.81,272.42c.52.15,1.1.52,1.65.42s.93-.79,1.18-1.41c0-.07.08,0,.1,0A1.91,1.91,0,0,1,284,274c-.9.41-1.83-.24-2.36-1.14C281.52,272.67,281.6,272.36,281.81,272.42Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "283.277px 272.762px",
        }}
        id="elezji6v7dob"
        className="animable"
      />
      <path
        d="M269.37,275.26c-2.55.58-1.21,5.64,1.16,5.11S271.51,274.77,269.37,275.26Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "269.88px 277.818px",
        }}
        id="el8p3ab2kf2tb"
        className="animable"
      />
      <path
        d="M268.4,275.87c-.33.38-.59,1-1.06,1.13s-1.1-.26-1.6-.69c-.05,0-.07,0-.06.08.23,1,.82,1.9,1.8,1.83s1.29-1.05,1.27-2.07C268.74,276,268.53,275.72,268.4,275.87Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "267.214px 277.025px",
        }}
        id="el2h1u0unjp4c"
        className="animable"
      />
      <path
        d="M284,286.4c-.24.49-.44,1.11-1,1.35a4.25,4.25,0,0,1-1.78.19c-.05,0-.08.07,0,.1a2.2,2.2,0,0,0,2.24.16,1.75,1.75,0,0,0,.73-1.78C284.17,286.32,284,286.33,284,286.4Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "282.697px 287.39px",
        }}
        id="el6u3srfho3ml"
        className="animable"
      />
      <path
        d="M275.87,282.63s.35,2.42.66,3.52c0,.11.31.08.69,0,0,0,0,0,0,0a5.44,5.44,0,0,0,4.52-3.4.12.12,0,0,0-.21-.11,8.2,8.2,0,0,1-4.38,2.74c-.16-.29-.46-4.21-.63-4.13-.69.33-1.89,1-2.33,1.28-.26-1.57-.78-6.06-1.26-8.92,0-.18-.31-.16-.31,0a77.85,77.85,0,0,0,.71,10.17C273.41,284,275.48,283,275.87,282.63Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "277.183px 279.852px",
        }}
        id="el98rtwdlv7hi"
        className="animable"
      />
      <path
        d="M277.07,285.27a6.52,6.52,0,0,0,3,1.6,3,3,0,0,0,1.81-.18c1.24-.56,1.08-1.75.67-2.73a6.86,6.86,0,0,0-.84-1.46A8.62,8.62,0,0,1,277.07,285.27Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "279.96px 284.718px",
        }}
        id="elf0yrkel7int"
        className="animable"
      />
      <path
        d="M280,286.87a3,3,0,0,0,1.81-.18c1.24-.56,1.08-1.75.67-2.73A3.1,3.1,0,0,0,280,286.87Z"
        style={{
          fill: "rgb(255, 154, 187)",
          transformOrigin: "281.39px 285.448px",
        }}
        id="elcgoq5cr8se5"
        className="animable"
      />
      <path
        d="M304.15,272.38c-5.82,1.31-12.14-16-12.89-18.1.4,1.36,2.51,8.61,2,9a5.73,5.73,0,0,1-1.9.14h0a18.59,18.59,0,0,0-.89-2.56c-.16-.39.07.92.27,2.55-.35,0-.74,0-1.15,0a21.29,21.29,0,0,0-2-5.41c-.35-.64.28,2.51.33,5.39a72,72,0,0,0-15.79,1.29c-1.45.33-2.69.67-3.77,1-.58-2.15-.93-4.51-1-4a21.36,21.36,0,0,0,.15,4.24c-.59.19-1.13.38-1.61.55-.94-3-.77-8.23-1.06-7.36a22.13,22.13,0,0,0-1,8.26c-2,.94-2.43,1.5-2.63,1-.36-1-1.4-9.77,3.6-17.75,5.43-8.68,19.36-14.15,30.2-5.82,0,0,7.81,2.61,10.7,9.35S307.51,271.62,304.15,272.38Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "284.124px 256.561px",
        }}
        id="el8dybdq6sqnw"
        className="animable"
      />
      <path
        d="M301.75,271.8s2.84-8.62,6.6-7.82,3.13,12.26-.24,14.82a4,4,0,0,1-5.8-.53Z"
        style={{
          fill: "rgb(211, 118, 106)",
          transformOrigin: "306.332px 271.866px",
        }}
        id="eloiwawztinn"
        className="animable"
      />
      <path
        d="M308.09,267.26a.06.06,0,0,1,.05.1c-2.34,1.87-3,4.76-3.21,7.62.49-1.23,1.41-2.09,3-1.54.09,0,.05.15,0,.16a2.47,2.47,0,0,0-2.36,1.61,11.94,11.94,0,0,0-.62,2.49c-.05.28-.52.28-.51,0v-.07C303.34,274.24,304.55,268.7,308.09,267.26Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "306.101px 272.585px",
        }}
        id="elwcsjau4b77"
        className="animable"
      />
      <polygon
        points="305.95 249.51 272.44 241.55 300.15 199.39 305.95 249.51"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "289.195px 224.45px",
        }}
        id="el2im0bhnqcv5"
        className="animable"
      />
      <path
        d="M305.11,242.25a6.53,6.53,0,0,1-2.37-1,11.45,11.45,0,0,1-2.46-2.15,19.4,19.4,0,0,0,1.87-10.37,11.75,11.75,0,0,0-1-3.94,6.32,6.32,0,0,0-1.22-1.76,3.67,3.67,0,0,0-3.11-1.05,2.58,2.58,0,0,0-1.11.43,3.32,3.32,0,0,0-1.24,1.88,10.32,10.32,0,0,0-.07,4.1,22,22,0,0,0,1.06,3.86,23.48,23.48,0,0,0,3.69,6.61,8.08,8.08,0,0,1-.52.9,9.48,9.48,0,0,1-2.55,2.65,6.8,6.8,0,0,1-3.41,1.14,7.66,7.66,0,0,1-3.58-.6,5.19,5.19,0,0,1-2.51-2.45,8.16,8.16,0,0,1-.81-3.57v0a14.89,14.89,0,0,0,1.69-1.49,16.13,16.13,0,0,0,2.47-3.15,10.3,10.3,0,0,0,.88-1.83,5.11,5.11,0,0,0,.23-1.06,2,2,0,0,0-.19-1.2,1.44,1.44,0,0,0-.5-.51,1.9,1.9,0,0,0-.64-.2,2,2,0,0,0-1.2.27,4.82,4.82,0,0,0-1.55,1.49,12.47,12.47,0,0,0-1.66,3.71,14.55,14.55,0,0,0-.52,3.9c-.26.18-.52.36-.79.52a9.16,9.16,0,0,1-3.53,1.34,5.87,5.87,0,0,1-1.87,0,5,5,0,0,1-1.77-.6,5.3,5.3,0,0,1-1.37-1.13l-.22.32a5.53,5.53,0,0,0,1.37,1.18,5.92,5.92,0,0,0,1.9.72,7,7,0,0,0,2,.07,10,10,0,0,0,3.78-1.35l.49-.31a8.8,8.8,0,0,0,.86,3.38,6.32,6.32,0,0,0,3,2.94,8.81,8.81,0,0,0,4.07.72,8,8,0,0,0,3.95-1.3,10.34,10.34,0,0,0,2.88-2.94c.13-.21.26-.42.38-.63a12.53,12.53,0,0,0,2.47,2.05,7.31,7.31,0,0,0,2.78,1Zm-18.88-9a11.88,11.88,0,0,1,1.49-3.44,4,4,0,0,1,1.21-1.25,1.19,1.19,0,0,1,.68-.16.54.54,0,0,1,.48.26,2.27,2.27,0,0,1-.07,1.57,10,10,0,0,1-.77,1.71,15.84,15.84,0,0,1-2.31,3,13.48,13.48,0,0,1-1.17,1.1A13.48,13.48,0,0,1,286.23,233.22Zm13.28,5a23.18,23.18,0,0,1-3.25-6.19,20.15,20.15,0,0,1-.93-3.71,9.32,9.32,0,0,1,.06-3.69,2.45,2.45,0,0,1,.86-1.34,2,2,0,0,1,1.52-.23,3.56,3.56,0,0,1,2.44,2.23,11.07,11.07,0,0,1,.9,3.62,18.57,18.57,0,0,1-.05,3.8A18.23,18.23,0,0,1,299.51,238.18Zm2.38-23.81a14.13,14.13,0,0,1-1,1.17,11.66,11.66,0,0,1-3,2.27,3.88,3.88,0,0,1-1.66.5,1.17,1.17,0,0,1-.67-.18.57.57,0,0,1-.29-.47,2.22,2.22,0,0,1,.82-1.33,9.84,9.84,0,0,1,1.51-1.12,16.33,16.33,0,0,1,3.5-1.54l.67-.19-.08-.69-.79.2a16.86,16.86,0,0,0-3.7,1.55,9.91,9.91,0,0,0-1.66,1.19,4.54,4.54,0,0,0-.72.79,2.09,2.09,0,0,0-.41,1.15,1.34,1.34,0,0,0,.19.68,1.64,1.64,0,0,0,.45.49,2,2,0,0,0,1.18.36,4.9,4.9,0,0,0,2.08-.55,12.05,12.05,0,0,0,3.25-2.44,4.32,4.32,0,0,0,.46-.51Zm-10.61-1.5a18.25,18.25,0,0,1-.75,2.55,9.26,9.26,0,0,1-1.85,3.19,2.4,2.4,0,0,1-1.4.75H287l-.59.9a2.45,2.45,0,0,0,.93.08,3.3,3.3,0,0,0,2-1,10,10,0,0,0,2-3.55,21.92,21.92,0,0,0,1-3.89c0-.28.08-.55.11-.82Zm9.2-10.62a7.89,7.89,0,0,0-1.85-.55l-.66,1a6.94,6.94,0,0,1,2.35.66c.1.06.21.1.31.17Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "290.195px 223.223px",
        }}
        id="elbxyt0sqf2lc"
        className="animable"
      />
      <polygon
        points="306.75 251.18 270.8 242.65 271.08 240 307.77 248.36 306.75 251.18"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "289.285px 245.59px",
        }}
        id="elqipe44xa0dl"
        className="animable"
      />
      <polygon
        points="305.71 254 270.61 245.67 270.77 243.13 306.57 251.63 305.71 254"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "288.59px 248.565px",
        }}
        id="ele2i19yhjrw8"
        className="animable"
      />
      <polygon
        points="305.49 201.32 301.38 200.07 304.67 202.82 303.81 203.73 300.87 200.59 302.34 204.62 301.15 204.98 300.17 200.79 299.43 205.02 298.21 204.73 299.46 200.61 296.71 203.9 295.81 203.04 298.94 200.1 294.92 201.58 294.56 200.38 298.75 199.4 294.52 198.67 294.81 197.45 298.93 198.7 295.63 195.95 296.49 195.04 299.44 198.18 297.95 194.15 299.15 193.8 300.13 197.98 300.87 193.76 302.08 194.04 300.83 198.16 303.58 194.87 304.49 195.73 301.35 198.67 305.38 197.19 305.74 198.39 301.55 199.37 305.78 200.1 305.49 201.32"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "300.15px 199.39px",
        }}
        id="elraug9vxjdt"
        className="animable"
      />
    </g>
    <g
      id="freepik--character-1--inject-25"
      className="animable"
      style={{
        transformOrigin: "157.765px 278.395px",
      }}
    >
      <path
        d="M173.19,426.75H104.75c-1-10.29-1.91-20.58-2.81-30.42-.59-6.42-1.15-12.65-1.69-18.55-.31-3.45-.62-6.8-.9-10h0c-.07-.64-.12-1.27-.18-1.9-.07-.86-.16-1.72-.23-2.56-.06-.59-.11-1.17-.16-1.74-.39-4.28-.75-8.24-1.06-11.82,0,0,0-.06,0-.09-1.12-12.43-1.81-20.19-1.81-20.19h64.83l0,.2c0,.17.07.48.12.89,0,.11,0,.23,0,.35a.37.37,0,0,1,0,.12c0,.32.08.7.15,1.13.1.86.24,1.91.4,3.16,0,.31.08.63.12,1,.15,1.16.32,2.45.5,3.87,0,.21.06.42.08.62,0,.42.1.84.16,1.28l.54,4.18c.18,1.48.39,3,.6,4.67,0,.15,0,.31.05.47.12.92.25,1.87.37,2.84s.24,1.91.37,2.9c.16,1.24.33,2.53.49,3.85.32,2.44.64,5,1,7.63C167.9,385.49,170.55,406.09,173.19,426.75Z"
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "134.55px 378.115px",
        }}
        id="elbehp7xrtcpi"
        className="animable"
      />
      <path
        d="M115,426.75h-1.06q-2.86-25-5.14-50-.63-6.87-1.24-13.74c-.06-.64-.12-1.26-.16-1.89-.1-1-.18-2-.26-2.94-.14-1.52-.27-3-.4-4.55h0q-.68-7.79-1.32-15.58c0-.17.24-.17.26,0q.7,6.9,1.4,13.82v0c.18,1.67.34,3.34.51,5h0c.15,1.39.29,2.78.43,4.17.06.64.13,1.28.19,1.9q.68,6.84,1.38,13.67,1.67,16.31,3.42,32.6Q113.94,418,115,426.75Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "110.21px 382.336px",
        }}
        id="elr1hfu28vvmt"
        className="animable"
      />
      <path
        d="M151.37,329.47l-2.48,16.34L147,358.58l-.43,2.87,0,.08-1.61,10.62L142.64,387l-.3,1.95-.78,5.19-.06.38-.21,1.39-4.69,30.86H97.35c-1.6-9-3.19-18-4.73-26.67,0-.09,0-.18-.05-.27q-.63-3.56-1.25-7c-.46-2.65-.93-5.26-1.39-7.83,0-.13,0-.26-.06-.38-.32-1.81-.64-3.6-.94-5.36h0c-.4-2.26-.79-4.48-1.18-6.64-.06-.41-.14-.8-.21-1.2-.45-2.61-.9-5.13-1.33-7.56-.09-.5-.18-1-.28-1.52l-5.8-32.81Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "115.75px 378.12px",
        }}
        id="el0yv4hbh72luq"
        className="animable"
      />
      <path
        d="M160.79,329.42s0,.12,0,.25c-.28,1.87-2.15,13.91-5.35,28.29-.24,1.09-.5,2.19-.76,3.31-.76,3.26-1.58,6.61-2.46,10h0a199.44,199.44,0,0,1-6.77,21.33c-.07.21-.16.4-.23.59,0,0-1.3.41-3.67,1.35-.92.36-2,.81-3.25,1.35h0l-1.31.57h0c-2.64,1.19-5.83,2.73-9.47,4.69l-1.39.75s0,.15,0,.44c-.16,2.1-.88,11.56-1.84,24.44H59.67c.1-1,.19-1.94.28-2.9.13-1.27.25-2.55.38-3.82.87-8.89,1.74-17.68,2.58-26.09.29-2.87.56-5.68.84-8.45l.14-1.39.18-1.76c.06-.65.12-1.29.19-1.93.17-1.69.34-3.36.5-5,.08-.83.16-1.64.25-2.44q.08-.8.15-1.56c.18-1.76.35-3.48.52-5.15.06-.56.11-1.12.17-1.66s.08-.9.13-1.33c.08-.8.15-1.57.24-2.34.31-3,.6-5.91.87-8.59,0-.18,0-.36,0-.54,1.4-13.72,2.29-22.39,2.29-22.39Z"
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "110.23px 378.1px",
        }}
        id="elddm03rp9k2d"
        className="animable"
      />
      <path
        d="M76.67,339.42q-.9,11.73-1.79,23.44c0,.47-.06.93-.1,1.4q-.63,8.44-1.28,16.89l-.24,3.12c0,.34-.05.68-.08,1q-.34,4.53-.7,9.07-.66,8.64-1.36,17.27-.6,7.56-1.24,15.12h-.95q1.41-16.2,2.75-32.4l.75-9c0-.36,0-.71.08-1.06.08-1,.17-2,.25-3q.69-8.49,1.37-17l.12-1.38q.94-11.75,1.88-23.47C76.16,339.09,76.69,339.08,76.67,339.42Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "72.8003px 382.949px",
        }}
        id="eltt10s83u6lg"
        className="animable"
      />
      <path
        d="M148.43,391.46a141.26,141.26,0,0,0-22.38,10.42.25.25,0,0,0,.21.46c7.54-3.24,15.22-6.34,22.57-10A.49.49,0,0,0,148.43,391.46Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "137.474px 396.903px",
        }}
        id="el2ap9lyglori"
        className="animable"
      />
      <path
        d="M150.82,339.74c0-.26-.47-.32-.47,0a249.75,249.75,0,0,1-1.27,25.18c-.35,3.89-3.47,25.34-10.2,23.78-1.13-.27-1.7-1.37-1.88-3.07-.21-2,.56-4.55.89-6.58.75-4.5,1.35-9,1.74-13.54a123,123,0,0,0-.28-25.38.22.22,0,0,0-.43,0c0,11.73-.3,23.43-2,35-.84,5.58-3.66,14,2.18,14.84s9.79-13.19,10.52-17C151.59,362.2,151.67,350.61,150.82,339.74Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "143.416px 364.764px",
        }}
        id="ell7qznt9t0u"
        className="animable"
      />
      <path
        d="M139.06,389.23a36.45,36.45,0,0,0-1.52,4.45,10.26,10.26,0,0,0-.63,3.66.27.27,0,0,0,.47.1,12.76,12.76,0,0,0,1.56-3.56c.52-1.38,1.06-2.74,1.53-4.13A.75.75,0,0,0,139.06,389.23Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "138.712px 393.14px",
        }}
        id="el0b83pmeemnz7"
        className="animable"
      />
      <path
        d="M108.59,346.76a11.8,11.8,0,0,0-.28-2.79.15.15,0,0,0-.28,0,11.27,11.27,0,0,0-.31,2.4c-.09.93-.22,1.85-.32,2.77a40.89,40.89,0,0,1-1,5.61,19.91,19.91,0,0,1-5.14,9.23,26.66,26.66,0,0,1-8.7,5.73c-3.61,1.53-7.42,2.1-11.15,3.2a.14.14,0,0,0,0,.28,32.34,32.34,0,0,0,12.08-2.38,25.82,25.82,0,0,0,9.07-5.79,20.16,20.16,0,0,0,5.29-9.5,28.83,28.83,0,0,0,.72-5.62A23.64,23.64,0,0,0,108.59,346.76Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "94.9513px 358.532px",
        }}
        id="elyrflj7i4i4"
        className="animable"
      />
      <path
        d="M125.2,254.22c18.53,11.67,51.84,28,64.5,29,14.08,1.13,34-36.42,47.41-59.63,2.67-4.62-31.88-27.54-34.47-22.47-6.77,13.26-19.77,42.68-23,43.52-2.66.68-30.21-3.38-45.73-5.84C109.18,234.9,112.16,246,125.2,254.22Z"
        style={{
          fill: "rgb(173, 99, 89)",
          transformOrigin: "176.283px 241.819px",
        }}
        id="elo9yprnztwyb"
        className="animable"
      />
      <path
        d="M229.68,236.59,197.85,210.9c.2-1,1.8-3.47,3-6.73,0,0,1.87-11.11-.15-21.16-1.68-8.45-5.14-20.79-.63-21.87,6.57-1.58,12.82,13.51,15.88,22.39,3.39-3.82,6.67-6.79,9.21-7.82,8.44-3.42,28.5,32.33,24,40.41C244.78,223.92,234.5,235,229.68,236.59Z"
        style={{
          fill: "rgb(173, 99, 89)",
          transformOrigin: "223.826px 198.808px",
        }}
        id="elnm7pkuvpyep"
        className="animable"
      />
      <path
        d="M213.22,183.58c.15,4.73,5.64,1.84,5.64,1.84S212,191.48,214,196.3c2,4.64,8.49.91,9,.65-.36.32-6.55,6.06-4,10.69,2.66,4.81,8.55,0,8.93-.37-.25.42-3.41,5.93-.67,9,4.72,5.28,13.18-8.61,18.8-9.73,0,0,3,9.31,3.12,9.57,0,0,8.32-13.05,6.39-20.55a4.93,4.93,0,0,0-4.9-3.78s3.15-3.92,1.26-7.62c-1-1.9-4.89-2-4.89-2s2.39-3.24.49-6.43c-1.5-2.55-5.19-2.28-5.19-2.28s.86-4.17-1.53-6.28C236,162.88,212.9,173.45,213.22,183.58Z"
        style={{
          fill: "rgb(173, 99, 89)",
          transformOrigin: "234.539px 191.826px",
        }}
        id="elh3a4gp1awbn"
        className="animable"
      />
      <path
        d="M241.72,173.38a.07.07,0,0,0,0-.13c-8.44,1.62-17.22,6-23.14,12.29-.2.21.06.62.31.43A90.41,90.41,0,0,1,241.72,173.38Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "230.136px 179.634px",
        }}
        id="eln4io0envia9"
        className="animable"
      />
      <path
        d="M247.1,182c.09,0,0-.19-.07-.17-8.69,1.72-18.44,6.91-24.41,15-.2.28-.11.73.15.43C227.15,192.22,239.37,184.81,247.1,182Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "234.824px 189.594px",
        }}
        id="el24nsf6ypjty"
        className="animable"
      />
      <path
        d="M227.68,208c6-7.52,13.85-12.34,22.6-16.15.11-.05,0-.2-.08-.19-4.78.7-10.11,3.7-14.06,6.39a25.42,25.42,0,0,0-8.73,9.74C227.33,207.93,227.55,208.14,227.68,208Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "238.86px 199.853px",
        }}
        id="el2o92u6say6l"
        className="animable"
      />
      <path
        d="M218.7,185.4c-.23.25.39.31.16.57-.94,1.07-6.08,8-4.26,10.52,1.47,2,5.17,1.4,6.5.61l3.34-2-2.46,3a15.71,15.71,0,0,0-2.59,4.44,5.64,5.64,0,0,0,0,4.64,3.27,3.27,0,0,0,3.66,1.82,9.85,9.85,0,0,0,4.33-2.34l3.48-3-2.29,4a15.1,15.1,0,0,0-1.48,3.51,6.15,6.15,0,0,0-.05,3.55,2.91,2.91,0,0,0,2.36,2,6.37,6.37,0,0,0,3.46-1,50.44,50.44,0,0,0,6.41-4.74c1.05-.85,2.1-1.7,3.19-2.5a9.54,9.54,0,0,1,3.58-1.87,10.36,10.36,0,0,0-3.35,2.16c-1,.87-2,1.79-3,2.72a43.4,43.4,0,0,1-6.29,5.19A7.66,7.66,0,0,1,229.3,218a4.16,4.16,0,0,1-3.6-2.78,7.62,7.62,0,0,1,0-4.41,16.12,16.12,0,0,1,1.59-3.93l1.18,1a11.21,11.21,0,0,1-5.08,2.81,4.73,4.73,0,0,1-3.16-.41A5.35,5.35,0,0,1,218,208a7.17,7.17,0,0,1,0-5.88,17.07,17.07,0,0,1,2.93-4.84l.89,1c-1.72.94-5.78,2.05-8.45-.75C210.45,193.36,217.35,186.55,218.7,185.4Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "229.348px 201.7px",
        }}
        id="el3m6jht2bsn"
        className="animable"
      />
      <path
        d="M218.86,185.42a9.69,9.69,0,0,1-2.88.4,2.21,2.21,0,0,1-1.93-1.11,4.55,4.55,0,0,1-.23-2.54c.14-.94.34-1.92.58-2.93a7.4,7.4,0,0,0-1.58,2.7,4.39,4.39,0,0,0,.06,3.39,3.21,3.21,0,0,0,1.37,1.29,3.37,3.37,0,0,0,1.78.23A5.12,5.12,0,0,0,218.86,185.42Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "215.684px 183.062px",
        }}
        id="el05dtvnjtcf8d"
        className="animable"
      />
      <path
        d="M162.64,240.27l-9.78,34s-23.51-11.92-33.64-22c-7.17-7.16-11.44-16.44,12.11-15.61S162.64,240.27,162.64,240.27Z"
        style={{
          fill: "#213E60",
          transformOrigin: "138.1px 255.439px",
        }}
        id="ely9m4e5acg6j"
        className="animable"
      />
      <path
        d="M134.57,259.77a24.59,24.59,0,0,0-2.38,2.51l.5.33a22.41,22.41,0,0,0,2.61-2,19.25,19.25,0,0,0,3.14-3.58A19.24,19.24,0,0,0,134.57,259.77ZM117.4,238.11c-.37.15-.7.31-1,.47a17.43,17.43,0,0,0,3.19,2.72A17.44,17.44,0,0,0,117.4,238.11Zm35.18,34a8.56,8.56,0,0,0,.83.23l.12-.4C153.22,272,152.9,272,152.58,272.11Zm-1.69-34a19.66,19.66,0,0,0-.78,4.69,18.54,18.54,0,0,0,.31,4.75,18.41,18.41,0,0,0,.78-4.69A18.62,18.62,0,0,0,150.89,238.08Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "134.965px 255.21px",
        }}
        id="elo3bfupvio7p"
        className="animable"
      />
      <path
        d="M147.7,268.3a54.47,54.47,0,0,1,1.62-6.67c.6-2.2,1.25-4.39,1.9-6.58s1.32-4.41,2-6.6,1.58-4.44,2.37-6.66c0-.13.27-.07.23.06-.55,2.22-1,4.46-1.63,6.67s-1.26,4.39-1.91,6.58-1.32,4.41-2,6.59a55.51,55.51,0,0,1-2.38,6.66A.1.1,0,0,1,147.7,268.3Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "151.76px 255.073px",
        }}
        id="el45mkrnygl6a"
        className="animable"
      />
      <g id="elk424f7vvi6">
        <path
          d="M157,260l-4.12,14.32s-23.51-11.93-33.64-22c-5.12-5.11-8.76-11.29-1.87-14.12Z"
          style={{
            opacity: 0.1,
            transformOrigin: "135.288px 256.26px",
          }}
          className="animable"
          id="eltn6lkotsbt"
        />
      </g>
      <path
        d="M167.21,357l-106.5,6.36S72.23,275.07,107,237.89c4.3-4.59,15.13-5,22.2-1.86C148.3,244.57,167.45,356.64,167.21,357Z"
        style={{
          fill: "#213E60",
          transformOrigin: "113.961px 298.679px",
        }}
        id="elj0w9cken0e9"
        className="animable"
      />
      <path
        d="M117.64,299.26a18.24,18.24,0,0,0-3.15,3.57,20.53,20.53,0,0,0,7-6.34A19.29,19.29,0,0,0,117.64,299.26Zm-3.15,60.85-.06.05,1.68-.1a16.53,16.53,0,0,0,2.25-2.71A19.24,19.24,0,0,0,114.49,360.11Zm20.08-100.34a19.67,19.67,0,0,0-3.15,3.58,19,19,0,0,0,3.88-2.76,19.25,19.25,0,0,0,3.14-3.58A19.24,19.24,0,0,0,134.57,259.77ZM70.33,334.32a19,19,0,0,0-3.15,3.58,18.37,18.37,0,0,0,3.87-2.77,18,18,0,0,0,3.15-3.57A18,18,0,0,0,70.33,334.32Zm2.07,25.3a18.93,18.93,0,0,0-3.58-3.14,19.24,19.24,0,0,0,2.77,3.88,23.2,23.2,0,0,0,2.32,2.22l.71,0A21,21,0,0,0,72.4,359.62Zm55.18-25.06a19,19,0,0,0-3.58-3.14,19.29,19.29,0,0,0,2.77,3.87,18,18,0,0,0,3.58,3.15A18.7,18.7,0,0,0,127.58,334.56Zm-38.94-41a19.16,19.16,0,0,0-3.56-3.14,18.86,18.86,0,0,0,2.76,3.87,18.63,18.63,0,0,0,3.58,3.14A18.57,18.57,0,0,0,88.64,293.58Zm28.17-56.16a19.79,19.79,0,0,0-3.18-2.87l-.23,0a20.59,20.59,0,0,0,2.6,3.56,18.63,18.63,0,0,0,3.58,3.14A19.35,19.35,0,0,0,116.81,237.42ZM156.92,340a19,19,0,0,0-4.75.3,18.07,18.07,0,0,0,4.69.79,18.6,18.6,0,0,0,4.75-.31A19.09,19.09,0,0,0,156.92,340Zm-58.27,5.53a19.07,19.07,0,0,0-4.75.29,18.28,18.28,0,0,0,4.7.79,18.56,18.56,0,0,0,4.75-.3A18.12,18.12,0,0,0,98.65,345.55ZM146,317.08a19,19,0,0,0-4.75.3,18.14,18.14,0,0,0,4.69.79,18.6,18.6,0,0,0,4.75-.31A19,19,0,0,0,146,317.08ZM114.6,273.4a18.57,18.57,0,0,0-4.75.31,18.56,18.56,0,0,0,4.69.78,19,19,0,0,0,4.75-.3A19.43,19.43,0,0,0,114.6,273.4Zm30.53,81a17.13,17.13,0,0,0-.73,4l1-.06A16.65,16.65,0,0,0,145.13,354.41Zm-3.8-69.23a18.41,18.41,0,0,0-.78,4.69,18.07,18.07,0,0,0,.3,4.74,20.89,20.89,0,0,0,.48-9.43Zm-41.05,31.54a19.09,19.09,0,0,0-.78,4.69,18.67,18.67,0,0,0,.31,4.76,19.09,19.09,0,0,0,.78-4.7A18.6,18.6,0,0,0,100.28,316.72Zm-2.35-62a18.63,18.63,0,0,0-.78,4.69,19,19,0,0,0,.3,4.75,18.42,18.42,0,0,0,.79-4.69A18.62,18.62,0,0,0,97.93,254.74Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "114.395px 298.555px",
        }}
        id="eljp2oz7s7rv9"
        className="animable"
      />
      <path
        d="M129.8,258c-6.08.75-15.26-9.44-18.47-17.23-.22-.53,1.14-5.75,2.49-12.18.81-3.9,1.61-8.26,2.05-12.29.09-.83,24.63,8.94,24.63,8.94s-3.42,8.18-4.16,15.22a9.34,9.34,0,0,0,0,1.67c0,.08,0,.17,0,.28C136.5,245.6,135.68,257.27,129.8,258Z"
        style={{
          fill: "rgb(173, 99, 89)",
          transformOrigin: "125.903px 237.145px",
        }}
        id="eltwesyd1l1zr"
        className="animable"
      />
      <path
        d="M115,222.41c7.6,14.59,19.16,14.83,21.85,14.67a71.27,71.27,0,0,1,3.65-11.85s-24.54-9.77-24.62-8.94C115.65,218.28,115.34,220.36,115,222.41Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "127.75px 226.672px",
        }}
        id="elozbbav22teo"
        className="animable"
      />
      <path
        d="M106,188c-1.75,9.27,5.83,34.67,12.85,39.75,10.17,7.36,25.4,6.5,31.3-5.4,5.72-11.54-4.75-44.47-12.46-48.93C126.34,166.8,108.58,174.27,106,188Z"
        style={{
          fill: "rgb(173, 99, 89)",
          transformOrigin: "128.768px 201.72px",
        }}
        id="el0r2jn8cql0pa"
        className="animable"
      />
      <path
        d="M128.68,198.23a22,22,0,0,0,2-1.17,3.84,3.84,0,0,0,1.86-1.6,1.23,1.23,0,0,0-.45-1.42,3,3,0,0,0-3.06.25,4.45,4.45,0,0,0-2.17,2.35A1.3,1.3,0,0,0,128.68,198.23Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "129.699px 196.054px",
        }}
        id="el2w66e94fc9"
        className="animable"
      />
      <path
        d="M145.76,194a23.4,23.4,0,0,1-2.37,0,3.86,3.86,0,0,1-2.41-.48,1.21,1.21,0,0,1-.29-1.46,3,3,0,0,1,2.78-1.28,4.42,4.42,0,0,1,3,1A1.3,1.3,0,0,1,145.76,194Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "143.714px 192.398px",
        }}
        id="el1oig2mudb4r"
        className="animable"
      />
      <path
        d="M136.29,220.34A2.76,2.76,0,0,0,138,221a4.73,4.73,0,0,0,1.75-.91.06.06,0,0,1,.1.07,2.39,2.39,0,0,1-2,1.49,1.89,1.89,0,0,1-1.75-1.18C136.09,220.36,136.21,220.29,136.29,220.34Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "137.98px 220.857px",
        }}
        id="ellpkmjuhcl9"
        className="animable"
      />
      <path
        d="M135.59,212.64a6.08,6.08,0,0,0,4.6,1.63,7.22,7.22,0,0,0,2.14-.44,1.64,1.64,0,0,0,.39-.14,3,3,0,0,0,.37-.16.45.45,0,0,0,.25-.47v0a1.22,1.22,0,0,0-.07-.17h0l0-.15c-.3-1.34-.94-3.34-.94-3.34.55.12,3.31.62,3.1-.07-1.79-5.68-3.79-12-6.77-17.27a.17.17,0,0,0-.31.12c1.51,5.53,4,10.75,5.58,16.28a10.63,10.63,0,0,0-3-.14c-.18.1,1.3,3.83,1.39,4.44v.07c-2.17.85-4,.6-6.58-.36C135.56,212.37,135.45,212.52,135.59,212.64Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "140.484px 203.135px",
        }}
        id="el64kork68cep"
        className="animable"
      />
      <path
        d="M142.11,213.61a7.2,7.2,0,0,1-2.25,2.87,3.32,3.32,0,0,1-1.89.6c-1.47,0-1.82-1.28-1.84-2.43a7.69,7.69,0,0,1,.2-1.81A9.35,9.35,0,0,0,142.11,213.61Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "139.12px 214.96px",
        }}
        id="el3pu1ypp0ezu"
        className="animable"
      />
      <path
        d="M139.86,216.48a3.32,3.32,0,0,1-1.89.6c-1.47,0-1.82-1.28-1.84-2.43A3.36,3.36,0,0,1,139.86,216.48Z"
        style={{
          fill: "rgb(255, 154, 187)",
          transformOrigin: "137.995px 215.828px",
        }}
        id="ela0e4osnkozi"
        className="animable"
      />
      <path
        d="M146.9,198.49a2.53,2.53,0,0,0-.86-1.06,1.86,1.86,0,0,0-1.46-.23,1.7,1.7,0,0,0-1.11,1,3,3,0,0,0-.15,1.34,5.66,5.66,0,0,0,.16.8,3.56,3.56,0,0,0,.77,1.48,5.74,5.74,0,0,1-.25-1.19,7,7,0,0,1-.05-1.11c0-.75.29-1.43.85-1.54s1.14.18,1.55.82a11.71,11.71,0,0,1,1,2.1A5.17,5.17,0,0,0,146.9,198.49Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "145.329px 199.481px",
        }}
        id="el3dcdfh33fgo"
        className="animable"
      />
      <path
        d="M130.7,203a2.61,2.61,0,0,1,.35-1.32,1.87,1.87,0,0,1,1.24-.82,1.66,1.66,0,0,1,1.43.47,3,3,0,0,1,.69,1.15,5.62,5.62,0,0,1,.18.79,3.61,3.61,0,0,1-.09,1.67,5.26,5.26,0,0,0-.26-1.19,7.78,7.78,0,0,0-.42-1c-.34-.67-.85-1.19-1.41-1.06s-.95.64-1.07,1.39a11.28,11.28,0,0,0-.07,2.34A5.27,5.27,0,0,1,130.7,203Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "132.674px 203.13px",
        }}
        id="el54f9gvog74i"
        className="animable"
      />
      <path
        d="M131.54,207.54a10.15,10.15,0,0,1,3.6,2.92,7.72,7.72,0,0,1,1.62,4.48,7.9,7.9,0,0,1-1.34,4.58,7.22,7.22,0,0,1-3.7,2.85,10.73,10.73,0,0,0,3-3.3,8.45,8.45,0,0,0,1.16-4.12,7.67,7.67,0,0,0-1.24-4.12A12.33,12.33,0,0,0,131.54,207.54Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "134.151px 214.955px",
        }}
        id="elb54rfz83cic"
        className="animable"
      />
      <path
        d="M106.89,212.57c7.17-.85,9.26-10,6.31-16.45,0,0,19.28-1.08,17.31-16.35A15.1,15.1,0,0,0,144,184.23l3.16,5.16c1.82-.92,2.83-6.8-2.71-10.2,0,0-1.75-7.46-8.16-10.92a10.45,10.45,0,0,0-11.35.55,15.85,15.85,0,0,0-11.87-.64c-6.76,2.2-8.41,9.06-8.41,9.06s-9,3.55-9.31,10.47a14,14,0,0,0,3.94,10.7s-1.85,3.05.41,8.47C101.19,210.36,104.74,212.82,106.89,212.57Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "121.961px 189.721px",
        }}
        id="elo5rs4c4twqf"
        className="animable"
      />
      <path
        d="M129.84,178.51a17.94,17.94,0,0,1,.75,3.68,15.18,15.18,0,0,1,0,3.69,9.68,9.68,0,0,1-3.32,6.25c-1.79,1.69-4.25,2.37-6.6,3.06-1.23.19-2.45.48-3.7.6s-2.5.19-3.76.33c1.26.06,2.53.07,3.8.11s2.52-.25,3.79-.37c2.47-.58,5-1.28,7-3.06a10.12,10.12,0,0,0,3.43-6.84A15.28,15.28,0,0,0,129.84,178.51Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "122.237px 187.372px",
        }}
        id="elrrcjsw0fjhb"
        className="animable"
      />
      <path
        d="M104.69,177.24a17.66,17.66,0,0,0-6.64,2.82A10.58,10.58,0,0,0,93.72,186a11.56,11.56,0,0,0-.22,3.7,10.62,10.62,0,0,0,.87,3.59,9.85,9.85,0,0,0,4.95,5.17A10.88,10.88,0,0,1,95,193a12.13,12.13,0,0,1-.42-6.82A8.82,8.82,0,0,1,96,183.08a13.9,13.9,0,0,1,2.43-2.48A22.75,22.75,0,0,1,104.69,177.24Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "99.0652px 187.85px",
        }}
        id="el3260xiuqlfo"
        className="animable"
      />
      <path
        d="M141.19,185.39a19.79,19.79,0,0,1-6.28-2,12.2,12.2,0,0,1-2.64-1.88,14.73,14.73,0,0,1-2.12-2.56,8.17,8.17,0,0,0,1.62,3,9.18,9.18,0,0,0,2.72,2.19,11,11,0,0,0,3.28,1.12A10.08,10.08,0,0,0,141.19,185.39Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "135.67px 182.214px",
        }}
        id="elinb8538qje8"
        className="animable"
      />
      <polygon
        points="125.07 164.09 97.12 184.23 83.37 135.68 125.07 164.09"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "104.22px 159.955px",
        }}
        id="elsawvud9oo7m"
        className="animable"
      />
      <path
        d="M117.38,165.16l.92-2.13-2.12.68-1.35-1.65.31,2.09-2.2,1.32,2.34.38.42,2,1.15-1.88,1.64.52ZM94,157.66l.49-2.08-1.47,1.53-2.39-1,1.13,2.08-1.36,1.58,2.2-.23.58,1.61.4-1.71,2.25-.58Zm16.16-2.3-2.42-.09-1.36-2.9-1.23,2.8-3-.12,2.45,1.59-.85,2.52,2.46-1.46,2.75,1.79-.88-2.91Zm-5.75,16.07-2.71-.85-.15-5.07-2.77,4.17-3.3-1,2.29,2.55-1.72,2.6,3.22-.92,2.58,2.88-.1-3.58Zm-7.29-26.36-.92.94,1.87,3.05-3.66-1.21-2.35,2.39.21-3.1-3.25-1.08,3.37-.75.22-3.31,2,1.33.8,1.31.85-.18Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "103.755px 158.895px",
        }}
        id="ellfryht66dd"
        className="animable"
      />
      <polygon
        points="126.85 164.58 96.88 186.18 95.06 184.24 125.39 161.97 126.85 164.58"
        style={{
          fill: "#213E60",
          transformOrigin: "110.955px 174.075px",
        }}
        id="el5ksdsgvplhq"
        className="animable"
      />
      <polygon
        points="128.31 167.22 99.04 188.31 97.22 186.52 127.08 165.01 128.31 167.22"
        style={{
          fill: "#213E60",
          transformOrigin: "112.765px 176.66px",
        }}
        id="eli193vqd9nm"
        className="animable"
      />
      <polygon
        points="88.32 132.91 84.69 135.2 88.92 134.51 89.05 135.76 84.75 135.93 88.76 137.45 88.25 138.59 84.44 136.59 87.16 139.91 86.14 140.64 83.85 137 84.53 141.24 83.29 141.36 83.12 137.06 81.6 141.07 80.46 140.56 82.47 136.75 79.14 139.47 78.41 138.46 82.05 136.16 77.81 136.85 77.69 135.61 81.99 135.44 77.97 133.92 78.49 132.78 82.29 134.78 79.58 131.46 80.59 130.73 82.89 134.37 82.2 130.13 83.44 130.01 83.61 134.31 85.13 130.29 86.27 130.8 84.27 134.62 87.59 131.9 88.32 132.91"
        style={{
          fill: "#213E60",
          transformOrigin: "83.37px 135.685px",
        }}
        id="el6mugmv0vlza"
        className="animable"
      />
      <path
        d="M115.86,210.19s-6.94-7.6-10.46-5,2.45,14.13,7.12,15.21a4.56,4.56,0,0,0,5.75-3.23Z"
        style={{
          fill: "rgb(173, 99, 89)",
          transformOrigin: "111.304px 212.624px",
        }}
        id="el79n2646eq4s"
        className="animable"
      />
      <path
        d="M107.2,208.43a.06.06,0,0,0,0,.12c3.29.86,5.31,3.55,6.85,6.4-1.08-1-2.43-1.51-3.83-.2-.08.07,0,.19.1.16a2.82,2.82,0,0,1,3.2.57,14.24,14.24,0,0,1,1.79,2.29c.18.26.67,0,.52-.26a.43.43,0,0,0,0-.07C115.34,213.45,111.52,208.28,107.2,208.43Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "111.499px 213.152px",
        }}
        id="eljdtujx3olqc"
        className="animable"
      />
      <polygon
        points="191.02 204.07 192.08 214.82 136.83 218.47 136.13 211.31 191.02 204.07"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "164.105px 211.27px",
        }}
        id="els2h7cbymrq"
        className="animable"
      />
      <polygon
        points="169.28 206.94 170.2 216.26 192.08 214.82 202.43 242.07 207.38 240.3 196.64 216.28 215.83 240.45 222.64 234.58 202.95 215.28 232.99 230.94 234.96 224.15 209.46 212.84 230.69 215.76 230.54 208.51 206.12 208.52 237.77 200.17 235.99 192.88 198.9 207.32 226.89 191.44 222.8 185.89 201.13 202.49 217.01 179.91 211.63 176.6 196.58 201.37 201.18 181.17 194.47 180.18 191.02 204.07 169.28 206.94"
        style={{
          fill: "#213E60",
          transformOrigin: "203.525px 209.335px",
        }}
        id="elf18dkapsabm"
        className="animable"
      />
      <path
        d="M107.33,265.69c21.62,35.93,62.31,71.06,73,59.95,9.76-10.15,21.61-50.61,23.82-67.81.65-5.06-43.4-9.57-44.1-4.16-.84,6.53-1.94,23.21-2.21,23.81-.6,1.29-25.63-18.78-40-28.18C98.4,236.59,99.05,251.93,107.33,265.69Z"
        style={{
          fill: "rgb(173, 99, 89)",
          transformOrigin: "153.004px 286.141px",
        }}
        id="el332l3mw8s6p"
        className="animable"
      />
      <path
        d="M160.5,203.71c4.21-1.81,7.3,1.78,7.3,1.78a9.83,9.83,0,0,1,5.42-3.84c3.93-.88,7,4.88,7,4.88a12.09,12.09,0,0,1,6.36-3.14c3.84-.47,7.81,4.9,7.81,4.9a10.53,10.53,0,0,1,7.33.77c6,3.25,6.55,13.59,7,20.16s-4.43,25.62-5,29.35l-42.13,3.25s-10.4-28.89-9.83-36.69C152.29,218.57,155.78,205.75,160.5,203.71Z"
        style={{
          fill: "rgb(173, 99, 89)",
          transformOrigin: "180.243px 231.689px",
        }}
        id="elcedap90nlwl"
        className="animable"
      />
      <path
        d="M167.15,205.84c-2.19,6.86-2.22,14-2.66,21.11,0,.16.24.17.24,0,.36-7.09,2.12-14,2.75-21.07A.17.17,0,0,0,167.15,205.84Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "165.985px 216.4px",
        }}
        id="elm9hrbwppb9"
        className="animable"
      />
      <path
        d="M179.72,206.71a18.66,18.66,0,0,0-.4,4.89q0,2.61,0,5.22c.07,3.49.22,7,.48,10.44,0,.15.25.18.24,0-.06-3.47-.08-6.94,0-10.41,0-1.74.09-3.47.16-5.21a22.38,22.38,0,0,0,0-4.91A.24.24,0,0,0,179.72,206.71Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "179.816px 216.933px",
        }}
        id="eltqis8868xll"
        className="animable"
      />
      <path
        d="M194.43,208.44a13.1,13.1,0,0,0-.13,4.42c.07,1.59.13,3.18.18,4.76.09,3.18.19,6.35.18,9.52,0,.16.24.18.24,0,0-3.23.11-6.45.11-9.68,0-1.58,0-3.17,0-4.75a12.16,12.16,0,0,0-.4-4.3C194.56,208.36,194.45,208.37,194.43,208.44Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "194.613px 217.823px",
        }}
        id="elds90f4c1qdw"
        className="animable"
      />
      <path
        d="M191.5,304.44c1.24-3.84,2.46-7.68,3.62-11.54s2.33-7.71,3.37-11.6,2.12-7.77,3-11.69,1.66-7.87,2.17-11.84v0l1.85-9.13,1.77-9.15c.29-1.52.56-3,.81-4.58a22.34,22.34,0,0,0,.42-4.59l-.58-9.3,1,9.28a9.81,9.81,0,0,1,0,2.36c-.07.79-.18,1.56-.27,2.33-.21,1.55-.44,3.08-.69,4.62-1,6.15-2.18,12.25-3.37,18.35v0a104.12,104.12,0,0,1-2.2,11.94c-.92,3.94-2,7.83-3.11,11.71s-2.39,7.71-3.67,11.53S193,300.68,191.5,304.44Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "200.251px 262.73px",
        }}
        id="ely6z4sydf6h8"
        className="animable"
      />
      <path
        d="M155.15,242.6l4.77,13.68v.08c-.19,3.34-.4,6.69-.66,10s-.52,6.67-.86,10-.44,6.64-.54,10-.05,6.69,0,10c-.37-3.33-.58-6.68-.68-10a79,79,0,0,1,.3-10.08c.26-3.34.64-6.66,1-10s.73-6.66,1.14-10v.07Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "157.535px 269.48px",
        }}
        id="el17oukzuwwpe"
        className="animable"
      />
      <path
        d="M153.3,275.1a15.54,15.54,0,0,1,2.33,1.1c.37.21.73.41,1.09.64s.72.44,1.11.64a4,4,0,0,1-1.28-.29,9,9,0,0,1-1.17-.56A10,10,0,0,1,153.3,275.1Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "155.565px 276.29px",
        }}
        id="elnghfvo8pk9p"
        className="animable"
      />
      <path
        d="M145.5,266.1l-24,26s-15.66-21.21-20.17-34.79c-3.19-9.61-2.85-19.82,17.83-8.5S145.5,266.1,145.5,266.1Z"
        style={{
          fill: "#213E60",
          transformOrigin: "122.674px 267.965px",
        }}
        id="el4sdx3bem0zi"
        className="animable"
      />
      <path
        d="M114.6,273.4a18.57,18.57,0,0,0-4.75.31,18.56,18.56,0,0,0,4.69.78,19,19,0,0,0,4.75-.3A19.43,19.43,0,0,0,114.6,273.4Zm21.2-14.66c-.42.33-.83.68-1.23,1a19.67,19.67,0,0,0-3.15,3.58,19,19,0,0,0,3.88-2.76c.45-.42.9-.86,1.32-1.31Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "123.235px 266.634px",
        }}
        id="el04aysmu9qodw"
        className="animable"
      />
      <path
        d="M119.57,284.44A53.93,53.93,0,0,1,124,279.2c1.53-1.69,3.09-3.35,4.65-5s3.16-3.35,4.78-5,3.4-3.26,5.1-4.89c.1-.1.27.05.18.16-1.48,1.74-2.91,3.52-4.45,5.23s-3.09,3.35-4.66,5-3.16,3.35-4.77,5a59,59,0,0,1-5.12,4.88A.1.1,0,0,1,119.57,284.44Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "129.143px 274.439px",
        }}
        id="elq39zafaiitc"
        className="animable"
      />
      <path
        d="M132.72,256.74a51.87,51.87,0,0,1,6.88,4c1.1.75,2.17,1.54,3.2,2.37a18.77,18.77,0,0,1,2.9,2.81l.16.2-.16.15c-.64.57-1.26,1.15-1.93,1.69.49-.7,1-1.37,1.54-2.05v.35a36.57,36.57,0,0,0-3.06-2.42l-3.2-2.3C136.9,260,134.77,258.45,132.72,256.74Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "139.29px 262.35px",
        }}
        id="els0gw08poudb"
        className="animable"
      />
      <path
        d="M124.17,289.19c-.81,1.05-1.67,2.05-2.5,3.07l-.17.21-.19-.22c-1.56-1.77-3.08-3.57-4.48-5.47s-2.76-3.82-4-5.81-2.46-4-3.54-6.13a61,61,0,0,1-2.93-6.43c1.18,2,2.32,4.09,3.54,6.09s2.47,4,3.75,5.94,2.59,3.89,3.93,5.81,2.68,3.84,4.12,5.69h-.36C122.27,291,123.2,290.09,124.17,289.19Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "115.265px 280.44px",
        }}
        id="el57gooxbqg5o"
        className="animable"
      />
      <path
        d="M106.58,272.71a10.76,10.76,0,0,1,2.14,1.6,12.55,12.55,0,0,1,1.78,2,6.39,6.39,0,0,1-2.29-1.43A7.07,7.07,0,0,1,106.58,272.71Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "108.54px 274.51px",
        }}
        id="el6qutclxo8nt"
        className="animable"
      />
    </g>
    <g
      id="freepik--Cake--inject-25"
      className="animable"
      style={{
        transformOrigin: "250px 387.7px",
      }}
    >
      <ellipse
        cx={250}
        cy={447.62}
        rx={81.16}
        ry={11.85}
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "250px 447.62px",
        }}
        id="el56jsirftt87"
        className="animable"
      />
      <ellipse
        cx={250}
        cy={446.26}
        rx={63.08}
        ry={9.21}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "250px 446.26px",
        }}
        id="eldzr6mutxhpe"
        className="animable"
      />
      <g id="els1oszoo9ac">
        <rect
          x={271.01}
          y={337.1}
          width={4.86}
          height={28.76}
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "273.44px 351.48px",
            transform: "rotate(10deg)",
          }}
          className="animable"
          id="elohw8lgfjqz"
        />
      </g>
      <path
        d="M276.36,335.59c-5.72-6,2.07-11.79,2.07-11.79S283.77,331.92,276.36,335.59Z"
        style={{
          fill: "#213E60",
          transformOrigin: "277.277px 329.695px",
        }}
        id="elmhuv1clu3i"
        className="animable"
      />
      <g id="el3rb28fjc4v9">
        <path
          d="M276.36,335.59c-5.72-6,2.07-11.79,2.07-11.79S283.77,331.92,276.36,335.59Z"
          style={{
            opacity: 0.2,
            transformOrigin: "277.277px 329.695px",
          }}
          className="animable"
          id="elp6kciiv41gm"
        />
      </g>
      <path
        d="M276.35,335.59c-4-4.16,1.44-8.19,1.44-8.19S281.5,333,276.35,335.59Z"
        style={{
          fill: "#213E60",
          transformOrigin: "276.982px 331.495px",
        }}
        id="eleqkyyb97kmt"
        className="animable"
      />
      <g id="elp09ahhecuu">
        <rect
          x={223.46}
          y={337.1}
          width={4.86}
          height={28.76}
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "225.89px 351.48px",
            transform: "rotate(-10deg)",
          }}
          className="animable"
          id="eldqwyj2fgf1w"
        />
      </g>
      <path
        d="M222.88,335.11c-7.41-3.66-2.08-11.78-2.08-11.78S228.6,329.13,222.88,335.11Z"
        style={{
          fill: "#213E60",
          transformOrigin: "221.961px 329.22px",
        }}
        id="elmu99m31g15"
        className="animable"
      />
      <g id="el8qzfuv21tqx">
        <path
          d="M222.88,335.11c-7.41-3.66-2.08-11.78-2.08-11.78S228.6,329.13,222.88,335.11Z"
          style={{
            opacity: 0.2,
            transformOrigin: "221.961px 329.22px",
          }}
          className="animable"
          id="elddstrthr6db"
        />
      </g>
      <path
        d="M222.92,335.12c-5.15-2.54-1.44-8.18-1.44-8.18S226.89,331,222.92,335.12Z"
        style={{
          fill: "#213E60",
          transformOrigin: "222.281px 331.03px",
        }}
        id="eldzicsl1jjzb"
        className="animable"
      />
      <rect
        x={246.86}
        y={329.35}
        width={4.86}
        height={28.76}
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "249.29px 343.73px",
        }}
        id="elm59b4ivodj"
        className="animable"
      />
      <path
        d="M249.29,327.93c-6.67-4.9,0-12,0-12S256,323,249.29,327.93Z"
        style={{
          fill: "#213E60",
          transformOrigin: "249.299px 321.93px",
        }}
        id="elhdhut56mt8p"
        className="animable"
      />
      <g id="elslenck8yn4s">
        <path
          d="M249.29,327.93c-6.67-4.9,0-12,0-12S256,323,249.29,327.93Z"
          style={{
            opacity: 0.2,
            transformOrigin: "249.299px 321.93px",
          }}
          className="animable"
          id="els8eip4hp5we"
        />
      </g>
      <path
        d="M249.29,328c-4.63-3.4,0-8.31,0-8.31S253.92,324.56,249.29,328Z"
        style={{
          fill: "#213E60",
          transformOrigin: "249.29px 323.845px",
        }}
        id="el86kevvpdxyr"
        className="animable"
      />
      <path
        d="M292.48,375.22c-.26,4.44-.83,9.38-1.42,13.71l-.15,1.1c-.49,3.45-1,6.42-1.29,8.3-.19,1.16-.33,1.91-.36,2.1a.18.18,0,0,0,0,.05H208.37l-.27-2c0-.21-.07-.43-.1-.67-.26-1.9-.63-4.71-1-7.88,0-.28-.07-.56-.1-.85-.56-4.6-1.14-9.84-1.46-14.2h0c-.32-4.57-.38-8.16.18-9,3.71-5.91,75.82-9,85.2-3.41C292.57,363.52,292.84,368.86,292.48,375.22Z"
        style={{
          fill: "#213E60",
          transformOrigin: "248.909px 380.006px",
        }}
        id="elhv97ryrb8ei"
        className="animable"
      />
      <g id="elx3rc5xi2qre">
        <path
          d="M292.48,375.22c-.26,4.44-.83,9.38-1.42,13.71l-.15,1.1c-.49,3.45-1,6.42-1.29,8.3-.19,1.16-.33,1.91-.36,2.1a.18.18,0,0,0,0,.05H208.37l-.27-2c0-.21-.07-.43-.1-.67-.26-1.9-.63-4.71-1-7.88,0-.28-.07-.56-.1-.85-.56-4.6-1.14-9.84-1.46-14.2h0c-.32-4.57-.38-8.16.18-9,3.71-5.91,75.82-9,85.2-3.41C292.57,363.52,292.84,368.86,292.48,375.22Z"
          style={{
            opacity: 0.3,
            transformOrigin: "248.909px 380.006px",
          }}
          className="animable"
          id="elhb2wrd2zrmc"
        />
      </g>
      <path
        d="M206.4,361.82c-2.86,1.31-3.72,4.64-2.3,9.48s2.56,6.22,5.12,6.14,1.36-7.08,4.26-7.81-.68,15,6.23,15.4,4.1-15.53,8.11-16.29,3.24,6.14,8.11,6.82,6.14-10,9.47-10.41,2.3,3.41,6.14,3.93,2.73-4.18,6.4-4.18,1.45,11.77,7.17,12.54,5.12-11.86,7.42-12.12,1.71,7.26,5.55,7.6,4.78-6.92,7.42-7,3.28,9,7,9.3,5.35-11.92,0-14.85C285.76,356.7,237.12,347.83,206.4,361.82Z"
        style={{
          fill: "#213E60",
          transformOrigin: "249.678px 369.622px",
        }}
        id="elnaiw4u903e"
        className="animable"
      />
      <path
        d="M299.3,415.09h0c-.33,4.22-.85,9.05-1.37,13.48,0,.2-.05.41-.07.6-.9,7.43-1.78,13.59-1.78,13.59s-9.3,7.2-45.56,7.2c-32.68,0-45.36-7.2-45.36-7.2s-1.14-6.27-2.17-14c0-.19-.05-.37-.07-.56-.55-4.18-1.06-8.74-1.33-13-.48-7.51-.23-14,1.85-15.2a15.93,15.93,0,0,1,4.66-1.5c16-3.23,60.94-1.8,81.16,1.9,5.46,1,9.12,2.15,9.92,3.43C299.85,404.93,299.75,409.46,299.3,415.09Z"
        style={{
          fill: "#213E60",
          transformOrigin: "250.521px 423.333px",
        }}
        id="elxilygm27rxr"
        className="animable"
      />
      <g id="elgw2evaqmfbp">
        <path
          d="M299.3,415.09h0c-.33,4.22-.85,9.05-1.37,13.48,0,.2-.05.41-.07.6-.9,7.43-1.78,13.59-1.78,13.59s-9.3,7.2-45.56,7.2c-32.68,0-45.36-7.2-45.36-7.2s-1.14-6.27-2.17-14c0-.19-.05-.37-.07-.56-.55-4.18-1.06-8.74-1.33-13-.48-7.51-.23-14,1.85-15.2a15.93,15.93,0,0,1,4.66-1.5c16-3.23,60.94-1.8,81.16,1.9,5.46,1,9.12,2.15,9.92,3.43C299.85,404.93,299.75,409.46,299.3,415.09Z"
          style={{
            opacity: 0.3,
            transformOrigin: "250.521px 423.333px",
          }}
          className="animable"
          id="elo7npybtujdd"
        />
      </g>
      <path
        d="M298.28,401.37c3.22,1.35,4.19,4.8,2.59,9.81s-2.87,6.45-5.75,6.36-1.54-7.33-4.8-8.09.77,15.51-7,15.95-4.6-16.08-9.11-16.87-3.64,6.36-9.11,7.06-6.9-10.33-10.65-10.78-2.58,3.54-6.9,4.07-3.07-4.33-7.19-4.33-1.63,12.19-8.06,13S226.55,405.26,224,405s-1.92,7.51-6.24,7.86-5.37-7.15-8.34-7.24-3.69,9.36-7.84,9.63-6-12.34,0-15.37C209.09,396.07,263.76,386.88,298.28,401.37Z"
        style={{
          fill: "#213E60",
          transformOrigin: "249.685px 409.447px",
        }}
        id="el6fft8xmd63c"
        className="animable"
      />
      <g id="elrknyx6ivya">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "251.533px 407.02px",
          }}
          className="animable"
          id="elbcck016rk28"
        >
          <circle
            cx={288.91}
            cy={434.1}
            r={1.09}
            id="elkorlcbh7obm"
            className="animable"
            style={{
              transformOrigin: "288.91px 434.1px",
            }}
          />
          <path
            d="M211.8,419.1a1.09,1.09,0,1,1-1.09-1.08A1.09,1.09,0,0,1,211.8,419.1Z"
            id="eljk64vlod0t"
            className="animable"
            style={{
              transformOrigin: "210.71px 419.11px",
            }}
          />
          <circle
            cx={293.71}
            cy={433.89}
            r={2.11}
            id="elg91wo7pky"
            className="animable"
            style={{
              transformOrigin: "293.71px 433.89px",
            }}
          />
          <circle
            cx={288.46}
            cy={379.29}
            r={2.11}
            id="elrxsy26xm29"
            className="animable"
            style={{
              transformOrigin: "288.46px 379.29px",
            }}
          />
          <path
            d="M293.71,438.39a1.54,1.54,0,1,1-1.53-1.54A1.53,1.53,0,0,1,293.71,438.39Z"
            id="elo8x796lzty"
            className="animable"
            style={{
              transformOrigin: "292.17px 438.39px",
            }}
          />
          <path
            d="M230.4,377.76a1.54,1.54,0,1,1-1.54-1.54A1.54,1.54,0,0,1,230.4,377.76Z"
            id="elhqz42d5evs"
            className="animable"
            style={{
              transformOrigin: "228.86px 377.76px",
            }}
          />
          <path
            d="M210.32,415.75a1.54,1.54,0,0,1-3.07,0,1.54,1.54,0,1,1,3.07,0Z"
            id="eljcwv63dev8i"
            className="animable"
            style={{
              transformOrigin: "208.785px 415.626px",
            }}
          />
          <path
            d="M286.35,375.64a1.54,1.54,0,1,1-1.53-1.53A1.54,1.54,0,0,1,286.35,375.64Z"
            id="elwzs18de5xab"
            className="animable"
            style={{
              transformOrigin: "284.81px 375.65px",
            }}
          />
        </g>
      </g>
      <path
        d="M297.93,428.57c0,.2-.05.41-.07.6-2.83.88-5.71,1.63-8.6,2.28-4.22.88-8.47,1.54-12.75,2a167.77,167.77,0,0,1-25.75.53l-12.84-.77c-4.29-.23-8.57-.41-12.85-.77s-8.53-1-12.75-1.76c-3.13-.55-6.25-1.18-9.33-1.94,0-.19-.05-.37-.07-.56,3.19.45,6.39.88,9.58,1.32l12.72,1.65c2.11.3,4.23.6,6.35.87l3.19.38,3.19.31c4.26.35,8.55.45,12.83.42s8.54-.2,12.81-.38,8.51-.55,12.76-.94,8.46-.95,12.69-1.58C292,429.77,295,429.2,297.93,428.57Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "250.425px 431.213px",
        }}
        id="els6r4feakm0j"
        className="animable"
      />
      <path
        d="M291.06,388.93l-.15,1.1-2-.28-12.72-1.65c-2.12-.3-4.23-.59-6.36-.86l-3.18-.39-3.2-.31c-4.26-.35-8.55-.45-12.82-.42s-8.55.2-12.82.37-8.51.56-12.75.95-8.47.95-12.69,1.59c-1.8.29-3.59.6-5.38,1,0-.28-.07-.56-.1-.85,1.74-.47,3.49-.91,5.25-1.3,4.22-.89,8.47-1.55,12.75-2a165.42,165.42,0,0,1,25.76-.52l12.83.76c4.29.24,8.58.41,12.85.78s8.53,1,12.76,1.74Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "248.975px 387.557px",
        }}
        id="elzjcpfukuhu"
        className="animable"
      />
    </g>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
  </svg>
);
export default BirthdayWebsiteSVG;
